/*
window.theme=window.theme||{},window.theme=window.theme||{},theme.Sections=function(){this.constructors={},this.instances=[],$(document).on("shopify:section:load",this._onSectionLoad.bind(this)).on("shopify:section:unload",this._onSectionUnload.bind(this)).on("shopify:section:select",this._onSelect.bind(this)).on("shopify:section:deselect",this._onDeselect.bind(this)).on("shopify:block:select",this._onBlockSelect.bind(this)).on("shopify:block:deselect",this._onBlockDeselect.bind(this))},theme.Sections.prototype=_.assignIn({},theme.Sections.prototype,{_createInstance:function(e,t){var i,s=$(e),a=s.attr("data-section-id"),r=s.attr("data-section-type");t=t||this.constructors[r],_.isUndefined(t)||(i=_.assignIn(new t(e),{id:a,type:r,container:e}),this.instances.push(i))},_onSectionLoad:function(e){var t=$("[data-section-id]",e.target)[0];t&&this._createInstance(t)},_onSectionUnload:function(i){this.instances=_.filter(this.instances,function(e){var t=e.id===i.detail.sectionId;return t&&_.isFunction(e.onUnload)&&e.onUnload(i),!t})},_onSelect:function(t){var e=_.find(this.instances,function(e){return e.id===t.detail.sectionId});!_.isUndefined(e)&&_.isFunction(e.onSelect)&&e.onSelect(t)},_onDeselect:function(t){var e=_.find(this.instances,function(e){return e.id===t.detail.sectionId});!_.isUndefined(e)&&_.isFunction(e.onDeselect)&&e.onDeselect(t)},_onBlockSelect:function(t){var e=_.find(this.instances,function(e){return e.id===t.detail.sectionId});!_.isUndefined(e)&&_.isFunction(e.onBlockSelect)&&e.onBlockSelect(t)},_onBlockDeselect:function(t){var e=_.find(this.instances,function(e){return e.id===t.detail.sectionId});!_.isUndefined(e)&&_.isFunction(e.onBlockDeselect)&&e.onBlockDeselect(t)},register:function(e,i){this.constructors[e]=i,$("[data-section-type="+e+"]").each(function(e,t){this._createInstance(t,i)}.bind(this))}}),window.slate=window.slate||{},slate.utils={getParameterByName:function(e,t){t=t||window.location.href,e=e.replace(/[[\]]/g,"\\$&");var i=new RegExp("[?&]"+e+"(=([^&#]*)|&|#|$)").exec(t);return i?i[2]?decodeURIComponent(i[2].replace(/\+/g," ")):"":null},resizeSelects:function(e){e.each(function(){var e=$(this),t=e.find("option:selected").text(),i=$("<span>").html(t);i.appendTo("body");var s=i.width();i.remove(),e.width(s+10)})},keyboardKeys:{TAB:9,ENTER:13,ESCAPE:27,LEFTARROW:37,RIGHTARROW:39}},window.slate=window.slate||{},slate.rte={wrapTable:function(e){e.$tables.wrap('<div class="'+e.tableWrapperClass+'"></div>')},wrapIframe:function(e){e.$iframes.each(function(){$(this).wrap('<div class="'+e.iframeWrapperClass+'"></div>'),this.src})}},window.slate=window.slate||{},slate.a11y={pageLinkFocus:function(e){var t="js-focus-hidden";e.first().attr("tabIndex","-1").focus().addClass(t).one("blur",function(){e.first().removeClass(t).removeAttr("tabindex")})},focusHash:function(){var e=window.location.hash;e&&document.getElementById(e.slice(1))&&this.pageLinkFocus($(e))},bindInPageLinks:function(){$("a[href*=#]").on("click",function(e){this.pageLinkFocus($(e.currentTarget.hash))}.bind(this))},trapFocus:function(e){var t={focusin:e.namespace?"focusin."+e.namespace:"focusin",focusout:e.namespace?"focusout."+e.namespace:"focusout",keydown:e.namespace?"keydown."+e.namespace:"keydown.handleFocus"},i=e.$container.find($('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(":visible")),s=i[0],a=i[i.length-1];e.$elementToFocus||(e.$elementToFocus=e.$container),e.$container.attr("tabindex","-1"),e.$elementToFocus.focus(),$(document).off("focusin"),$(document).on(t.focusout,function(){$(document).off(t.keydown)}),$(document).on(t.focusin,function(e){e.target!==a&&e.target!==s||$(document).on(t.keydown,function(e){var t;(t=e).keyCode===slate.utils.keyboardKeys.TAB&&(t.target!==a||t.shiftKey||(t.preventDefault(),s.focus()),t.target===s&&t.shiftKey&&(t.preventDefault(),a.focus()))})})},removeTrapFocus:function(e){var t=e.namespace?"focusin."+e.namespace:"focusin";e.$container&&e.$container.length&&e.$container.removeAttr("tabindex"),$(document).off(t)},accessibleLinks:function(e){var r=document.querySelector("body"),o={newWindow:"a11y-new-window-message",external:"a11y-external-message",newWindowExternal:"a11y-new-window-external-message"};void 0!==e.$links&&e.$links.jquery||(e.$links=$("a[href]:not([aria-describedby])")),$.each(e.$links,function(){var e,t,i=$(this),s=i.attr("target"),a=i.attr("rel"),r=(e=i,t=window.location.hostname,e[0].hostname!==t),n="_blank"===s;r&&i.attr("aria-describedby",o.external),n&&(void 0!==a&&-1!==a.indexOf("noopener")||i.attr("rel",function(e,t){return(void 0===t?"":t+" ")+"noopener"}),i.attr("aria-describedby",o.newWindow)),r&&n&&i.attr("aria-describedby",o.newWindowExternal)}),function(e){"object"!=typeof e&&(e={});var t=$.extend({newWindow:"Opens in a new window.",external:"Opens external website.",newWindowExternal:"Opens external website in a new window."},e),i=document.createElement("ul"),s="";for(var a in t)s+="<li id="+o[a]+">"+t[a]+"</li>";i.setAttribute("hidden",!0),i.innerHTML=s,r.appendChild(i)}(e.messages)}},theme.Images={preload:function(e,t){"string"==typeof e&&(e=[e]);for(var i=0;i<e.length;i++){var s=e[i];this.loadImage(this.getSizedImageUrl(s,t))}},loadImage:function(e){(new Image).src=e},switchImage:function(e,t,i){var s=this.imageSize(t.src),a=this.getSizedImageUrl(e.src,s);i?i(a,e,t):t.src=a},imageSize:function(e){var t=e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);return null!==t?void 0!==t[2]?t[1]+t[2]:t[1]:null},getSizedImageUrl:function(e,t){if(null===t)return e;if("master"===t)return this.removeProtocol(e);var i=e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null===i)return null;var s=e.split(i[0]),a=i[0];return this.removeProtocol(s[0]+"_"+t+a)},removeProtocol:function(e){return e.replace(/http(s)?:/,"")}},theme.Currency={formatMoney:function(e,t){"string"==typeof e&&(e=e.replace(".",""));var i="",s=/\{\{\s*(\w+)\s*\}\}/,a=t||"${{amount}}";function r(e,t,i,s){if(i=i||",",s=s||".",isNaN(e)||null===e)return 0;var a=(e=(e/100).toFixed(t)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i)+(a[1]?s+a[1]:"")}switch(a.match(s)[1]){case"amount":i=r(e,2);break;case"amount_no_decimals":i=r(e,0);break;case"amount_with_comma_separator":i=r(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":i=r(e,0,".",",");break;case"amount_no_decimals_with_space_separator":i=r(e,0," ");break;case"amount_with_apostrophe_separator":i=r(e,2,"'")}return a.replace(s,i)}},slate.Variants=function(){function e(e){this.$container=e.$container,this.product=e.product,this.singleOptionSelector=e.singleOptionSelector,this.originalSelectorId=e.originalSelectorId,this.enableHistoryState=e.enableHistoryState,this.currentVariant=this._getVariantFromOptions(),$(this.singleOptionSelector,this.$container).on("change",this._onSelectChange.bind(this))}return e.prototype=_.assignIn({},e.prototype,{_getCurrentOptions:function(){var e=_.map($(this.singleOptionSelector,this.$container),function(e){var t=$(e),i=t.attr("type"),s={};return("radio"!==i&&"checkbox"!==i||!!t[0].checked)&&(s.value=t.val(),s.index=t.data("index"),s)});return e=_.compact(e)},_getVariantFromOptions:function(){var e=this._getCurrentOptions(),t=this.product.variants;return _.find(t,function(t){return e.every(function(e){return _.isEqual(t[e.index],e.value)})})},_onSelectChange:function(){var e=this._getVariantFromOptions();this.$container.trigger({type:"variantChange",variant:e}),e&&(this._updateMasterSelect(e),this._updateImages(e),this._updatePrice(e),this._updateSKU(e),this.currentVariant=e,this.enableHistoryState&&this._updateHistoryState(e))},_updateImages:function(e){var t=e.featured_image||{},i=this.currentVariant.featured_image||{};e.featured_image&&t.src!==i.src&&this.$container.trigger({type:"variantImageChange",variant:e})},_updatePrice:function(e){e.price===this.currentVariant.price&&e.compare_at_price===this.currentVariant.compare_at_price||this.$container.trigger({type:"variantPriceChange",variant:e})},_updateSKU:function(e){e.sku!==this.currentVariant.sku&&this.$container.trigger({type:"variantSKUChange",variant:e})},_updateHistoryState:function(e){var t;history.replaceState&&e&&(t=window.location.protocol+"//"+window.location.host+window.location.pathname+"?variant="+e.id,window.history.replaceState({path:t},"",t))},_updateMasterSelect:function(e){$(this.originalSelectorId,this.$container).val(e.id)}}),e}(),this.Shopify=this.Shopify||{},this.Shopify.theme=this.Shopify.theme||{},this.Shopify.theme.PredictiveSearch=function(){"use strict";function d(){var e=Error.call(this);return e.name="Server error",e.message="Something went wrong on the server",e.status=500,e}function u(e){var t=Error.call(this);return t.name="Not found",t.message="Not found",t.status=e,t}function h(){var e=Error.call(this);return e.name="Server error",e.message="Something went wrong on the server",e.status=500,e}function p(e){var t=Error.call(this);return t.name="Content-Type error",t.message="Content-Type was not provided or is of wrong type",t.status=e,t}function m(e){var t=Error.call(this);return t.name="JSON parse error",t.message="JSON syntax error",t.status=e,t}function f(e,t,i,s){var a=Error.call(this);return a.name=t,a.message=i,a.status=e,a.retryAfter=s,a}function v(e,t,i){var s=Error.call(this);return s.name=t,s.message=i,s.status=e,s}function g(e,t,i){var s=Error.call(this);return s.name=t,s.message=i,s.status=e,s}function t(e){this._store={},this._keys=[],e&&e.bucketSize?this.bucketSize=e.bucketSize:this.bucketSize=20}function i(){this.events={}}function s(e){this.eventName=e,this.callbacks=[]}function n(s,a){var r="";return a=a||null,Object.keys(s).forEach(function(e){var t,i=a?a+"["+e+"]":e+"=";switch(t=s[e],Object.prototype.toString.call(t).slice(8,-1).toLowerCase()){case"object":r+=n(s[e],a?i:e);break;case"array":r+=i+"="+s[e].join(",")+"&";break;default:a&&(i+="="),r+=i+encodeURIComponent(s[e])+"&"}}),r}t.prototype.set=function(e,t){var i;return this.count()>=this.bucketSize&&(i=this._keys.splice(0,1),this.delete(i)),this._keys.push(e),this._store[e]=t,this._store},t.prototype.get=function(e){return this._store[e]},t.prototype.has=function(e){return Boolean(this._store[e])},t.prototype.count=function(){return Object.keys(this._store).length},t.prototype.delete=function(e){var t=Boolean(this._store[e]);return delete this._store[e],t&&!this._store[e]},i.prototype.on=function(e,t){var i=this.events[e];i||(i=new s(e),this.events[e]=i),i.registerCallback(t)},i.prototype.off=function(e,t){var i=this.events[e];i&&-1<i.callbacks.indexOf(t)&&(i.unregisterCallback(t),0===i.callbacks.length&&delete this.events[e])},i.prototype.dispatch=function(e,t){var i=this.events[e];i&&i.fire(t)},s.prototype.registerCallback=function(e){this.callbacks.push(e)},s.prototype.unregisterCallback=function(e){var t=this.callbacks.indexOf(e);-1<t&&this.callbacks.splice(t,1)},s.prototype.fire=function(t){this.callbacks.slice(0).forEach(function(e){e(t)})};var a,r,o,c=(a=function(e,n,o,c){var l=new XMLHttpRequest;l.onreadystatechange=function(){if(l.readyState===XMLHttpRequest.DONE){var e=l.getResponseHeader("Content-Type");if(500<=l.status)c(new h);else if(404!==l.status)if("string"==typeof e&&null!==e.toLowerCase().match("application/json"))if(417!==l.status)if(422!==l.status)if(429!==l.status)if(200!==l.status)try{var t=JSON.parse(l.responseText);c(new d(l.status,t.message,t.description))}catch(e){c(new m(l.status))}else try{var i=JSON.parse(l.responseText);i.query=n,o(i)}catch(e){c(new m(l.status))}else try{var s=JSON.parse(l.responseText);c(new f(l.status,s.message,s.description,l.getResponseHeader("Retry-After")))}catch(e){c(new m(l.status))}else try{var a=JSON.parse(l.responseText);c(new g(l.status,a.message,a.description))}catch(e){c(new m(l.status))}else try{var r=JSON.parse(l.responseText);c(new v(l.status,r.message,r.description))}catch(e){c(new m(l.status))}else c(new p(l.status));else c(new u(l.status))}},l.open("get","/search/suggest.json?q="+encodeURIComponent(n)+"&"+e),l.setRequestHeader("Content-Type","application/json"),l.send()},r=10,o=null,function(){var e=this,t=arguments;clearTimeout(o),o=setTimeout(function(){o=null,a.apply(e,t)},r||0)});function e(e){if(!e)throw new TypeError("No config object was specified");this._retryAfter=null,this._currentQuery=null,this.dispatcher=new i,this.cache=new t({bucketSize:40}),this.configParams=n(e)}function l(e){return"string"!=typeof e?null:e.trim().replace(" ","-").toLowerCase()}return e.TYPES={PRODUCT:"product",PAGE:"page",ARTICLE:"article"},e.FIELDS={AUTHOR:"author",BODY:"body",PRODUCT_TYPE:"product_type",TAG:"tag",TITLE:"title",VARIANTS_BARCODE:"variants.barcode",VARIANTS_SKU:"variants.sku",VARIANTS_TITLE:"variants.title",VENDOR:"vendor"},e.UNAVAILABLE_PRODUCTS={SHOW:"show",HIDE:"hide",LAST:"last"},e.prototype.query=function(e){try{!function(e){var t;if(null==e)throw(t=new TypeError("'query' is missing")).type="argument",t;if("string"!=typeof e)throw(t=new TypeError("'query' is not a string")).type="argument",t}(e)}catch(e){return void this.dispatcher.dispatch("error",e)}if(""===e)return this;this._currentQuery=l(e);var t=this.cache.get(this._currentQuery);return t?this.dispatcher.dispatch("success",t):c(this.configParams,e,function(e){this.cache.set(l(e.query),e),l(e.query)===this._currentQuery&&(this._retryAfter=null,this.dispatcher.dispatch("success",e))}.bind(this),function(e){e.retryAfter&&(this._retryAfter=e.retryAfter),this.dispatcher.dispatch("error",e)}.bind(this)),this},e.prototype.on=function(e,t){return this.dispatcher.on(e,t),this},e.prototype.off=function(e,t){return this.dispatcher.off(e,t),this},e}(),this.Shopify=this.Shopify||{},this.Shopify.theme=this.Shopify.theme||{},this.Shopify.theme.PredictiveSearchComponent=function(n){"use strict";var o={resources:{type:[(n=n&&n.hasOwnProperty("default")?n.default:n).TYPES.PRODUCT],options:{unavailable_products:n.UNAVAILABLE_PRODUCTS.LAST,fields:[n.FIELDS.TITLE,n.FIELDS.VENDOR,n.FIELDS.PRODUCT_TYPE,n.FIELDS.VARIANTS_TITLE]}}};function e(e){if(!(e&&e.selectors&&e.selectors.input&&c(e.selectors.input)&&e.selectors.result&&c(e.selectors.result)&&e.resultTemplateFct&&l(e.resultTemplateFct)&&e.numberOfResultsTemplateFct&&l(e.numberOfResultsTemplateFct)&&e.loadingResultsMessageTemplateFct&&l(e.loadingResultsMessageTemplateFct))){var t=new TypeError("PredictiveSearchComponent config is not valid");throw t.type="argument",t}var i,s,a,r;this.nodes=(i=e.selectors,{input:document.querySelector(i.input),reset:document.querySelector(i.reset),result:document.querySelector(i.result)}),(s=this.nodes)&&s.input&&s.result&&"INPUT"===s.input.tagName?(this._searchKeyword="",this.resultTemplateFct=e.resultTemplateFct,this.numberOfResultsTemplateFct=e.numberOfResultsTemplateFct,this.loadingResultsMessageTemplateFct=e.loadingResultsMessageTemplateFct,this.numberOfResults=e.numberOfResults||4,this.classes={visibleVariant:e.visibleVariant?e.visibleVariant:"predictive-search-wrapper--visible",itemSelected:e.itemSelectedClass?e.itemSelectedClass:"predictive-search-item--selected",clearButtonVisible:e.clearButtonVisibleClass?e.clearButtonVisibleClass:"predictive-search__clear-button--visible"},this.selectors={searchResult:e.searchResult?e.searchResult:"[data-search-result]"},this.callbacks={onBodyMousedown:(a=e).onBodyMousedown,onBeforeOpen:a.onBeforeOpen,onOpen:a.onOpen,onBeforeClose:a.onBeforeClose,onClose:a.onClose,onInputFocus:a.onInputFocus,onInputKeyup:a.onInputKeyup,onInputBlur:a.onInputBlur,onInputReset:a.onInputReset,onBeforeDestroy:a.onBeforeDestroy,onDestroy:a.onDestroy},(r=this.nodes.input).setAttribute("autocorrect","off"),r.setAttribute("autocomplete","off"),r.setAttribute("autocapitalize","off"),r.setAttribute("spellcheck","false"),this._addInputEventListeners(),this._addBodyEventListener(),this._addAccessibilityAnnouncer(),this._toggleClearButtonVisibility(),this.predictiveSearch=new n(e.PredictiveSearchAPIConfig?e.PredictiveSearchAPIConfig:o),this.predictiveSearch.on("success",this._handlePredictiveSearchSuccess.bind(this)),this.predictiveSearch.on("error",this._handlePredictiveSearchError.bind(this))):console.warn("Could not find valid nodes")}function t(e){return Object.prototype.toString.call(e)}function c(e){return"[object String]"===t(e)}function i(e){return"[object Boolean]"===t(e)}function l(e){return"[object Function]"===t(e)}return e.prototype.isResultVisible=!1,e.prototype.results={},e.prototype._latencyTimer=null,e.prototype._resultNodeClicked=!1,e.prototype._addInputEventListeners=function(){var e=this.nodes.input,t=this.nodes.reset;e&&(this._handleInputFocus=this._handleInputFocus.bind(this),this._handleInputBlur=this._handleInputBlur.bind(this),this._handleInputKeyup=this._handleInputKeyup.bind(this),this._handleInputKeydown=this._handleInputKeydown.bind(this),e.addEventListener("focus",this._handleInputFocus),e.addEventListener("blur",this._handleInputBlur),e.addEventListener("keyup",this._handleInputKeyup),e.addEventListener("keydown",this._handleInputKeydown),t&&(this._handleInputReset=this._handleInputReset.bind(this),t.addEventListener("click",this._handleInputReset)))},e.prototype._removeInputEventListeners=function(){var e=this.nodes.input;e.removeEventListener("focus",this._handleInputFocus),e.removeEventListener("blur",this._handleInputBlur),e.removeEventListener("keyup",this._handleInputKeyup),e.removeEventListener("keydown",this._handleInputKeydown)},e.prototype._addBodyEventListener=function(){this._handleBodyMousedown=this._handleBodyMousedown.bind(this),document.querySelector("body").addEventListener("mousedown",this._handleBodyMousedown)},e.prototype._removeBodyEventListener=function(){document.querySelector("body").removeEventListener("mousedown",this._handleBodyMousedown)},e.prototype._removeClearButtonEventListener=function(){var e=this.nodes.reset;e&&e.removeEventListener("click",this._handleInputReset)},e.prototype._handleBodyMousedown=function(e){var t;this.isResultVisible&&null!==this.nodes&&(e.target.isEqualNode(this.nodes.input)||this.nodes.input.contains(e.target)||e.target.isEqualNode(this.nodes.result)||this.nodes.result.contains(e.target)?this._resultNodeClicked=!0:(!l(this.callbacks.onBodyMousedown)||i(t=this.callbacks.onBodyMousedown(this.nodes))&&t)&&this.close())},e.prototype._handleInputFocus=function(e){if(l(this.callbacks.onInputFocus)){var t=this.callbacks.onInputFocus(this.nodes);if(i(t)&&!t)return!1}return 0<e.target.value.length&&this._search(),!0},e.prototype._handleInputBlur=function(){return setTimeout(function(){if(l(this.callbacks.onInputBlur)){var e=this.callbacks.onInputBlur(this.nodes);if(i(e)&&!e)return!1}return!document.activeElement.isEqualNode(this.nodes.reset)&&(this._resultNodeClicked?this._resultNodeClicked=!1:void this.close())}.bind(this)),!0},e.prototype._addAccessibilityAnnouncer=function(){this._accessibilityAnnouncerDiv=window.document.createElement("div"),this._accessibilityAnnouncerDiv.setAttribute("style","position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;"),this._accessibilityAnnouncerDiv.setAttribute("data-search-announcer",""),this._accessibilityAnnouncerDiv.setAttribute("aria-live","polite"),this._accessibilityAnnouncerDiv.setAttribute("aria-atomic","true"),this.nodes.result.parentElement.appendChild(this._accessibilityAnnouncerDiv)},e.prototype._removeAccessibilityAnnouncer=function(){this.nodes.result.parentElement.removeChild(this._accessibilityAnnouncerDiv)},e.prototype._updateAccessibilityAttributesAfterSelectingElement=function(e,t){this.nodes.input.setAttribute("aria-activedescendant",t.id),e&&e.removeAttribute("aria-selected"),t.setAttribute("aria-selected",!0)},e.prototype._clearAriaActiveDescendant=function(){this.nodes.input.setAttribute("aria-activedescendant","")},e.prototype._announceNumberOfResultsFound=function(e){var t=this._accessibilityAnnouncerDiv.innerHTML,i=this.numberOfResultsTemplateFct(e);t===i&&(i+="&nbsp;"),this._accessibilityAnnouncerDiv.innerHTML=i},e.prototype._announceLoadingState=function(){this._accessibilityAnnouncerDiv.innerHTML=this.loadingResultsMessageTemplateFct()},e.prototype._handleInputKeyup=function(e){if(l(this.callbacks.onInputKeyup)){var t=this.callbacks.onInputKeyup(this.nodes);if(i(t)&&!t)return!1}if(this._toggleClearButtonVisibility(),this.isResultVisible&&null!==this.nodes){if(38===e.keyCode)return this._navigateOption(e,"UP"),!0;if(40===e.keyCode)return this._navigateOption(e,"DOWN"),!0;if(13===e.keyCode)return this._selectOption(),!0;27===e.keyCode&&this.close()}return e.target.value.length<=0?(this.close(),this._setKeyword("")):0<e.target.value.length&&this._search(),!0},e.prototype._handleInputKeydown=function(e){13===e.keyCode&&null!==this._getSelectedOption()&&e.preventDefault(),38!==e.keyCode&&40!==e.keyCode||e.preventDefault()},e.prototype._handleInputReset=function(e){if(e.preventDefault(),l(this.callbacks.onInputReset)){var t=this.callbacks.onInputReset(this.nodes);if(i(t)&&!t)return!1}return this.nodes.input.value="",this.nodes.input.focus(),this._toggleClearButtonVisibility(),this.close(),!0},e.prototype._navigateOption=function(e,t){var i,s,a,r=this._getSelectedOption();r?"DOWN"===t?(i=r.nextElementSibling)&&(r.classList.remove(this.classes.itemSelected),i.classList.add(this.classes.itemSelected),this._updateAccessibilityAttributesAfterSelectingElement(r,i)):(s=r.previousElementSibling)&&(r.classList.remove(this.classes.itemSelected),s.classList.add(this.classes.itemSelected),this._updateAccessibilityAttributesAfterSelectingElement(r,s)):((a=this.nodes.result.querySelector(this.selectors.searchResult)).classList.add(this.classes.itemSelected),this._updateAccessibilityAttributesAfterSelectingElement(null,a))},e.prototype._getSelectedOption=function(){return this.nodes.result.querySelector("."+this.classes.itemSelected)},e.prototype._selectOption=function(){var e=this._getSelectedOption();e&&e.querySelector("a, button").click()},e.prototype._search=function(){var e=this.nodes.input.value;this._searchKeyword!==e&&(clearTimeout(this._latencyTimer),this._latencyTimer=setTimeout(function(){this.results.isLoading=!0,this._announceLoadingState(),this.nodes.result.classList.add(this.classes.visibleVariant),this.nodes.result.innerHTML=this.resultTemplateFct(this.results)}.bind(this),500),this.predictiveSearch.query(e),this._setKeyword(e))},e.prototype._handlePredictiveSearchSuccess=function(e){clearTimeout(this._latencyTimer),this.results=e.resources.results,this.results.isLoading=!1,this.results.products=this.results.products.slice(0,this.numberOfResults),this.results.canLoadMore=this.numberOfResults<=this.results.products.length,this.results.searchQuery=this.nodes.input.value,0<this.results.products.length||this.results.searchQuery?(this.nodes.result.innerHTML=this.resultTemplateFct(this.results),this._announceNumberOfResultsFound(this.results),this.open()):(this.nodes.result.innerHTML="",this._closeOnNoResults())},e.prototype._handlePredictiveSearchError=function(){clearTimeout(this._latencyTimer),this.nodes.result.innerHTML="",this._closeOnNoResults()},e.prototype._closeOnNoResults=function(){this.nodes&&this.nodes.result.classList.remove(this.classes.visibleVariant),this.isResultVisible=!1},e.prototype._setKeyword=function(e){this._searchKeyword=e},e.prototype._toggleClearButtonVisibility=function(){this.nodes.reset&&(0<this.nodes.input.value.length?this.nodes.reset.classList.add(this.classes.clearButtonVisible):this.nodes.reset.classList.remove(this.classes.clearButtonVisible))},e.prototype.open=function(){if(!this.isResultVisible){if(l(this.callbacks.onBeforeOpen)){var e=this.callbacks.onBeforeOpen(this.nodes);if(i(e)&&!e)return!1}return this.nodes.result.classList.add(this.classes.visibleVariant),this.nodes.input.setAttribute("aria-expanded",!0),this.isResultVisible=!0,l(this.callbacks.onOpen)&&this.callbacks.onOpen(this.nodes)||!0}},e.prototype.close=function(){if(!this.isResultVisible)return!0;if(l(this.callbacks.onBeforeClose)){var e=this.callbacks.onBeforeClose(this.nodes);if(i(e)&&!e)return!1}return this.nodes&&this.nodes.result.classList.remove(this.classes.visibleVariant),this.nodes.input.setAttribute("aria-expanded",!1),this._clearAriaActiveDescendant(),this._setKeyword(""),l(this.callbacks.onClose)&&this.callbacks.onClose(this.nodes),this.isResultVisible=!1,this.results={},!0},e.prototype.destroy=function(){if(this.close(),l(this.callbacks.onBeforeDestroy)){var e=this.callbacks.onBeforeDestroy(this.nodes);if(i(e)&&!e)return!1}var t;return this.nodes.result.classList.remove(this.classes.visibleVariant),(t=this.nodes.input).removeAttribute("autocorrect","off"),t.removeAttribute("autocomplete","off"),t.removeAttribute("autocapitalize","off"),t.removeAttribute("spellcheck","false"),this._removeInputEventListeners(),this._removeBodyEventListener(),this._removeAccessibilityAnnouncer(),this._removeClearButtonEventListener(),l(this.callbacks.onDestroy)&&this.callbacks.onDestroy(this.nodes),!0},e.prototype.clearAndClose=function(){this.nodes.input.value="",this.close()},e}(Shopify.theme.PredictiveSearch),theme.Drawers=function(){function e(e,t,i){var s="js-drawer-open",a={selectors:{openVariant:"."+s+"-"+t,close:".js-drawer-close"},classes:{open:s,openVariant:s+"-"+t},withPredictiveSearch:!1};if(this.nodes={$parent:$("html").add("body"),$page:$("#PageContainer")},this.config=$.extend(a,i),this.position=t,this.$drawer=$("#"+e),!this.$drawer.length)return!1;this.drawerIsOpen=!1,this.init()}return e.prototype.init=function(){$(this.config.selectors.openVariant).on("click",$.proxy(this.open,this)),this.$drawer.on("click",this.config.selectors.close,$.proxy(this.close,this))},e.prototype.open=function(e){var t=!1;if(e?e.preventDefault():t=!0,e&&e.stopPropagation&&(e.stopPropagation(),this.$activeSource=$(e.currentTarget)),this.drawerIsOpen&&!t)return this.close();this.config.withPredictiveSearch||this.$drawer.prepareTransition(),this.nodes.$parent.addClass(this.config.classes.open+" "+this.config.classes.openVariant),this.drawerIsOpen=!0,this.config.onDrawerOpen&&"function"==typeof this.config.onDrawerOpen&&(t||this.config.onDrawerOpen()),this.$activeSource&&this.$activeSource.attr("aria-expanded")&&this.$activeSource.attr("aria-expanded","true");var i={$container:this.$drawer,namespace:"drawer_focus"};return this.config.$elementToFocusOnOpen&&(i.$elementToFocus=this.config.$elementToFocusOnOpen),slate.a11y.trapFocus(i),this.bindEvents(),this},e.prototype.close=function(){this.drawerIsOpen&&($(document.activeElement).trigger("blur"),this.config.withPredictiveSearch||this.$drawer.prepareTransition(),this.nodes.$parent.removeClass(this.config.classes.open+" "+this.config.classes.openVariant),this.$activeSource&&this.$activeSource.attr("aria-expanded")&&this.$activeSource.attr("aria-expanded","false"),this.drawerIsOpen=!1,slate.a11y.removeTrapFocus({$container:this.$drawer,namespace:"drawer_focus"}),this.unbindEvents(),this.config.onDrawerClose&&"function"==typeof this.config.onDrawerClose&&this.config.onDrawerClose())},e.prototype.bindEvents=function(){this.nodes.$parent.on("keyup.drawer",$.proxy(function(e){return 27!==e.keyCode||(this.close(),!1)},this)),this.nodes.$page.on("touchmove.drawer",function(){return!1}),this.nodes.$page.on("click.drawer",$.proxy(function(){return this.close(),!1},this))},e.prototype.unbindEvents=function(){this.nodes.$page.off(".drawer"),this.nodes.$parent.off(".drawer")},e}(),theme.Helpers=function(){var e=!1;return{setTouch:function(){e=!0},isTouch:function(){return e}}}(),theme.LibraryLoader=function(){var u="link",h="script",p={requested:"requested",loaded:"loaded"},e="https://cdn.shopify.com/shopifycloud/",m={youtubeSdk:{tagId:"youtube-sdk",src:"https://www.youtube.com/iframe_api",type:h},plyrShopifyStyles:{tagId:"plyr-shopify-styles",src:e+"shopify-plyr/v1.0/shopify-plyr.css",type:u},modelViewerUiStyles:{tagId:"shopify-model-viewer-ui-styles",src:e+"model-viewer-ui/assets/v1.0/model-viewer-ui.css",type:u}};return{load:function(e,t){var i,s,a,r,n,o,c,l=m[e];if(l&&l.status!==p.requested)if(t=t||function(){},l.status!==p.loaded){switch(l.status=p.requested,l.type){case h:n=l,o=t,(c=document.createElement("script")).src=n.src,c.addEventListener("load",function(){n.status=p.loaded,o()}),i=c;break;case u:s=l,a=t,(r=document.createElement("link")).href=s.src,r.rel="stylesheet",r.type="text/css",r.addEventListener("load",function(){s.status=p.loaded,a()}),i=r}i.id=l.tagId,l.element=i;var d=document.getElementsByTagName(l.type)[0];d.parentNode.insertBefore(i,d)}else t()}}}(),window.theme=window.theme||{},theme.Header=function(){var s={body:"body",navigation:"#AccessibleNav",siteNavHasDropdown:"[data-has-dropdowns]",siteNavChildLinks:".site-nav__child-link",siteNavActiveDropdown:".site-nav--active-dropdown",siteNavHasCenteredDropdown:".site-nav--has-centered-dropdown",siteNavCenteredDropdown:".site-nav__dropdown--centered",siteNavLinkMain:".site-nav__link--main",siteNavChildLink:".site-nav__link--last",siteNavDropdown:".site-nav__dropdown",siteHeader:".site-header"},i={activeClass:"site-nav--active-dropdown",childLinkClass:"site-nav__child-link",rightDropdownClass:"site-nav__dropdown--right",leftDropdownClass:"site-nav__dropdown--left"},a={};function r(e){e.find(s.siteNavLinkMain).attr("aria-expanded","false"),e.removeClass(i.activeClass),a.$activeDropdown=$(s.siteNavActiveDropdown),$(s.body).off("click.siteNav"),$(window).off("keyup.siteNav")}function e(e){e.each(function(){var e=$(this).find(s.siteNavDropdown);e.length&&(Math.ceil($(this).offset().left)>Math.floor(a.$siteHeader.outerWidth())/2?e.removeClass(i.leftDropdownClass).addClass(i.rightDropdownClass):e.removeClass(i.rightDropdownClass).addClass(i.leftDropdownClass))})}function t(){$(s.siteNavHasCenteredDropdown).each(function(){var e=$(this),t=e.find(s.siteNavCenteredDropdown),i=e.position().top+41;t.css("top",i)})}return{init:function(){a={$nav:$(s.navigation),$topLevel:$(s.siteNavLinkMain),$parents:$(s.navigation).find(s.siteNavHasDropdown),$subMenuLinks:$(s.siteNavChildLinks),$activeDropdown:$(s.siteNavActiveDropdown),$siteHeader:$(s.siteHeader)},e($(s.siteNavHasDropdown)),t(),a.$parents.on("click.siteNav",function(){var e=$(this);(e.hasClass(i.activeClass)?r:function(t){t.addClass(i.activeClass),a.$activeDropdown.length&&r(a.$activeDropdown);(a.$activeDropdown=t).find(s.siteNavLinkMain).attr("aria-expanded","true"),setTimeout(function(){$(window).on("keyup.siteNav",function(e){27===e.keyCode&&r(t)}),$(s.body).on("click.siteNav",function(){r(t)})},250)})(e)}),$(s.siteNavChildLink).on("focusout.siteNav",function(){setTimeout(function(){!$(document.activeElement).hasClass(i.childLinkClass)&&a.$activeDropdown.length&&r(a.$activeDropdown)})}),a.$topLevel.on("focus.siteNav",function(){a.$activeDropdown.length&&r(a.$activeDropdown)}),a.$subMenuLinks.on("click.siteNav",function(e){e.stopImmediatePropagation()}),$(window).resize($.debounce(50,function(){e($(s.siteNavHasDropdown)),t()}))},unload:function(){$(window).off(".siteNav"),a.$parents.off(".siteNav"),a.$subMenuLinks.off(".siteNav"),a.$topLevel.off(".siteNav"),$(s.siteNavChildLink).off(".siteNav"),$(s.body).off(".siteNav")}}}(),window.theme=window.theme||{},theme.MobileNav=function(){var o,c,s,l={mobileNavOpenIcon:"mobile-nav--open",mobileNavCloseIcon:"mobile-nav--close",navLinkWrapper:"mobile-nav__item",navLink:"mobile-nav__link",subNavLink:"mobile-nav__sublist-link",return:"mobile-nav__return-btn",subNavActive:"is-active",subNavClosing:"is-closing",navOpen:"js-menu--is-open",subNavShowing:"sub-nav--is-open",thirdNavShowing:"third-nav--is-open",subNavToggleBtn:"js-toggle-submenu"},d={},u=1;function e(){var e;d.$mobileNavToggle.hasClass(l.mobileNavCloseIcon)?t():(e=d.$siteHeader.outerHeight(),d.$mobileNavContainer.prepareTransition().addClass(l.navOpen),d.$mobileNavContainer.css({transform:"translateY("+e+"px)"}),d.$pageContainer.css({transform:"translate3d(0, "+d.$mobileNavContainer[0].scrollHeight+"px, 0)"}),slate.a11y.trapFocus({$container:d.$sectionHeader,$elementToFocus:d.$mobileNavToggle,namespace:"navFocus"}),d.$mobileNavToggle.addClass(l.mobileNavCloseIcon).removeClass(l.mobileNavOpenIcon).attr("aria-expanded",!0),$(window).on("keyup.mobileNav",function(e){27===e.which&&t()}))}function t(){d.$mobileNavContainer.prepareTransition().removeClass(l.navOpen),d.$mobileNavContainer.css({transform:"translateY(-100%)"}),d.$pageContainer.removeAttr("style"),slate.a11y.trapFocus({$container:$("html"),$elementToFocus:$("body")}),d.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle",function(){slate.a11y.removeTrapFocus({$container:d.$mobileNav,namespace:"navFocus"})}),d.$mobileNavToggle.addClass(l.mobileNavOpenIcon).removeClass(l.mobileNavCloseIcon).attr("aria-expanded",!1).focus(),$(window).off("keyup.mobileNav"),scrollTo(0,0)}function i(e){var t,i;o||(i=(t=$(e.currentTarget)).hasClass(l.return),o=!0,i?($("."+l.subNavToggleBtn+'[data-level="'+(u-1)+'"]').removeClass(l.subNavActive),s&&s.length&&s.removeClass(l.subNavActive)):t.addClass(l.subNavActive),function(e){var t=e?$('.mobile-nav__dropdown[data-parent="'+e+'"]'):d.$mobileNav;u=t.data("level")?t.data("level"):1,c&&c.length&&c.prepareTransition().addClass(l.subNavClosing);var i=(c=t).outerHeight(),s=2<u?l.thirdNavShowing:l.subNavShowing;d.$mobileNavContainer.css("height",i).removeClass(l.thirdNavShowing).addClass(s),e||d.$mobileNavContainer.removeClass(l.thirdNavShowing).removeClass(l.subNavShowing);var a=1===u?d.$sectionHeader:t,r=t.find("[data-menu-title="+u+"]"),n=r||t;d.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle",function(){slate.a11y.trapFocus({$container:a,$elementToFocus:n,namespace:"subNavFocus"}),d.$mobileNavContainer.off(".subnavToggle"),o=!1}),d.$pageContainer.css({transform:"translateY("+i+"px)"}),c.removeClass(l.subNavClosing)}((s=t).data("target")))}return{init:function(){(d={$pageContainer:$("#PageContainer"),$siteHeader:$(".site-header"),$mobileNavToggle:$(".js-mobile-nav-toggle"),$mobileNavContainer:$(".mobile-nav-wrapper"),$mobileNav:$("#MobileNav"),$sectionHeader:$("#shopify-section-header"),$subNavToggleBtn:$("."+l.subNavToggleBtn)}).$mobileNavToggle.on("click",e),d.$subNavToggleBtn.on("click.subNav",i),enquire.register("screen and (max-width: 749px)",{unmatch:function(){d.$mobileNavContainer.hasClass(l.navOpen)&&t()}})},closeMobileNav:t}}(jQuery),function(){var e=$(".return-link");function i(e){var t=document.createElement("a");return t.ref=e,t.hostname}document.referrer&&e.length&&window.history.length&&e.one("click",function(e){e.preventDefault();var t=i(document.referrer);return i(window.location.href)===t&&history.back(),!1})}(),theme.Slideshow=function(){this.$slideshow=null;var n={slideshow:"slideshow",slickActiveMobile:"slick-active-mobile",controlsHover:"slideshow__controls--hover",isPaused:"is-paused"},r={section:".shopify-section",wrapper:"#SlideshowWrapper-",slides:".slideshow__slide",textWrapperMobile:".slideshow__text-wrap--mobile",textContentMobile:".slideshow__text-content--mobile",controls:".slideshow__controls",pauseButton:".slideshow__pause",dots:".slick-dots",arrows:".slideshow__arrows",arrowsMobile:".slideshow__arrows--mobile",arrowLeft:".slideshow__arrow-left",arrowRight:".slideshow__arrow-right"};function e(e,i){var t=this.$slideshow=$(e);this.adaptHeight=this.$slideshow.data("adapt-height"),this.$wrapper=this.$slideshow.closest(r.wrapper+i),this.$section=this.$wrapper.closest(r.section),this.$controls=this.$wrapper.find(r.controls),this.$arrows=this.$section.find(r.arrows),this.$arrowsMobile=this.$section.find(r.arrowsMobile),this.$pause=this.$controls.find(r.pauseButton),this.$textWrapperMobile=this.$section.find(r.textWrapperMobile),this.autorotate=this.$slideshow.data("autorotate");var s=this.$slideshow.data("speed"),a=this.$slideshow.data("slide-nav-a11y");this.settings={accessibility:!0,arrows:!1,dots:!0,fade:!0,draggable:!0,touchThreshold:20,autoplay:this.autorotate,autoplaySpeed:s,appendDots:this.$arrows,customPaging:function(e,t){return'<a href="'+r.wrapper+i+'" aria-label="'+a.replace("[slide_number]",t+1)+'" data-slide-number="'+t+'"></a>'}},this.$slideshow.on("beforeChange",function(e,t,i,s){var a=this.$dots.find("a"),r=this.$mobileDots.find("li");a.removeAttr("aria-current").eq(s).attr("aria-current","true"),r.removeClass(n.slickActiveMobile).eq(s).addClass(n.slickActiveMobile),this.showMobileText(s)}.bind(this)),this.$slideshow.on("init",function(e,t){var i=t.$slider,s=t.$list;this.$dots=this.$section.find(r.dots),this.$mobileDots=this.$dots.eq(1),s.removeAttr("aria-live"),this.$wrapper.on("keyup",o.bind(this)),this.$controls.on("keyup",o.bind(this)),this.$textWrapperMobile.on("keyup",o.bind(this)),this.$wrapper.on("focusin",function(e){this.$wrapper.has(e.target).length&&(s.attr("aria-live","polite"),this.autorotate&&i.slick("slickPause"))}.bind(this)).on("focusout",function(e){this.$wrapper.has(e.target).length&&(s.removeAttr("aria-live"),this.autorotate&&(this.$pause.is(".is-paused")||i.slick("slickPlay")))}.bind(this)),this.$dots&&this.$dots.find("a").each(function(){$(this).on("click keyup",function(e){var t;"keyup"===e.type&&e.which!==slate.utils.keyboardKeys.ENTER||(e.preventDefault(),t=$(e.target).data("slide-number"),i.attr("tabindex",-1).slick("slickGoTo",t),"keyup"===e.type&&i.focus())})}).eq(0).attr("aria-current","true");this.$controls.on("focusin",function(){this.$controls.addClass(n.controlsHover)}.bind(this)).on("focusout",function(){this.$controls.removeClass(n.controlsHover)}.bind(this))}.bind(this)),this.$slideshow.on("init",function(){this.$mobileDots.find("li:first-of-type").addClass(n.slickActiveMobile),this.showMobileText(0)}.bind(this)),this.autorotate&&$(document).scroll($.debounce(250,function(){this.$arrowsMobile.offset().top+this.$arrowsMobile.outerHeight()<window.pageYOffset?t.slick("slickPause"):this.$pause.hasClass(n.isPaused)||t.slick("slickPlay")}.bind(this))),this.adaptHeight&&(this.setSlideshowHeight(),$(window).resize($.debounce(50,this.setSlideshowHeight.bind(this)))),this.$slideshow.slick(this.settings),function(){this.$slideshow.find(r.slides).removeAttr("role").removeAttr("aria-labelledby"),this.$dots.removeAttr("role").find("li").removeAttr("role").removeAttr("aria-selected").each(function(){var e=$(this),t=e.attr("aria-controls");e.removeAttr("aria-controls").find("a").attr("aria-controls",t)})}.bind(this)(),this.$arrows.find(r.arrowLeft).on("click",function(){t.slick("slickPrev")}),this.$arrows.find(r.arrowRight).on("click",function(){t.slick("slickNext")}),this.$pause.on("click",this.togglePause.bind(this))}function o(){event.keyCode===slate.utils.keyboardKeys.LEFTARROW&&this.$slideshow.slick("slickPrev"),event.keyCode===slate.utils.keyboardKeys.RIGHTARROW&&this.$slideshow.slick("slickNext")}return e.prototype.togglePause=function(){var e="#Slideshow-"+this.$pause.data("id");this.$pause.hasClass(n.isPaused)?(this.$pause.removeClass(n.isPaused).attr("aria-pressed","false"),this.autorotate&&$(e).slick("slickPlay")):(this.$pause.addClass(n.isPaused).attr("aria-pressed","true"),this.autorotate&&$(e).slick("slickPause"))},e.prototype.setSlideshowHeight=function(){var e=this.$slideshow.data("min-aspect-ratio");this.$slideshow.height($(document).width()/e)},e.prototype.showMobileText=function(e){var t=this.$textWrapperMobile.find(r.textContentMobile),i=r.textContentMobile+"-"+e,s=this.$textWrapperMobile.find(i);s.length||1!==this.$slideshow.find(r.slides).length?this.$textWrapperMobile.show():this.$textWrapperMobile.hide(),t.hide(),s.show()},e}(),theme.Video=function(){var r=!1,t=!1,n=!1,o=!1,c={},l=[],d={ratio:16/9,scrollAnimationDuration:400,playerVars:{iv_load_policy:3,modestbranding:1,autoplay:0,controls:0,wmode:"opaque",branding:0,autohide:0,rel:0},events:{onReady:function(e){e.target.setPlaybackQuality("hd1080");var t=y(e),i=e.target.getVideoData().title;a(),$("#"+t.id).attr("tabindex","-1"),w(),function(e,t){var i=e.find(h.playVideoBtn),s=e.find(h.closeVideoBtn),a=e.find(h.pauseVideoBtn),r=s.find(h.fallbackText),n=a.find(h.pauseVideoStop).find(h.fallbackText),o=a.find(h.pauseVideoResume).find(h.fallbackText);i.each(function(){var e=$(this).find(h.fallbackText);e.text(e.text().replace("[video_title]",t))}),r.text(r.text().replace("[video_title]",t)),n.text(n.text().replace("[video_title]",t)),o.text(o.text().replace("[video_title]",t))}(t.$videoWrapper,i),"background"===t.type&&(e.target.mute(),s(t.id));t.$videoWrapper.addClass(u.loaded)},onStateChange:function(e){var t=y(e);"background"!==t.status||S()||r||e.data!==YT.PlayerState.PLAYING&&e.data!==YT.PlayerState.BUFFERING||(i(!0),r=!0,t.$videoWrapper.removeClass(u.loading));switch(e.data){case YT.PlayerState.ENDED:!function(e){switch(e.type){case"background":l[e.id].seekTo(0);break;case"image_with_play":g(e.id),b(e.id,!1)}}(t);break;case YT.PlayerState.PAUSED:setTimeout(function(){e.target.getPlayerState()===YT.PlayerState.PAUSED&&v(t)},200)}}}},u={playing:"video-is-playing",paused:"video-is-paused",loading:"video-is-loading",loaded:"video-is-loaded",backgroundVideoWrapper:"video-background-wrapper",videoWithImage:"video--image_with_play",backgroundVideo:"video--background",userPaused:"is-paused",supportsAutoplay:"autoplay",supportsNoAutoplay:"no-autoplay",wrapperMinHeight:"video-section-wrapper--min-height"},h={section:".video-section",videoWrapper:".video-section-wrapper",playVideoBtn:".video-control__play",closeVideoBtn:".video-control__close-wrapper",pauseVideoBtn:".video__pause",pauseVideoStop:".video__pause-stop",pauseVideoResume:".video__pause-resume",fallbackText:".icon__fallback-text"};function p(e){(t||n)&&e&&"function"==typeof l[e].playVideo&&s(e)}function m(e){l[e]&&"function"==typeof l[e].pauseVideo&&l[e].pauseVideo()}function s(e,t){var i=c[e],s=l[e],a=i.$videoWrapper;if(n)f(i);else{if(t||r)return a.removeClass(u.loading),f(i),void s.playVideo();s.playVideo()}}function i(e){var t=e?u.supportsAutoplay:u.supportsNoAutoplay;$(document.documentElement).removeClass(u.supportsAutoplay).removeClass(u.supportsNoAutoplay).addClass(t),e||(n=!0),r=!0}function a(){t||(S()&&(n=!0),n&&i(!1),t=!0)}function f(e){var t=e.$videoWrapper,i=t.find(h.pauseVideoBtn);t.removeClass(u.loading),i.hasClass(u.userPaused)&&i.removeClass(u.userPaused),"background"!==e.status&&($("#"+e.id).attr("tabindex","0"),"image_with_play"===e.type&&t.removeClass(u.paused).addClass(u.playing),setTimeout(function(){t.find(h.closeVideoBtn).focus()},d.scrollAnimationDuration))}function v(e){var t=e.$videoWrapper;"image_with_play"===e.type&&("closed"===e.status?t.removeClass(u.paused):t.addClass(u.paused)),t.removeClass(u.playing)}function g(e){var t,i=c[e],s=i.$videoWrapper,a=[u.paused,u.playing].join(" ");switch(S()&&s.removeAttr("style"),$("#"+i.id).attr("tabindex","-1"),i.status="closed",i.type){case"image_with_play":l[e].stopVideo(),v(i);break;case"background":l[e].mute(),t=e,$("#"+t).removeClass(u.videoWithImage).addClass(u.backgroundVideo),c[t].$videoWrapper.addClass(u.backgroundVideoWrapper),c[t].status="background",C($("#"+t))}s.removeClass(a)}function y(e){var t=e.target.getIframe().id;return c[t]}function b(e,t){var i=c[e],s=i.$videoWrapper.offset().top,a=i.$videoWrapper.find(h.playVideoBtn),r=0,n=0;S()&&i.$videoWrapper.parent().toggleClass("page-width",!t),t?(n=S()?$(window).width()/d.ratio:i.$videoWrapper.width()/d.ratio,r=($(window).height()-n)/2,i.$videoWrapper.removeClass(u.wrapperMinHeight).animate({height:n},600),S()&&Shopify.designMode||$("html, body").animate({scrollTop:s-r},d.scrollAnimationDuration)):(n=S()?i.$videoWrapper.data("mobile-height"):i.$videoWrapper.data("desktop-height"),i.$videoWrapper.height(i.$videoWrapper.width()/d.ratio).animate({height:n},600),setTimeout(function(){i.$videoWrapper.addClass(u.wrapperMinHeight)},600),a.focus())}function _(e){var t,i=c[e];switch(i.$videoWrapper.addClass(u.loading),i.$videoWrapper.attr("style","height: "+i.$videoWrapper.height()+"px"),i.status="open",i.type){case"image_with_play":s(e,!0);break;case"background":t=e,$("#"+t).removeClass(u.backgroundVideo).addClass(u.videoWithImage),setTimeout(function(){$("#"+t).removeAttr("style")},600),c[t].$videoWrapper.removeClass(u.backgroundVideoWrapper).addClass(u.playing),c[t].status="open",l[e].unMute(),s(e,!0)}b(e,!0),$(document).on("keydown.videoPlayer",function(e){var t=$(document.activeElement).data("controls");e.keyCode===slate.utils.keyboardKeys.ESCAPE&&t&&(g(t),b(t,!1))})}function w(){$("."+u.backgroundVideo).each(function(e,t){C($(t))})}function C(e){var t,i,s,a;o&&(S()?e.removeAttr("style"):(i=(t=e.closest(h.videoWrapper)).width(),s=e.width(),a=t.data("desktop-height"),i/d.ratio<a?(s=Math.ceil(a*d.ratio),e.width(s).height(a).css({left:(i-s)/2,top:0})):(a=Math.ceil(i/d.ratio),e.width(i).height(a).css({left:0,top:(a-a)/2})),e.prepareTransition(),t.addClass(u.loaded)))}function S(){return $(window).width()<750||window.mobileCheck()}function k(){$(document).on("click.videoPlayer",h.playVideoBtn,function(e){_($(e.currentTarget).data("controls"))}),$(document).on("click.videoPlayer",h.closeVideoBtn,function(e){var t=$(e.currentTarget).data("controls");$(e.currentTarget).blur(),g(t),b(t,!1)}),$(document).on("click.videoPlayer",h.pauseVideoBtn,function(e){var t,i,s,a=$(e.currentTarget).data("controls");i=c[t=a].$videoWrapper.find(h.pauseVideoBtn),(s=i.hasClass(u.userPaused))?(i.removeClass(u.userPaused),p(t)):(i.addClass(u.userPaused),m(t)),i.attr("aria-pressed",!s)}),$(window).on("resize.videoPlayer",$.debounce(200,function(){if(o){var e,t=window.innerHeight===screen.height;if(w(),S()){for(e in c)c.hasOwnProperty(e)&&(c[e].$videoWrapper.hasClass(u.playing)&&(t||(m(e),v(c[e]))),c[e].$videoWrapper.height($(document).width()/d.ratio));i(!1)}else for(e in i(!0),c)c[e].$videoWrapper.find("."+u.videoWithImage).length||(l[e].playVideo(),f(c[e]))}})),$(window).on("scroll.videoPlayer",$.debounce(50,function(){if(o)for(var e in c){var t;!c.hasOwnProperty(e)||(t=c[e].$videoWrapper).hasClass(u.playing)&&(t.offset().top+.75*t.height()<$(window).scrollTop()||t.offset().top+.25*t.height()>$(window).scrollTop()+$(window).height())&&(g(e),b(e,!1))}}))}function T(e){var t=$.extend({},d,c[e]);t.playerVars.controls=t.controls,l[e]=new YT.Player(e,t)}return{init:function(e){var t,i;e.length&&(c[e.attr("id")]={id:e.attr("id"),videoId:e.data("id"),type:e.data("type"),status:"image_with_play"===e.data("type")?"closed":"background",$video:e,$videoWrapper:e.closest(h.videoWrapper),$section:e.closest(h.section),controls:"background"===e.data("type")?0:1},o||((t=document.createElement("script")).src="https://www.youtube.com/iframe_api",(i=document.getElementsByTagName("script")[0]).parentNode.insertBefore(t,i)),a())},editorLoadVideo:function(e){o&&(T(e),k())},loadVideos:function(){for(var e in c)c.hasOwnProperty(e)&&T(e);k(),o=!0},playVideo:p,pauseVideo:m,removeEvents:function(){$(document).off(".videoPlayer"),$(window).off(".videoPlayer")}}}(),theme.ProductVideo=function(){var a={},r={html5:"html5",youtube:"youtube"},n={productMediaWrapper:"[data-product-single-media-wrapper]"},o={enableVideoLooping:"enable-video-looping",videoId:"video-id"};function c(e){e?function(){for(var e in a)if(a.hasOwnProperty(e)){var t=a[e];if(t.nativeVideo)continue;t.host===r.html5&&(t.element.setAttribute("controls","controls"),t.nativeVideo=!0)}}():t(r.html5)}function l(){window.YT.Player&&t(r.youtube)}function t(e){for(var t in a){var i;!a.hasOwnProperty(t)||(i=a[t]).host===e&&i.ready()}}return{init:function(e,t){if(e.length){var i=e.find("iframe, video")[0],s=e.data("mediaId");if(i)switch(a[s]={mediaId:s,sectionId:t,host:function(e){if("VIDEO"===e.tagName)return r.html5;if("IFRAME"===e.tagName&&/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e.src))return r.youtube;return null}(i),container:e,element:i,ready:function(){!function(e){if(e.player)return;var t=e.container.closest(n.productMediaWrapper),i=t.data(o.enableVideoLooping);switch(e.host){case r.html5:e.player=new Shopify.Plyr(e.element,{loop:{active:i}});break;case r.youtube:var s=t.data(o.videoId);e.player=new YT.Player(e.element,{videoId:s,events:{onStateChange:function(e){0===e.data&&i&&e.target.seekTo(0)}}})}t.on("mediaHidden xrLaunch",function(){e.player&&(e.host===r.html5&&e.player.pause(),e.host===r.youtube&&e.player.pauseVideo&&e.player.pauseVideo())}),t.on("mediaVisible",function(){theme.Helpers.isTouch()||e.player&&(e.host===r.html5&&e.player.play(),e.host===r.youtube&&e.player.playVideo&&e.player.playVideo())})}(this)}},a[s].host){case r.html5:window.Shopify.loadFeatures([{name:"video-ui",version:"1.0",onLoad:c}]),theme.LibraryLoader.load("plyrShopifyStyles");break;case r.youtube:theme.LibraryLoader.load("youtubeSdk",l)}}},hosts:r,loadVideos:t,removeSectionVideos:function(e){for(var t in a){var i;!a.hasOwnProperty(t)||(i=a[t]).sectionId===e&&(i.player&&i.player.destroy(),delete a[t])}}}}(),theme.ProductModel=function(){var a={},o={},c={},l="[data-product-single-media-group]",d="[data-shopify-xr]";function r(e){if(!e)if(window.ShopifyXR){for(var t in a)if(a.hasOwnProperty(t)){var i=a[t];if(i.loaded)continue;var s=$("#ModelJson-"+t);window.ShopifyXR.addModels(JSON.parse(s.html())),i.loaded=!0}window.ShopifyXR.setupXRElements()}else document.addEventListener("shopify_xr_initialized",function(){r()})}function t(e){if(!e)for(var t in o){var i;o.hasOwnProperty(t)&&((i=o[t]).modelViewerUi||(i.modelViewerUi=new Shopify.ModelViewerUI(i.$element)),function(e){var t=c[e.sectionId];e.$container.on("mediaVisible",function(){t.$element.attr("data-shopify-model3d-id",e.modelId),theme.Helpers.isTouch()||e.modelViewerUi.play()}),e.$container.on("mediaHidden",function(){t.$element.attr("data-shopify-model3d-id",t.defaultId),e.modelViewerUi.pause()}).on("xrLaunch",function(){e.modelViewerUi.pause()})}(i))}}return{init:function(e,n){a[n]={loaded:!1},e.each(function(e){var t,i=$(this),s=i.data("media-id"),a=$(i.find("model-viewer")[0]),r=a.data("model-id");0===e&&(t=i.closest(l).find(d),c[n]={$element:t,defaultId:r}),o[s]={modelId:r,sectionId:n,$container:i,$element:a}}),window.Shopify.loadFeatures([{name:"shopify-xr",version:"1.0",onLoad:r},{name:"model-viewer-ui",version:"1.0",onLoad:t}]),theme.LibraryLoader.load("modelViewerUiStyles")},removeSectionModels:function(e){for(var t in o){o.hasOwnProperty(t)&&o[t].sectionId===e&&(o[t].modelViewerUi.destroy(),delete o[t])}delete a[e]}}}(),window.theme=window.theme||{},theme.FormStatus=function(){var e="[data-form-status]";return{init:function(){this.$statusMessage=$(e),this.$statusMessage&&(this.$statusMessage.attr("tabindex",-1).focus(),this.$statusMessage.on("blur",function(){this.$statusMessage.removeAttr("tabindex")}.bind(this)))}}}(),theme.Hero=function(){var n="index-section--flush",o=".hero-fixed-width__content",c=".hero-fixed-width__image";return function(e,t){this.$hero=$(e),this.layout=this.$hero.data("layout");var i=$("#shopify-section-"+t),s=i.find(o),a=i.find(c);function r(){var e=s.height()+50;a.height()<e&&a.css("min-height",e)}"fixed_width"===this.layout&&(i.removeClass(n),r(),$(window).resize($.debounce(50,function(){r()})))}}(),window.theme=window.theme||{},theme.SearchResultsTemplate=function(){function a(e,t,i){return['<div class="predictive-search">',(r=t,0!==e.length?['<div class="predictive-search-title">','<h3 id="predictive-search" class="predictive-search-title__content">'+theme.strings.products+"</h3>",'<span class="predictive-search-title__loading-spinner">'+(r?'<span class= "icon-predictive-search-spinner" ></span >':"")+"</span>","</div>"].join(""):""),(a=i,n=(s=e).length,['<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',s.map(function(e,t){return i={url:(0<(r=e).variants.length?r.variants[0]:r).url,image:function(e){var t,i;return 0<e.variants.length&&null!==e.variants[0].image?i=e.variants[0].featured_image:e.image?i=e.featured_image:t=null,null!==t&&(t={url:theme.Images.getSizedImageUrl(i.url,"100x"),alt:i.alt}),t}(r),title:r.title,vendor:r.vendor||"",price:theme.Currency.formatMoney(r.price_min,theme.moneyFormat),compareAtPrice:theme.Currency.formatMoney(r.compare_at_price_min,theme.moneyFormat),available:r.available,isOnSale:function(e){return null!==e.compare_at_price_min&&parseInt(e.compare_at_price_min,10)>parseInt(e.price_min,10)}(r),isPriceVaries:function(e){return e.price_max!==e.price_min}(r),isCompareVaries:function(e){return e.compare_at_price_max!==e.compare_at_price_min}(r)},a=n,['<li id="search-result-'+(s=t)+'" class="predictive-search-item" role="option" data-search-result>','<a class="predictive-search-item__link" href="'+i.url+'" tabindex="-1">','<div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper>',function(e){return null!==e.image?['<div class="placeholder-background placeholder-background--animation" data-image-placeholder aria-hidden="true"></div>','<img class="predictive-search-item__image lazyload" src="'+e.image.url+'" data-src="'+e.image.url+'" data-image alt="'+e.image.alt+'" />'].join(""):""}(i),"</div>",'<div class="predictive-search__column predictive-search__column--content '+(o()?"":"predictive-search__column--center")+'">','<span class="predictive-search-item__title">','<span class="predictive-search-item__title-text">'+i.title+"</span>","</span>"+(o()?function(e){return['<dl class="predictive-search-item__details price'+(e.isOnSale?" price--on-sale":"")+(e.available?"":" price--sold-out")+(!e.isPriceVaries&&e.isCompareVaries?" price--compare-price-hidden":"")+'">','<div class="predictive-search-item__detail">',function(e){return theme.settings.predictiveSearchShowVendor&&""!==e.vendor?["<dt>",'<span class="visually-hidden">'+theme.strings.vendor+"</span>","</dt>",'<dd class="predictive-search-item__vendor">'+e.vendor+"</dd>"].join(""):""}(e),"</div>",'<div class="predictive-search-item__detail predictive-search-item__detail--inline">'+function(e){if(!theme.settings.predictiveSearchShowPrice)return"";var t='<div class="price__regular">'+function(e){return["<dt>",'<span class="visually-hidden">'+theme.strings.regularPrice+"</span>","</dt>","<dd>",'<span class="predictive-search-item__price">'+(e.isPriceVaries?theme.strings.fromLowestPrice.replace("[price]",e.price):e.price)+"</span>","</dd>"].join("")}(e)+"</div>",i='<div class="price__sale">'+function(e){return["<dt>",'<span class="visually-hidden">'+theme.strings.salePrice+"</span>","</dt>","<dd>",'<span class="predictive-search-item__price predictive-search-item__price--sale">'+(e.isPriceVaries?theme.strings.fromLowestPrice.replace("[price]",e.price):e.price)+"</span>","</dd>",'<div class="price__compare">'+function(e){return["<dt>",'<span class="visually-hidden">'+theme.strings.regularPrice+"</span> ","</dt>","<dd>",'<span class="predictive-search-item__price predictive-search-item__price--compare">'+e.compareAtPrice+"</span>","</dd>"].join("")}(e)+"</div>"].join("")}(e)+"</div>";return'<span class="visually-hidden">, </span><div class="price__pricing-group">'+(e.isOnSale?i:t)+"</div>"}(e),"</div>","</dl>"].join("")}(i):""),'<span class="visually-hidden">, </span>','<span class="visually-hidden">'+function(e,t){return theme.strings.number_of_results.replace("[result_number]",e).replace("[results_count]",t)}(s+1,a)+"</span>","</div>","</a>","</li>"].join("");var i,s,a,r}).join(""),'<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>'+function(e){return['<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',theme.strings.searchFor+'<span class="predictive-search-view-all__query"> &ldquo;'+function(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}(e)+"&rdquo;</span>","</button>"].join("")}(a)+"</li>","</ul>"].join("")),"</div>"].join("");var s,a,n,r}function o(){return[theme.settings.predictiveSearchShowPrice,theme.settings.predictiveSearchShowVendor].reduce(function(e,t){return e+(t?1:0)},0)}return function(e){var t=e.products||[],i=e.isLoading,s=e.searchQuery||"";return i&&0===t.length?['<div class="predictive-search">','<div class="predictive-search-loading">','<span class="visually-hidden">'+theme.strings.loading+"</span>",'<span class="predictive-search-loading__icon">','<span class="icon-predictive-search-spinner"></span>',"</span>","</div>","</div>"].join(""):a(t,i,s)}}(),window.theme=window.theme||{},function(){function e(e){return 1===e.products.length?theme.strings.one_result_found:theme.strings.number_of_results_found.replace("[results_count]",e.products.length)}function t(){return theme.strings.loading}function i(){return JSON.parse($("#shopify-features").text()).predictiveSearch&&window.theme.settings.predictiveSearchEnabled}function a(e,t){t.addEventListener("click",function(e,t){if(0!==e.value.trim().length)return;void 0!==t&&t.preventDefault();e.focus()}.bind(this,e))}var r,n,o,s,c,l,d,u,h,p,m,f,v,g,y,b;function _(){theme.SearchDrawer.close(),theme.SearchHeader.unload(),theme.SearchPage.unload(),b.mobile.matches?(theme.SearchHeader.init({numberOfResults:4,isTabletAndUp:!1}),w()&&theme.SearchPage.init({isTabletAndUp:!1})):(theme.SearchHeader.init({numberOfResults:4,isTabletAndUp:!0}),w()&&theme.SearchPage.init({isTabletAndUp:!0}))}function w(){return $("body").hasClass(g.searchTemplate)}window.theme.SearchPage=(n="[data-search-page-predictive-search-clear]",o="[data-search-page-predictive-search-input]",s="[data-search-page-predictive-search-submit]",c='[data-predictive-search-mount="default"]',l=document.querySelector(o),d=document.querySelector(s),{init:function(s){r=new window.Shopify.theme.PredictiveSearchComponent({selectors:{input:o,reset:n,result:c},resultTemplateFct:window.theme.SearchResultsTemplate,numberOfResultsTemplateFct:e,loadingResultsMessageTemplateFct:t,onOpen:function(e){var t,i;s.isTabletAndUp||(t=$(o)[0].getBoundingClientRect(),i=$("body").height()-t.bottom-50,$(e.result).css({maxHeight:i}))},onBeforeDestroy:function(e){$(e.result).css({maxHeight:""})}}),a(l,d)},unload:function(){r&&(r.destroy(),r=null)}}),window.theme.SearchHeader=(h="[data-predictive-search-drawer-input]",p='[data-predictive-search-mount="drawer"]',m="[data-search-form-submit]",f=document.querySelector(h),v=document.querySelector(m),{init:function(s){u=new window.Shopify.theme.PredictiveSearchComponent({selectors:{input:h,result:p},resultTemplateFct:window.theme.SearchResultsTemplate,numberOfResultsTemplateFct:e,numberOfResults:s.numberOfResults,loadingResultsMessageTemplateFct:t,onInputBlur:function(){return!1},onOpen:function(e){var t=$(f)[0].getBoundingClientRect(),i=window.innerHeight-t.bottom-(s.isTabletAndUp?20:0);$(e.result).css({top:s.isTabletAndUp?"":t.bottom,maxHeight:i})},onClose:function(e){$(e.result).css({maxHeight:""})},onBeforeDestroy:function(e){$(e.result).css({top:""})}}),a(f,v)},unload:function(){u&&(u.destroy(),u=null)},clearAndClose:function(){u&&u.clearAndClose()}}),window.theme.Search=(g={searchTemplate:"template-search"},y=".site-header",b={mobile:window.matchMedia("(max-width: 749px)"),tabletAndUp:window.matchMedia("(min-width: 750px)")},{init:function(){$(y).length&&i()&&(Object.keys(b).forEach(function(e){b[e].addListener(_)}),_())},unload:function(){theme.SearchHeader.unload(),theme.SearchPage.unload()}})}(),window.theme=window.theme||{},theme.SearchDrawer=function(){var e,t={headerSection:"[data-header-section]",drawer:"[data-predictive-search-drawer]",drawerOpenButton:"[data-predictive-search-open-drawer]",headerSearchInput:"[data-predictive-search-drawer-input]",predictiveSearchWrapper:'[data-predictive-search-mount="drawer"]'};return{init:function(){$(t.drawerOpenButton).attr("aria-controls","SearchDrawer").attr("aria-expanded","false").attr("aria-haspopup","dialog"),e=new theme.Drawers("SearchDrawer","top",{onDrawerOpen:function(){$(t.drawer).css({height:$(t.headerSection).outerHeight()}),theme.MobileNav.closeMobileNav(),window.bodyScrollLock.disableBodyScroll(document.querySelector(t.predictiveSearchWrapper),{allowTouchMove:function(e){return 1===$(e).parents(t.predictiveSearchWrapper).length}})},onDrawerClose:function(){theme.SearchHeader.clearAndClose(),$(t.drawerOpenButton).focus(),window.bodyScrollLock.clearAllBodyScrollLocks()},withPredictiveSearch:!0,$elementToFocusOnOpen:$(t.headerSearchInput)})},close:function(){e.close()}}}(),theme.Disclosure=function(){var e="[data-disclosure-list]",t="[data-disclosure-toggle]",i="[data-disclosure-input]",s="[data-disclosure-option]",a="disclosure-list--visible";function r(e){this.$container=e,this.cache={},this._cacheSelectors(),this._connectOptions(),this._connectToggle(),this._onFocusOut()}return r.prototype=_.assignIn({},r.prototype,{_cacheSelectors:function(){this.cache={$disclosureList:this.$container.find(e),$disclosureToggle:this.$container.find(t),$disclosureInput:this.$container.find(i),$disclosureOptions:this.$container.find(s)}},_connectToggle:function(){this.cache.$disclosureToggle.on("click",function(e){var t="true"===$(e.currentTarget).attr("aria-expanded");$(e.currentTarget).attr("aria-expanded",!t),this.cache.$disclosureList.toggleClass(a)}.bind(this))},_connectOptions:function(){this.cache.$disclosureOptions.on("click",function(e){this._submitForm($(e.currentTarget).data("value"))}.bind(this))},_onFocusOut:function(){this.cache.$disclosureToggle.on("focusout",function(e){0===this.$container.has(e.relatedTarget).length&&this._hideList()}.bind(this)),this.cache.$disclosureList.on("focusout",function(e){var t=0<$(e.currentTarget).has(e.relatedTarget).length;this.cache.$disclosureList.hasClass(a)&&!t&&this._hideList()}.bind(this)),this.$container.on("keyup",function(e){e.which===slate.utils.keyboardKeys.ESCAPE&&(this._hideList(),this.cache.$disclosureToggle.focus())}.bind(this)),$("body").on("click",function(e){var t=0<this.$container.has(e.target).length;this.cache.$disclosureList.hasClass(a)&&!t&&this._hideList()}.bind(this))},_submitForm:function(e){this.cache.$disclosureInput.val(e),this.$container.parents("form").submit()},_hideList:function(){this.cache.$disclosureList.removeClass(a),this.cache.$disclosureToggle.attr("aria-expanded",!1)},unload:function(){this.cache.$disclosureOptions.off(),this.cache.$disclosureToggle.off(),this.cache.$disclosureList.off(),this.$container.off()}}),r}(),function(){var e=$("#BlogTagFilter");e.length&&(slate.utils.resizeSelects(e),e.on("change",function(){location.href=$(this).val()}))}(),window.theme=theme||{},theme.customerTemplates=function(){var e="#RecoverHeading",t="#RecoverEmail",i="#LoginHeading";function s(){this.$RecoverHeading=$(e),this.$RecoverEmail=$(t),this.$LoginHeading=$(i),$("#RecoverPassword").on("click",function(e){e.preventDefault(),a(),this.$RecoverHeading.attr("tabindex","-1").focus()}.bind(this)),$("#HideRecoverPasswordLink").on("click",function(e){e.preventDefault(),$("#RecoverPasswordForm").addClass("hide"),$("#CustomerLoginForm").removeClass("hide"),this.$LoginHeading.attr("tabindex","-1").focus()}.bind(this)),this.$RecoverHeading.on("blur",function(){$(this).removeAttr("tabindex")}),this.$LoginHeading.on("blur",function(){$(this).removeAttr("tabindex")})}function a(){$("#RecoverPasswordForm").removeClass("hide"),$("#CustomerLoginForm").addClass("hide"),"true"===this.$RecoverEmail.attr("aria-invalid")&&this.$RecoverEmail.focus()}return{init:function(){var t,i;s(),function(){"#recover"===window.location.hash&&a.bind(this)()}(),$(".reset-password-success").length&&$("#ResetSuccess").removeClass("hide").focus(),t=$("#AddressNewForm"),i=$("#AddressNewButton"),t.length&&(Shopify&&new Shopify.CountryProvinceSelector("AddressCountryNew","AddressProvinceNew",{hideElement:"AddressProvinceContainerNew"}),$(".address-country-option").each(function(){var e=$(this).data("form-id"),t="AddressCountry_"+e,i="AddressProvince_"+e,s="AddressProvinceContainer_"+e;new Shopify.CountryProvinceSelector(t,i,{hideElement:s})}),$(".address-new-toggle").on("click",function(){var e="true"===i.attr("aria-expanded");t.toggleClass("hide"),i.attr("aria-expanded",!e).focus()}),$(".address-edit-toggle").on("click",function(){var e=$(this).data("form-id"),t=$("#EditFormButton_"+e),i=$("#EditAddress_"+e),s="true"===t.attr("aria-expanded");i.toggleClass("hide"),t.attr("aria-expanded",!s).focus()}),$(".address-delete").on("click",function(){var e=$(this),t=e.data("target"),i=e.data("confirm-message");confirm(i||"Are you sure you wish to delete this address?")&&Shopify.postLink(t,{parameters:{_method:"delete"}})}))}}}(),window.theme=window.theme||{},theme.Cart=function(){var t="[data-cart-count]",i="[data-cart-count-bubble]",e="[data-cart-discount]",s="[data-cart-discount-title]",a="[data-cart-discount-amount]",r="[data-cart-discount-wrapper]",n="[data-cart-error-message]",o="[data-cart-error-message-wrapper]",c="[data-cart-item]",l="[data-cart-item-details]",d="[data-cart-item-discount]",u="[data-cart-item-discounted-price-group]",h="[data-cart-item-discount-title]",p="[data-cart-item-discount-amount]",m="[data-cart-item-discount-list]",f="[data-cart-item-final-price]",v="[data-cart-item-image]",g="[data-cart-item-line-price]",y="[data-cart-item-original-price]",b="[data-cart-item-price]",w="[data-cart-item-price-list]",C="[data-cart-item-property]",S="[data-cart-item-property-name]",k="[data-cart-item-property-value]",T="[data-cart-item-regular-price-group]",P="[data-cart-item-regular-price]",I="[data-cart-item-title]",L="[data-cart-item-option]",x="[data-cart-line-items]",E="[data-cart-notes]",A="[data-cart-quantity-error-message]",M="[data-cart-quantity-error-message-wrapper]",D="[data-cart-remove]",O="[data-cart-status]",N="[data-cart-subtotal]",V="[data-cart-table-cell]",R="[data-cart-wrapper]",F="[data-empty-page-content]",B="[data-quantity-input]",W="[data-quantity-input-mobile]",H="[data-quantity-input-desktop]",q="[data-quantity-label-mobile]",U="[data-quantity-label-desktop]",j="[data-quantity-input]",Q=".cart__image",z="[data-unit-price]",K="[data-unit-price-base-unit]",Y="[data-unit-price-group]",J="cart--no-cookies",G="cart__removed-product",X="hide",Z="input--error",ee="data-cart-item-index",te="data-cart-item-key",ie="data-cart-item-quantity",se="data-cart-item-title",ae="data-cart-item-url",re="data-quantity-item";theme.breakpoints=theme.breakpoints||{},!isNaN(theme.breakpoints.medium)&&void 0!==theme.breakpoints.medium||(theme.breakpoints.medium=750);var ne="(min-width: "+theme.breakpoints.medium+"px)";function oe(e){this.$container=$(e),this.$thumbnails=$(Q,this.$container),this.ajaxEnabled=this.$container.data("ajax-enabled"),this.cookiesEnabled()||this.$container.addClass(J),this.$thumbnails.css("cursor","pointer"),this.$container.on("click",Q,this._handleThumbnailClick),this.$container.on("change",j,$.debounce(500,this._handleInputQty.bind(this))),this.mql=window.matchMedia(ne),this.mql.addListener(this.setQuantityFormControllers.bind(this)),this.setQuantityFormControllers(),this.ajaxEnabled&&(this.$container.on("change",E,this._onNoteChange.bind(this)),this.$container.on("click",D,this._onRemoveItem.bind(this)),this._setupCartTemplates())}return oe.prototype=_.assignIn({},oe.prototype,{_setupCartTemplates:function(){this.$itemTemplate=$(c,this.$container).first().clone(),this.$itemDiscountTemplate=$(d,this.$itemTemplate).clone(),this.$itemOptionTemplate=$(L,this.$itemTemplate).clone(),this.$itemPropertyTemplate=$(C,this.$itemTemplate).clone(),this.$itemPriceListTemplate=$(w,this.$itemTemplate).clone(),this.$itemLinePriceTemplate=$(g,this.$itemTemplate).clone(),this.$cartDiscountTemplate=$(e,this.$container).clone()},_handleInputQty:function(e){var t=$(e.target),i=t.data("quantity-item"),s=t.closest(c),a=$("[data-quantity-item="+i+"]"),r=parseInt(t.val()),n=!(r<0||isNaN(r));a.val(r),this._hideCartError(),this._hideQuantityErrorMessage(),n?n&&this.ajaxEnabled&&this._updateItemQuantity(i,s,a,r):this._showQuantityErrorMessages(s)},_updateItemQuantity:function(e,s,t,a){var r=s.attr(te),i=s.attr(ee),n={url:"/cart/change.js",data:{quantity:a,line:i},dataType:"json"};$.post(n).done(function(e){var t,i;0===e.item_count?this._emptyCart():(this._createCart(e),0===a?this._showRemoveMessage(s.clone()):(t=$('[data-cart-item-key="'+r+'"]'),i=this.getItem(r,e),$(B,t).focus(),this._updateLiveRegion(i))),this._setCartCountBubble(e.item_count)}.bind(this)).fail(function(){this._showCartError(t)}.bind(this))},getItem:function(t,e){return e.items.find(function(e){return e.key===t})},_liveRegionText:function(e){var t=(t=theme.strings.update+": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]").replace("[QuantityLabel]",theme.strings.quantity).replace("[Quantity]",e.quantity),i="",s=theme.Currency.formatMoney(e.original_line_price,theme.moneyFormat),a="",r="",n="";return e.original_line_price>e.final_line_price&&(i=theme.strings.regularTotal,a=theme.strings.discountedTotal,r=theme.Currency.formatMoney(e.final_line_price,theme.moneyFormat),n=theme.strings.priceColumn),t=t.replace("[Regular]",i).replace("[$$]",s).replace("[DiscountedPrice]",a).replace("[$]",r).replace("[PriceInformation]",n).trim()},_updateLiveRegion:function(e){var t=$(O);t.html(this._liveRegionText(e)).attr("aria-hidden",!1),setTimeout(function(){t.attr("aria-hidden",!0)},1e3)},_createCart:function(e){var t=this._createCartDiscountList(e);$(x,this.$container).html(this._createLineItemList(e)),this.setQuantityFormControllers(),$(E,this.$container).val(e.note),0===t.length?$(r,this.$container).html("").addClass(X):$(r,this.$container).html(t).removeClass(X),$(N,this.$container).html(theme.Currency.formatMoney(e.total_price,theme.moneyFormatWithCurrency))},_createCartDiscountList:function(e){return $.map(e.cart_level_discount_applications,function(e){var t=this.$cartDiscountTemplate.clone();return t.find(s).text(e.title),t.find(a).html(theme.Currency.formatMoney(e.total_allocated_amount,theme.moneyFormat)),t[0]}.bind(this))},_createLineItemList:function(e){return $.map(e.items,function(e,t){var i=this.$itemTemplate.clone(),s=this.$itemPriceListTemplate.clone();this._setLineItemAttributes(i,e,t),this._setLineItemImage(i,e.featured_image),$(I,i).text(e.product_title).attr("href",e.url);var a=this._createProductDetailsList(e.product_has_only_default_variant,e.options_with_values,e.properties);this._setProductDetailsList(i,a),this._setItemRemove(i,e.title),s.html(this._createItemPrice(e.original_price,e.final_price,this.$itemPriceListTemplate)),e.unit_price_measurement&&s.append(this._createUnitPrice(e.unit_price,e.unit_price_measurement,this.$itemPriceListTemplate)),this._setItemPrice(i,s);var r=this._createItemDiscountList(e);this._setItemDiscountList(i,r),this._setQuantityInputs(i,e,t);var n=this._createItemPrice(e.original_line_price,e.final_line_price,this.$itemLinePriceTemplate);return this._setItemLinePrice(i,n),i[0]}.bind(this))},_setLineItemAttributes:function(e,t,i){e.attr(te,t.key).attr(ae,t.url).attr(se,t.title).attr(ee,i+1).attr(ie,t.quantity)},_setLineItemImage:function(e,t){var i=$(v,e),s=null!==t.url?theme.Images.getSizedImageUrl(t.url,"x190"):null;s?i.attr("alt",t.alt).attr("src",s).removeClass(X):i.remove()},_setProductDetailsList:function(e,t){var i=$(l,e);0===t.length?i.addClass(X).text(""):i.removeClass(X).html(t)},_setItemPrice:function(e,t){$(b,e).html(t)},_setItemDiscountList:function(e,t){var i=$(m,e);0===t.length?i.html("").addClass(X):i.html(t).removeClass(X)},_setItemRemove:function(e,t){$(D,e).attr("aria-label",theme.strings.removeLabel.replace("[product]",t))},_setQuantityInputs:function(e,t,i){$(W,e).attr("id","updates_"+t.key).attr(re,i+1).val(t.quantity),$(H,e).attr("id","updates_large_"+t.key).attr(re,i+1).val(t.quantity),$(q,e).attr("for","updates_"+t.key),$(U,e).attr("for","updates_large_"+t.key)},setQuantityFormControllers:function(){this.mql.matches?($(H).attr("name","updates[]"),$(W).removeAttr("name")):($(W).attr("name","updates[]"),$(H).removeAttr("name"))},_setItemLinePrice:function(e,t){$(g,e).html(t)},_createProductDetailsList:function(e,t,i){var s=[];return e||(s=s.concat(this._getOptionList(t))),null!==i&&0!==Object.keys(i).length&&(s=s.concat(this._getPropertyList(i))),s},_getOptionList:function(e){return $.map(e,function(e){var t=this.$itemOptionTemplate.clone();return t.text(e.name+": "+e.value).removeClass(X),t[0]}.bind(this))},_getPropertyList:function(e){var t=null!==e?Object.entries(e):[];return $.map(t,function(e){var t=this.$itemPropertyTemplate.clone();if("_"!==e[0].charAt(0)&&0!==e[1].length)return t.find(S).text(e[0]),-1===e[0].indexOf("/uploads/")?t.find(k).text(": "+e[1]):t.find(k).html(': <a href="'+e[1]+'"> '+e[1].split("/").pop()+"</a>"),t.removeClass(X),t[0]}.bind(this))},_createItemPrice:function(e,t,i){if(e!==t){var s=$(u,i).clone();return $(y,s).html(theme.Currency.formatMoney(e,theme.moneyFormat)),$(f,s).html(theme.Currency.formatMoney(t,theme.moneyFormat)),s.removeClass(X),s[0]}var a=$(T,i).clone();return $(P,a).html(theme.Currency.formatMoney(e,theme.moneyFormat)),a.removeClass(X),a[0]},_createUnitPrice:function(e,t,i){var s=$(Y,i).clone(),a=(1!==t.reference_value?t.reference_value:"")+t.reference_unit;return $(K,s).text(a),$(z,s).html(theme.Currency.formatMoney(e,theme.moneyFormat)),s.removeClass(X),s[0]},_createItemDiscountList:function(e){return $.map(e.line_level_discount_allocations,function(e){var t=this.$itemDiscountTemplate.clone();return t.find(h).text(e.discount_application.title),t.find(p).html(theme.Currency.formatMoney(e.amount,theme.moneyFormat)),t[0]}.bind(this))},_showQuantityErrorMessages:function(e){$(A,e).text(theme.strings.quantityMinimumMessage),$(M,e).removeClass(X),$(j,e).addClass(Z).focus()},_hideQuantityErrorMessage:function(){var e=$(M).addClass(X);$(A,e).text(""),$(j,this.$container).removeClass(Z)},_handleThumbnailClick:function(e){var t=$(e.target).closest(c).data("cart-item-url");window.location.href=t},_onNoteChange:function(e){var t=e.currentTarget.value;this._hideCartError(),this._hideQuantityErrorMessage();var i={url:"/cart/update.js",data:{note:t},dataType:"json"};$.post(i).fail(function(){this._showCartError(e.currentTarget)}.bind(this))},_showCartError:function(e){$(n).text(theme.strings.cartError),$(o).removeClass(X),e.focus()},_hideCartError:function(){$(o).addClass(X),$(n).text("")},_onRemoveItem:function(e){e.preventDefault();var t=$(e.target).closest(c),i=t.attr(ee);this._hideCartError();var s={url:"/cart/change.js",data:{quantity:0,line:i},dataType:"json"};$.post(s).done(function(e){0===e.item_count?this._emptyCart():(this._createCart(e),this._showRemoveMessage(t.clone())),this._setCartCountBubble(e.item_count)}.bind(this)).fail(function(){this._showCartError(null)}.bind(this))},_showRemoveMessage:function(e){var t,i=e.data("cart-item-index"),s=this._getRemoveMessage(e);i-1==0?(t=$('[data-cart-item-index="1"]',this.$container),$(s).insertBefore(t)):(t=$('[data-cart-item-index="'+(i-1)+'"]',this.$container),s.insertAfter(t)),s.focus()},_getRemoveMessage:function(e){var t=this._formatRemoveMessage(e),i=$(V,e).clone();return i.removeClass().addClass(G).attr("colspan","4").html(t),e.attr("role","alert").html(i).attr("tabindex","-1"),e},_formatRemoveMessage:function(e){var t=e.data("cart-item-quantity"),i=e.attr(ae),s=e.attr(se);return theme.strings.removedItemMessage.replace("[quantity]",t).replace("[link]",'<a href="'+i+'" class="text-link text-link--accent">'+s+"</a>")},_setCartCountBubble:function(e){this.$cartCountBubble=this.$cartCountBubble||$(i),this.$cartCount=this.$cartCount||$(t),0<e?(this.$cartCountBubble.removeClass(X),this.$cartCount.html(e)):(this.$cartCountBubble.addClass(X),this.$cartCount.html(""))},_emptyCart:function(){this.$emptyPageContent=this.$emptyPageContent||$(F,this.$container),this.$cartWrapper=this.$cartWrapper||$(R,this.$container),this.$emptyPageContent.removeClass(X),this.$cartWrapper.addClass(X)},cookiesEnabled:function(){var e=navigator.cookieEnabled;return e||(document.cookie="testcookie",e=-1!==document.cookie.indexOf("testcookie")),e}}),oe}(),window.theme=window.theme||{},theme.Filters=function(){var t="screen and (min-width: 750px)",i="#FilterTags",s="#SortBy",e="data-default-sortby";function a(e){var t=this.$container=$(e);this.$filterSelect=$(i,t),this.$sortSelect=$(s,t),this.$selects=$(i,t).add($(s,t)),this.defaultSort=this._getDefaultSortValue(),this.$selects.removeClass("hidden"),this.$filterSelect.on("change",this._onFilterChange.bind(this)),this.$sortSelect.on("change",this._onSortChange.bind(this)),this._initBreakpoints(),this._initParams()}return a.prototype=_.assignIn({},a.prototype,{_initBreakpoints:function(){var e=this;enquire.register(t,{match:function(){slate.utils.resizeSelects(e.$selects)}})},_initParams:function(){if(self.queryParams={},location.search.length)for(var e,t=location.search.substr(1).split("&"),i=0;i<t.length;i++)1<(e=t[i].split("=")).length&&(self.queryParams[decodeURIComponent(e[0])]=decodeURIComponent(e[1]))},_onSortChange:function(){self.queryParams.sort_by=this._getSortValue(),self.queryParams.page&&delete self.queryParams.page,window.location.search=decodeURIComponent($.param(self.queryParams))},_onFilterChange:function(){document.location.href=this._getFilterValue()},_getFilterValue:function(){return this.$filterSelect.val()},_getSortValue:function(){return this.$sortSelect.val()||this.defaultSort},_getDefaultSortValue:function(){return this.$sortSelect.attr(e)},onUnload:function(){this.$filterSelect.off("change",this._onFilterChange),this.$sortSelect.off("change",this._onSortChange)}}),a}(),window.theme=window.theme||{},theme.HeaderSection=function(){function e(){theme.Header.init(),theme.MobileNav.init(),theme.SearchDrawer.init(),theme.Search.init()}return e.prototype=_.assignIn({},e.prototype,{onUnload:function(){theme.Header.unload(),theme.Search.unload()}}),e}(),theme.Maps=function(){var r=14,t=null,i=[],n={addressNoResults:theme.strings.addressNoResults,addressQueryLimit:theme.strings.addressQueryLimit,addressError:theme.strings.addressError,authError:theme.strings.authError},e='[data-section-type="map"]',s="[data-map]",a="[data-map-overlay]",o="map-section--load-error",c="map-section__error errors text-center";function l(e){this.$container=$(e),this.$map=this.$container.find(s),this.key=this.$map.data("api-key"),void 0!==this.key&&("loaded"===t?this.createMap():(i.push(this),"loading"!==t&&(t="loading",void 0===window.google&&$.getScript("https://maps.googleapis.com/maps/api/js?key="+this.key).then(function(){t="loaded",$.each(i,function(e,t){t.createMap()})}))))}return window.gm_authFailure=function(){Shopify.designMode&&($(e).addClass(o),$(s).remove(),$(a).after('<div class="'+c+'">'+theme.strings.authError+"</div>"))},l.prototype=_.assignIn({},l.prototype,{createMap:function(){var e,i,t,s,a=this.$map;return e=a,i=$.Deferred(),t=new google.maps.Geocoder,s=e.data("address-setting"),t.geocode({address:s},function(e,t){t!==google.maps.GeocoderStatus.OK&&i.reject(t),i.resolve(e)}),i.then(function(e){var t={zoom:r,center:e[0].geometry.location,draggable:!1,clickableIcons:!1,scrollwheel:!1,disableDoubleClickZoom:!0,disableDefaultUI:!0},i=this.map=new google.maps.Map(a[0],t),s=this.center=i.getCenter();new google.maps.Marker({map:i,position:i.getCenter()});google.maps.event.addDomListener(window,"resize",$.debounce(250,function(){google.maps.event.trigger(i,"resize"),i.setCenter(s),a.removeAttr("style")}))}.bind(this)).fail(function(){var e;switch(status){case"ZERO_RESULTS":e=n.addressNoResults;break;case"OVER_QUERY_LIMIT":e=n.addressQueryLimit;break;case"REQUEST_DENIED":e=n.authError;break;default:e=n.addressError}Shopify.designMode&&a.parent().addClass(o).html('<div class="'+c+'">'+e+"</div>")})},onUnload:function(){0!==this.$map.length&&google.maps.event.clearListeners(this.map,"resize")}}),l}(),theme.Product=function(){function e(e){var t=this.$container=$(e),i=t.attr("data-section-id");this.ajaxEnabled=t.data("ajax-enabled"),this.settings={mediaQueryMediumUp:"screen and (min-width: 750px)",mediaQuerySmall:"screen and (max-width: 749px)",bpSmall:!1,enableHistoryState:t.data("enable-history-state")||!1,namespace:".slideshow-"+i,sectionId:i,sliderActive:!1,zoomEnabled:!1},this.selectors={addToCart:"[data-add-to-cart]",addToCartText:"[data-add-to-cart-text]",cartCount:"[data-cart-count]",cartCountBubble:"[data-cart-count-bubble]",cartPopup:"[data-cart-popup]",cartPopupCartQuantity:"[data-cart-popup-cart-quantity]",cartPopupClose:"[data-cart-popup-close]",cartPopupDismiss:"[data-cart-popup-dismiss]",cartPopupImage:"[data-cart-popup-image]",cartPopupImageWrapper:"[data-cart-popup-image-wrapper]",cartPopupImagePlaceholder:"[data-cart-popup-image-placeholder]",cartPopupPlaceholderSize:"[data-placeholder-size]",cartPopupProductDetails:"[data-cart-popup-product-details]",cartPopupQuantity:"[data-cart-popup-quantity]",cartPopupQuantityLabel:"[data-cart-popup-quantity-label]",cartPopupTitle:"[data-cart-popup-title]",cartPopupWrapper:"[data-cart-popup-wrapper]",loader:"[data-loader]",loaderStatus:"[data-loader-status]",quantity:"[data-quantity-input]",SKU:".variant-sku",productStatus:"[data-product-status]",originalSelectorId:"#ProductSelect-"+i,productForm:"[data-product-form]",errorMessage:"[data-error-message]",errorMessageWrapper:"[data-error-message-wrapper]",imageZoomWrapper:"[data-image-zoom-wrapper]",productMediaWrapper:"[data-product-single-media-wrapper]",productThumbImages:".product-single__thumbnail--"+i,productThumbs:".product-single__thumbnails-"+i,productThumbListItem:".product-single__thumbnails-item",productThumbsWrapper:".thumbnails-wrapper",saleLabel:".product-price__sale-label-"+i,singleOptionSelector:".single-option-selector-"+i,shopifyPaymentButton:".shopify-payment-button",productMediaTypeVideo:"[data-product-media-type-video]",productMediaTypeModel:"[data-product-media-type-model]",priceContainer:"[data-price]",regularPrice:"[data-regular-price]",salePrice:"[data-sale-price]",unitPrice:"[data-unit-price]",unitPriceBaseUnit:"[data-unit-price-base-unit]",productPolicies:"[data-product-policies]"},this.classes={cartPopupWrapperHidden:"cart-popup-wrapper--hidden",hidden:"hide",visibilityHidden:"visibility-hidden",inputError:"input--error",jsZoomEnabled:"js-zoom-enabled",productOnSale:"price--on-sale",productUnitAvailable:"price--unit-available",productUnavailable:"price--unavailable",productSoldOut:"price--sold-out",cartImage:"cart-popup-item__image",productFormErrorMessageWrapperHidden:"product-form__error-message-wrapper--hidden",activeClass:"active-thumb",variantSoldOut:"product-form--variant-sold-out"},this.$quantityInput=$(this.selectors.quantity,t),this.$errorMessageWrapper=$(this.selectors.errorMessageWrapper,t),this.$addToCart=$(this.selectors.addToCart,t),this.$addToCartText=$(this.selectors.addToCartText,this.$addToCart),this.$shopifyPaymentButton=$(this.selectors.shopifyPaymentButton,t),this.$productPolicies=$(this.selectors.productPolicies,t),this.$loader=$(this.selectors.loader,this.$addToCart),this.$loaderStatus=$(this.selectors.loaderStatus,t),$("#ProductJson-"+i).html()&&(this.productSingleObject=JSON.parse(document.getElementById("ProductJson-"+i).innerHTML),this.settings.zoomEnabled=$(this.selectors.imageZoomWrapper).hasClass(this.classes.jsZoomEnabled),this._initBreakpoints(),this._stringOverrides(),this._initVariants(),this._initMediaSwitch(),this._initAddToCart(),this._setActiveThumbnail(),this._initProductVideo(),this._initModelViewerLibraries(),this._initShopifyXrLaunch())}return e.prototype=_.assignIn({},e.prototype,{_stringOverrides:function(){theme.productStrings=theme.productStrings||{},$.extend(theme.strings,theme.productStrings)},_initBreakpoints:function(){var e=this;enquire.register(this.settings.mediaQuerySmall,{match:function(){4<$(e.selectors.productThumbImages).length&&e._initThumbnailSlider(),e.settings.zoomEnabled&&$(e.selectors.imageZoomWrapper).each(function(){$(this).trigger("zoom.destroy")}),e.settings.bpSmall=!0},unmatch:function(){e.settings.sliderActive&&e._destroyThumbnailSlider(),e.settings.bpSmall=!1}}),enquire.register(this.settings.mediaQueryMediumUp,{match:function(){e.settings.zoomEnabled&&$(e.selectors.imageZoomWrapper).each(function(){var e,t;e=this,t=$(e).data("zoom"),$(e).zoom({url:t})})}})},_initVariants:function(){var e={$container:this.$container,enableHistoryState:this.$container.data("enable-history-state")||!1,singleOptionSelector:this.selectors.singleOptionSelector,originalSelectorId:this.selectors.originalSelectorId,product:this.productSingleObject};this.variants=new slate.Variants(e),this.$container.on("variantChange"+this.settings.namespace,this._updateAvailability.bind(this)),this.$container.on("variantImageChange"+this.settings.namespace,this._updateMedia.bind(this)),this.$container.on("variantPriceChange"+this.settings.namespace,this._updatePrice.bind(this)),this.$container.on("variantSKUChange"+this.settings.namespace,this._updateSKU.bind(this))},_initMediaSwitch:function(){var i;$(this.selectors.productThumbImages).length&&(i=this,$(this.selectors.productThumbImages).on("click",function(e){e.preventDefault();var t=$(this).data("thumbnail-id");i._switchMedia(t),i._setActiveThumbnail(t)}).on("keyup",i._handleMediaFocus.bind(i)))},_initAddToCart:function(){$(this.selectors.productForm,this.$container).on("submit",function(e){var t,i;this.$addToCart.is("[aria-disabled]")?e.preventDefault():this.ajaxEnabled&&(e.preventDefault(),this.$previouslyFocusedElement=$(":focus"),(t=this.$quantityInput.val()<=0)?this._showErrorMessage(theme.strings.quantityMinimumMessage):t||!this.ajaxEnabled||(this._handleButtonLoadingState(!0),i=$(this.selectors.productForm,this.$container),this._addItemToCart(i)))}.bind(this))},_initProductVideo:function(){var t=this.settings.sectionId;$(this.selectors.productMediaTypeVideo,this.$container).each(function(){var e=$(this);theme.ProductVideo.init(e,t)})},_initModelViewerLibraries:function(){var e=$(this.selectors.productMediaTypeModel,this.$container);e.length<1||theme.ProductModel.init(e,this.settings.sectionId)},_initShopifyXrLaunch:function(){var e=this;$(document).on("shopify_xr_launch",function(){$(e.selectors.productMediaWrapper+":not(."+e.classes.hidden+")",e.$container).trigger("xrLaunch")})},_addItemToCart:function(e){var t={url:"/cart/add.js",data:$(e).serialize(),dataType:"json"};$.post(t).done(function(e){this._hideErrorMessage(),this._setupCartPopup(e)}.bind(this)).fail(function(e){this.$previouslyFocusedElement.focus();var t=e.responseJSON?e.responseJSON.description:theme.strings.cartError;this._showErrorMessage(t),this._handleButtonLoadingState(!1)}.bind(this))},_handleButtonLoadingState:function(e){e?(this.$addToCart.attr("aria-disabled",!0),this.$addToCartText.addClass(this.classes.hidden),this.$loader.removeClass(this.classes.hidden),this.$shopifyPaymentButton.attr("disabled",!0),this.$loaderStatus.attr("aria-hidden",!1)):(this.$addToCart.removeAttr("aria-disabled"),this.$addToCartText.removeClass(this.classes.hidden),this.$loader.addClass(this.classes.hidden),this.$shopifyPaymentButton.removeAttr("disabled"),this.$loaderStatus.attr("aria-hidden",!0))},_showErrorMessage:function(e){$(this.selectors.errorMessage,this.$container).html(e),0!==this.$quantityInput.length&&this.$quantityInput.addClass(this.classes.inputError),this.$errorMessageWrapper.removeClass(this.classes.productFormErrorMessageWrapperHidden).attr("aria-hidden",!0).removeAttr("aria-hidden")},_hideErrorMessage:function(){this.$errorMessageWrapper.addClass(this.classes.productFormErrorMessageWrapperHidden),0!==this.$quantityInput.length&&this.$quantityInput.removeClass(this.classes.inputError)},_setupCartPopup:function(e){this.$cartPopup=this.$cartPopup||$(this.selectors.cartPopup),this.$cartPopupWrapper=this.$cartPopupWrapper||$(this.selectors.cartPopupWrapper),this.$cartPopupTitle=this.$cartPopupTitle||$(this.selectors.cartPopupTitle),this.$cartPopupQuantity=this.$cartPopupQuantity||$(this.selectors.cartPopupQuantity),this.$cartPopupQuantityLabel=this.$cartPopupQuantityLabel||$(this.selectors.cartPopupQuantityLabel),this.$cartPopupClose=this.$cartPopupClose||$(this.selectors.cartPopupClose),this.$cartPopupDismiss=this.$cartPopupDismiss||$(this.selectors.cartPopupDismiss),this.$cartPopupImagePlaceholder=this.$cartPopupImagePlaceholder||$(this.selectors.cartPopupImagePlaceholder),this._setupCartPopupEventListeners(),this._updateCartPopupContent(e)},_updateCartPopupContent:function(e){var t=this.$quantityInput.length?this.$quantityInput.val():1;this.$cartPopupTitle.text(e.product_title),this.$cartPopupQuantity.text(t),this.$cartPopupQuantityLabel.text(theme.strings.quantityLabel.replace("[count]",t)),this._setCartPopupPlaceholder(e.featured_image.url,e.featured_image.aspect_ratio),this._setCartPopupImage(e.featured_image.url,e.featured_image.alt),this._setCartPopupProductDetails(e.product_has_only_default_variant,e.options_with_values,e.properties),$.getJSON("/cart.js").then(function(e){this._setCartQuantity(e.item_count),this._setCartCountBubble(e.item_count),this._showCartPopup()}.bind(this))},_setupCartPopupEventListeners:function(){this.$cartPopupWrapper.on("keyup",function(e){e.keyCode===slate.utils.keyboardKeys.ESCAPE&&this._hideCartPopup(e)}.bind(this)),this.$cartPopupClose.on("click",this._hideCartPopup.bind(this)),this.$cartPopupDismiss.on("click",this._hideCartPopup.bind(this)),$("body").on("click",this._onBodyClick.bind(this))},_setCartPopupPlaceholder:function(e,t){var i,s,a;this.$cartPopupImageWrapper=this.$cartPopupImageWrapper||$(this.selectors.cartPopupImageWrapper),null!==e?(i=$(this.selectors.cartPopupPlaceholderSize),s=95*t,a=100/t,this.$cartPopupImagePlaceholder.css("max-width",s),i.css("padding-top",a+"%")):this.$cartPopupImageWrapper.addClass(this.classes.hidden)},_setCartPopupImage:function(e,t){var i,s;null!==e&&(this.$cartPopupImageWrapper.removeClass(this.classes.hidden),i=theme.Images.getSizedImageUrl(e,"200x"),(s=document.createElement("img")).src=i,s.alt=t,s.classList.add(this.classes.cartImage),s.dataset.cartPopupImage="",s.onload=function(){this.$cartPopupImagePlaceholder.addClass(this.classes.hidden),this.$cartPopupImageWrapper.append(s)}.bind(this))},_setCartPopupProductDetails:function(e,t,i){this.$cartPopupProductDetails=this.$cartPopupProductDetails||$(this.selectors.cartPopupProductDetails);var s="";e||(s+=this._getVariantOptionList(t)),null!==i&&0!==Object.keys(i).length&&(s+=this._getPropertyList(i)),0===s.length?(this.$cartPopupProductDetails.html(""),this.$cartPopupProductDetails.attr("hidden","")):(this.$cartPopupProductDetails.html(s),this.$cartPopupProductDetails.removeAttr("hidden"))},_getVariantOptionList:function(e){var t="";return e.forEach(function(e){t=t+'<li class="product-details__item product-details__item--variant-option">'+e.name+": "+e.value+"</li>"}),t},_getPropertyList:function(e){var t="";return Object.entries(e).forEach(function(e){"_"!==e[0].charAt(0)&&0!==e[1].length&&(t=t+'<li class="product-details__item product-details__item--property"><span class="product-details__property-label">'+e[0]+": </span>"+e[1])}),t},_setCartQuantity:function(e){var t;this.$cartPopupCartQuantity=this.$cartPopupCartQuantity||$(this.selectors.cartPopupCartQuantity),1===e?t=theme.strings.oneCartCount:1<e&&(t=theme.strings.otherCartCount.replace("[count]",e)),this.$cartPopupCartQuantity.text(e).attr("aria-label",t)},_setCartCountBubble:function(e){this.$cartCountBubble=this.$cartCountBubble||$(this.selectors.cartCountBubble),this.$cartCount=this.$cartCount||$(this.selectors.cartCount),this.$cartCountBubble.removeClass(this.classes.hidden),this.$cartCount.text(e)},_showCartPopup:function(){this.$cartPopupWrapper.prepareTransition().removeClass(this.classes.cartPopupWrapperHidden),this._handleButtonLoadingState(!1),slate.a11y.trapFocus({$container:this.$cartPopupWrapper,$elementToFocus:this.$cartPopup,namespace:"cartPopupFocus"})},_hideCartPopup:function(e){var t=0===e.detail;this.$cartPopupWrapper.prepareTransition().addClass(this.classes.cartPopupWrapperHidden),$(this.selectors.cartPopupImage).remove(),this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden),slate.a11y.removeTrapFocus({$container:this.$cartPopupWrapper,namespace:"cartPopupFocus"}),t&&this.$previouslyFocusedElement[0].focus(),this.$cartPopupWrapper.off("keyup"),this.$cartPopupClose.off("click"),this.$cartPopupDismiss.off("click"),$("body").off("click")},_onBodyClick:function(e){var t=$(e.target);t[0]===this.$cartPopupWrapper[0]||t.parents(this.selectors.cartPopup).length||this._hideCartPopup(e)},_setActiveThumbnail:function(e){void 0===e&&(e=$(this.selectors.productMediaWrapper+":not(.hide)",this.$container).data("media-id"));var t,i=$(this.selectors.productThumbListItem+":not(.slick-cloned)",this.$container),s=i.find(this.selectors.productThumbImages+"[data-thumbnail-id='"+e+"']");$(this.selectors.productThumbImages).removeClass(this.classes.activeClass).removeAttr("aria-current"),s.addClass(this.classes.activeClass),s.attr("aria-current",!0),i.hasClass("slick-slide")&&(t=s.parent().data("slick-index"),$(this.selectors.productThumbs).slick("slickGoTo",t,!0))},_switchMedia:function(e){var t=$(this.selectors.productMediaWrapper+":not(."+this.classes.hidden+")",this.$container),i=$(this.selectors.productMediaWrapper+"[data-media-id='"+e+"']",this.$container),s=$(this.selectors.productMediaWrapper+":not([data-media-id='"+e+"'])",this.$container);t.trigger("mediaHidden"),i.removeClass(this.classes.hidden).trigger("mediaVisible"),s.addClass(this.classes.hidden)},_handleMediaFocus:function(e){var t;e.keyCode===slate.utils.keyboardKeys.ENTER&&(t=$(e.currentTarget).data("thumbnail-id"),$(this.selectors.productMediaWrapper+"[data-media-id='"+t+"']",this.$container).focus())},_initThumbnailSlider:function(){var e={slidesToShow:3,slidesToScroll:2,infinite:!1,prevArrow:".thumbnails-slider__prev--"+this.settings.sectionId,nextArrow:".thumbnails-slider__next--"+this.settings.sectionId};$(this.selectors.productThumbs).slick(e),$(this.selectors.productThumbsWrapper,this.$container).find(".slick-list").removeAttr("aria-live"),$(this.selectors.productThumbsWrapper,this.$container).find(".slick-disabled").removeAttr("aria-disabled"),this.settings.sliderActive=!0},_destroyThumbnailSlider:function(){$(this.selectors.productThumbs).slick("unslick"),this.settings.sliderActive=!1,$(this.selectors.productThumbsWrapper,this.$container).find('[tabindex="-1"]').removeAttr("tabindex")},_liveRegionText:function(e){var t="[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";if(!e)return t=theme.strings.unavailable;var i=e.available?"":theme.strings.soldOut+",",t=t.replace("[Availability]",i),s="",a=theme.Currency.formatMoney(e.price,theme.moneyFormat),r="",n="",o="",c="";return e.compare_at_price>e.price&&(s=theme.strings.regularPrice,a=theme.Currency.formatMoney(e.compare_at_price,theme.moneyFormat)+",",r=theme.strings.sale,n=theme.Currency.formatMoney(e.price,theme.moneyFormat)),e.unit_price&&(o=theme.strings.unitPrice,c=theme.Currency.formatMoney(e.unit_price,theme.moneyFormat)+" "+theme.strings.unitPriceSeparator+" "+this._getBaseUnit(e)),t=t.replace("[Regular]",s).replace("[$$]",a).replace("[Sale]",r).replace("[$]",n).replace("[UnitPrice]",o).replace("[$$$]",c).trim()},_updateLiveRegion:function(e){var t=e.variant,i=this.container.querySelector(this.selectors.productStatus);i.innerHTML=this._liveRegionText(t),i.setAttribute("aria-hidden",!1),setTimeout(function(){i.setAttribute("aria-hidden",!0)},1e3)},_updateAddToCart:function(e){var t=e.variant;t?t.available?(this.$addToCart.removeAttr("aria-disabled").attr("aria-label",theme.strings.addToCart),$(this.selectors.addToCartText,this.$container).text(theme.strings.addToCart),$(this.selectors.productForm,this.container).removeClass(this.classes.variantSoldOut)):(this.$addToCart.attr("aria-disabled",!0).attr("aria-label",theme.strings.soldOut),$(this.selectors.addToCartText,this.$container).text(theme.strings.soldOut),$(this.selectors.productForm,this.container).addClass(this.classes.variantSoldOut)):(this.$addToCart.attr("aria-disabled",!0).attr("aria-label",theme.strings.unavailable),$(this.selectors.addToCartText,this.$container).text(theme.strings.unavailable),$(this.selectors.productForm,this.container).addClass(this.classes.variantSoldOut))},_updateAvailability:function(e){this._hideErrorMessage(),this._updateAddToCart(e),this._updateLiveRegion(e),this._updatePrice(e)},_updateMedia:function(e){var t=e.variant.featured_media.id,i=this.settings.sectionId+"-"+t;this._switchMedia(i),this._setActiveThumbnail(i)},_updatePrice:function(e){var t=e.variant,i=$(this.selectors.priceContainer,this.$container),s=$(this.selectors.regularPrice,i),a=$(this.selectors.salePrice,i),r=$(this.selectors.unitPrice,i),n=$(this.selectors.unitPriceBaseUnit,i);if(i.removeClass(this.classes.productUnavailable).removeClass(this.classes.productOnSale).removeClass(this.classes.productUnitAvailable).removeClass(this.classes.productSoldOut).removeAttr("aria-hidden"),this.$productPolicies.removeClass(this.classes.visibilityHidden),!t)return i.addClass(this.classes.productUnavailable).attr("aria-hidden",!0),void this.$productPolicies.addClass(this.classes.visibilityHidden);t.available||i.addClass(this.classes.productSoldOut),t.compare_at_price>t.price?(s.html(theme.Currency.formatMoney(t.compare_at_price,theme.moneyFormat)),a.html(theme.Currency.formatMoney(t.price,theme.moneyFormat)),i.addClass(this.classes.productOnSale)):s.html(theme.Currency.formatMoney(t.price,theme.moneyFormat)),t.unit_price&&(r.html(theme.Currency.formatMoney(t.unit_price,theme.moneyFormat)),n.html(this._getBaseUnit(t)),i.addClass(this.classes.productUnitAvailable))},_getBaseUnit:function(e){return 1===e.unit_price_measurement.reference_value?e.unit_price_measurement.reference_unit:e.unit_price_measurement.reference_value+e.unit_price_measurement.reference_unit},_updateSKU:function(e){var t=e.variant;$(this.selectors.SKU).html(t.sku)},onUnload:function(){this.$container.off(this.settings.namespace),theme.ProductVideo.removeSectionVideos(this.settings.sectionId),theme.ProductModel.removeSectionModels(this.settings.sectionId)}}),e}(),theme.ProductRecommendations=function(e){this.$container=$(e);var t=this.$container.data("baseUrl")+"?section_id=product-recommendations&product_id="+this.$container.data("productId")+"&limit=4";$.get(t).then(function(e){var t=$(e).html();""!==t.trim()&&this.$container.html(t)}.bind(this))},theme.Quotes=function(){var o={mediaQuerySmall:"screen and (max-width: 749px)",mediaQueryMediumUp:"screen and (min-width: 750px)",slideCount:0},c={accessibility:!0,arrows:!1,dots:!0,autoplay:!1,touchThreshold:20,slidesToShow:3,slidesToScroll:3};function e(e){var t=(this.$container=$(e)).attr("data-section-id"),i=(this.wrapper=".quotes-wrapper",this.slider="#Quotes-"+t),s=$(i,".quotes-wrapper"),a=!1,r=$.extend({},c,{slidesToShow:1,slidesToScroll:1,adaptiveHeight:!0});function n(e,t){a&&(e.slick("unslick"),a=!1),e.slick(t),a=!0}o.slideCount=s.data("count"),o.slideCount<c.slidesToShow&&(c.slidesToShow=o.slideCount,c.slidesToScroll=o.slideCount),s.on("init",this.a11y.bind(this)),enquire.register(o.mediaQuerySmall,{match:function(){n(s,r)}}),enquire.register(o.mediaQueryMediumUp,{match:function(){n(s,c)}})}return e.prototype=_.assignIn({},e.prototype,{onUnload:function(){enquire.unregister(o.mediaQuerySmall),enquire.unregister(o.mediaQueryMediumUp),$(this.slider,this.wrapper).slick("unslick")},onBlockSelect:function(e){var t=$(".quotes-slide--"+e.detail.blockId+":not(.slick-cloned)").data("slick-index");$(this.slider,this.wrapper).slick("slickGoTo",t)},a11y:function(e,t){var i=t.$list,s=$(this.wrapper,this.$container);i.removeAttr("aria-live"),s.on("focusin",function(e){s.has(e.target).length&&i.attr("aria-live","polite")}),s.on("focusout",function(e){s.has(e.target).length&&i.removeAttr("aria-live")})}}),e}(),theme.slideshows={},theme.SlideshowSection=function(e){var t=(this.$container=$(e)).attr("data-section-id"),i=this.slideshow="#Slideshow-"+t;theme.slideshows[i]=new theme.Slideshow(i,t)},theme.SlideshowSection.prototype=_.assignIn({},theme.SlideshowSection.prototype,{onUnload:function(){delete theme.slideshows[this.slideshow]},onBlockSelect:function(e){var t=$(this.slideshow);t.data("adapt-height")&&theme.slideshows[this.slideshow].setSlideshowHeight();var i=$(".slideshow__slide--"+e.detail.blockId+":not(.slick-cloned)").data("slick-index");t.slick("slickGoTo",i).slick("slickPause")},onBlockDeselect:function(){$(this.slideshow).slick("slickPlay")}}),theme.slideshows={},theme.VideoSection=function(e){var t=this.$container=$(e);$(".video",t).each(function(){var e=$(this);theme.Video.init(e),theme.Video.editorLoadVideo(e.attr("id"))})},theme.VideoSection.prototype=_.assignIn({},theme.VideoSection.prototype,{onUnload:function(){theme.Video.removeEvents()}}),theme.heros={},theme.HeroSection=function(e){var t=(this.$container=$(e)).attr("data-section-id"),i="#Hero-"+t;theme.heros[i]=new theme.Hero(i,t)},window.theme=window.theme||{};var selectors={disclosureLocale:"[data-disclosure-locale]",disclosureCurrency:"[data-disclosure-currency]"};function onYouTubeIframeAPIReady(){theme.Video.loadVideos(),theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube)}theme.FooterSection=function(){function e(e){this.$container=$(e),this.cache={},this.cacheSelectors(),this.cache.$localeDisclosure.length&&(this.localeDisclosure=new theme.Disclosure(this.cache.$localeDisclosure)),this.cache.$currencyDisclosure.length&&(this.currencyDisclosure=new theme.Disclosure(this.cache.$currencyDisclosure))}return e.prototype=_.assignIn({},e.prototype,{cacheSelectors:function(){this.cache={$localeDisclosure:this.$container.find(selectors.disclosureLocale),$currencyDisclosure:this.$container.find(selectors.disclosureCurrency)}},onUnload:function(){this.cache.$localeDisclosure.length&&this.localeDisclosure.unload(),this.cache.$currencyDisclosure.length&&this.currencyDisclosure.unload()}}),e}(),$(document).ready(function(){var e=new theme.Sections;e.register("cart-template",theme.Cart),e.register("product",theme.Product),e.register("collection-template",theme.Filters),e.register("product-template",theme.Product),e.register("header-section",theme.HeaderSection),e.register("map",theme.Maps),e.register("slideshow-section",theme.SlideshowSection),e.register("video-section",theme.VideoSection),e.register("quotes",theme.Quotes),e.register("hero-section",theme.HeroSection),e.register("product-recommendations",theme.ProductRecommendations),e.register("footer-section",theme.FooterSection)}),theme.init=function(){theme.customerTemplates.init();slate.rte.wrapTable({$tables:$(".rte table,.custom__item-inner--html table"),tableWrapperClass:"scrollable-wrapper"});slate.rte.wrapIframe({$iframes:$('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]'),iframeWrapperClass:"video-wrapper"}),slate.a11y.pageLinkFocus($(window.location.hash)),$(".in-page-link").on("click",function(e){slate.a11y.pageLinkFocus($(e.currentTarget.hash))}),$('a[href="#"]').on("click",function(e){e.preventDefault()}),slate.a11y.accessibleLinks({messages:{newWindow:theme.strings.newWindow,external:theme.strings.external,newWindowExternal:theme.strings.newWindowExternal},$links:$("a[href]:not([aria-describedby], .product-single__thumbnail)")}),theme.FormStatus.init();var r="[data-image]",n="[data-image-placeholder]",o="[data-image-with-placeholder-wrapper]",c=".lazyloaded",l="hide";$(document).on("lazyloaded",function(e){var t,i,s,a=$(e.target);!a.data("bgset")||(t=a.find(c)).length&&(i=a.data("alt"),s=t.data("src")?t.data("src"):a.data("bg"),t.attr("alt",i||""),t.attr("src",s||"")),a.is(r)&&a.closest(o).find(n).addClass(l)}),$(r+".lazyloaded").closest(o).find(n).addClass(l),$(document).one("touchstart",function(){theme.Helpers.setTouch()})},$(theme.init);
*/
(window.theme = window.theme || {}),
  (window.theme = window.theme || {}),
  (theme.Sections = function () {
  (this.constructors = {}),
    (this.instances = []),
    $(document)
  .on("shopify:section:load", this._onSectionLoad.bind(this))
  .on("shopify:section:unload", this._onSectionUnload.bind(this))
  .on("shopify:section:select", this._onSelect.bind(this))
  .on("shopify:section:deselect", this._onDeselect.bind(this))
  .on("shopify:block:select", this._onBlockSelect.bind(this))
  .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
}),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (e, t) {
    var i,
        s = $(e),
        a = s.attr("data-section-id"),
        r = s.attr("data-section-type");
    (t = t || this.constructors[r]), _.isUndefined(t) || ((i = _.assignIn(new t(e), { id: a, type: r, container: e })), this.instances.push(i));
  },
  _onSectionLoad: function (e) {
    var t = $("[data-section-id]", e.target)[0];
    t && this._createInstance(t);
  },
  _onSectionUnload: function (i) {
    this.instances = _.filter(this.instances, function (e) {
      var t = e.id === i.detail.sectionId;
      return t && _.isFunction(e.onUnload) && e.onUnload(i), !t;
    });
  },
  _onSelect: function (t) {
    var e = _.find(this.instances, function (e) {
      return e.id === t.detail.sectionId;
    });
    !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t);
  },
  _onDeselect: function (t) {
    var e = _.find(this.instances, function (e) {
      return e.id === t.detail.sectionId;
    });
    !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t);
  },
  _onBlockSelect: function (t) {
    var e = _.find(this.instances, function (e) {
      return e.id === t.detail.sectionId;
    });
    !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t);
  },
  _onBlockDeselect: function (t) {
    var e = _.find(this.instances, function (e) {
      return e.id === t.detail.sectionId;
    });
    !_.isUndefined(e) && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t);
  },
  register: function (e, i) {
    (this.constructors[e] = i),
      $("[data-section-type=" + e + "]").each(
      function (e, t) {
        this._createInstance(t, i);
      }.bind(this)
    );
  },
})),
  (window.slate = window.slate || {}),
  (slate.utils = {
  getParameterByName: function (e, t) {
    (t = t || window.location.href), (e = e.replace(/[[\]]/g, "\\$&"));
    var i = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
    return i ? (i[2] ? decodeURIComponent(i[2].replace(/\+/g, " ")) : "") : null;
  },
  resizeSelects: function (e) {
    e.each(function () {
      var e = $(this),
          t = e.find("option:selected").text(),
          i = $("<span>").html(t);
      i.appendTo("body");
      var s = i.width();
      i.remove(), e.width(s + 10);
    });
  },
  keyboardKeys: { TAB: 9, ENTER: 13, ESCAPE: 27, LEFTARROW: 37, RIGHTARROW: 39 },
}),
  (window.slate = window.slate || {}),
  (slate.rte = {
  wrapTable: function (e) {
    e.$tables.wrap('<div class="' + e.tableWrapperClass + '"></div>');
  },
  wrapIframe: function (e) {
    e.$iframes.each(function () {
      $(this).wrap('<div class="' + e.iframeWrapperClass + '"></div>'), this.src;
    });
  },
}),
  (window.slate = window.slate || {}),
  (slate.a11y = {
  pageLinkFocus: function (e) {
    var t = "js-focus-hidden";
    e.first()
    .attr("tabIndex", "-1")
    .focus()
    .addClass(t)
    .one("blur", function () {
      e.first().removeClass(t).removeAttr("tabindex");
    });
  },
  focusHash: function () {
    var e = window.location.hash;
    e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
  },
  bindInPageLinks: function () {
    $("a[href*=#]").on(
      "click",
      function (e) {
        this.pageLinkFocus($(e.currentTarget.hash));
      }.bind(this)
    );
  },
  trapFocus: function (e) {
    var t = { focusin: e.namespace ? "focusin." + e.namespace : "focusin", focusout: e.namespace ? "focusout." + e.namespace : "focusout", keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus" },
        i = e.$container.find($('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(":visible")),
        s = i[0],
        a = i[i.length - 1];
    e.$elementToFocus || (e.$elementToFocus = e.$container),
      e.$container.attr("tabindex", "-1"),
      e.$elementToFocus.focus(),
      $(document).off("focusin"),
      $(document).on(t.focusout, function () {
      $(document).off(t.keydown);
    }),
      $(document).on(t.focusin, function (e) {
      (e.target !== a && e.target !== s) ||
        $(document).on(t.keydown, function (e) {
        var t;
        (t = e).keyCode === slate.utils.keyboardKeys.TAB && (t.target !== a || t.shiftKey || (t.preventDefault(), s.focus()), t.target === s && t.shiftKey && (t.preventDefault(), a.focus()));
      });
    });
  },
  removeTrapFocus: function (e) {
    var t = e.namespace ? "focusin." + e.namespace : "focusin";
    e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t);
  },
  accessibleLinks: function (e) {
    var r = document.querySelector("body"),
        o = { newWindow: "a11y-new-window-message", external: "a11y-external-message", newWindowExternal: "a11y-new-window-external-message" };
    (void 0 !== e.$links && e.$links.jquery) || (e.$links = $("a[href]:not([aria-describedby])")),
      $.each(e.$links, function () {
      var e,
          t,
          i = $(this),
          s = i.attr("target"),
          a = i.attr("rel"),
          r = ((e = i), (t = window.location.hostname), e[0].hostname !== t),
          n = "_blank" === s;
      r && i.attr("aria-describedby", o.external),
        n &&
        ((void 0 !== a && -1 !== a.indexOf("noopener")) ||
        i.attr("rel", function (e, t) {
        return (void 0 === t ? "" : t + " ") + "noopener";
      }),
        i.attr("aria-describedby", o.newWindow)),
        r && n && i.attr("aria-describedby", o.newWindowExternal);
    }),
      (function (e) {
      "object" != typeof e && (e = {});
      var t = $.extend({ newWindow: "Opens in a new window.", external: "Opens external website.", newWindowExternal: "Opens external website in a new window." }, e),
          i = document.createElement("ul"),
          s = "";
      for (var a in t) s += "<li id=" + o[a] + ">" + t[a] + "</li>";
      i.setAttribute("hidden", !0), (i.innerHTML = s), r.appendChild(i);
    })(e.messages);
  },
}),
  (theme.Images = {
  preload: function (e, t) {
    "string" == typeof e && (e = [e]);
    for (var i = 0; i < e.length; i++) {
      var s = e[i];
      this.loadImage(this.getSizedImageUrl(s, t));
    }
  },
  loadImage: function (e) {
    new Image().src = e;
  },
  switchImage: function (e, t, i) {
    var s = this.imageSize(t.src),
        a = this.getSizedImageUrl(e.src, s);
    i ? i(a, e, t) : (t.src = a);
  },
  imageSize: function (e) {
    var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
    return null !== t ? (void 0 !== t[2] ? t[1] + t[2] : t[1]) : null;
  },
  getSizedImageUrl: function (e, t) {
    if (null === t) return e;
    if ("master" === t) return this.removeProtocol(e);
    var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null === i) return null;
    var s = e.split(i[0]),
        a = i[0];
    return this.removeProtocol(s[0] + "_" + t + a);
  },
  removeProtocol: function (e) {
    return e.replace(/http(s)?:/, "");
  },
}),
  (theme.Currency = {
  formatMoney: function (e, t) {
    "string" == typeof e && (e = e.replace(".", ""));
    var i = "",
        s = /\{\{\s*(\w+)\s*\}\}/,
        a = t || "${{amount}}";
    function r(e, t, i, s) {
      if (((i = i || ","), (s = s || "."), isNaN(e) || null === e)) return 0;
      var a = (e = (e / 100).toFixed(t)).split(".");
      return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? s + a[1] : "");
    }
    switch (a.match(s)[1]) {
      case "amount":
        i = r(e, 2);
        break;
      case "amount_no_decimals":
        i = r(e, 0);
        break;
      case "amount_with_comma_separator":
        i = r(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = r(e, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        i = r(e, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        i = r(e, 2, "'");
    }
    return a.replace(s, i);
  },
}),
  (slate.Variants = (function () {
  function e(e) {
    (this.$container = e.$container),
      (this.product = e.product),
      (this.singleOptionSelector = e.singleOptionSelector),
      (this.originalSelectorId = e.originalSelectorId),
      (this.enableHistoryState = e.enableHistoryState),
      (this.currentVariant = this._getVariantFromOptions()),
      $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
  }
  return (
    (e.prototype = _.assignIn({}, e.prototype, {
      _getCurrentOptions: function () {
        var e = _.map($(this.singleOptionSelector, this.$container), function (e) {
          var t = $(e),
              i = t.attr("type"),
              s = {};
          return (("radio" !== i && "checkbox" !== i) || !!t[0].checked) && ((s.value = t.val()), (s.index = t.data("index")), s);
        });
        return (e = _.compact(e));
      },
      _getVariantFromOptions: function () {
        var e = this._getCurrentOptions(),
            t = this.product.variants;
        return _.find(t, function (t) {
          return e.every(function (e) {
            return _.isEqual(t[e.index], e.value);
          });
        });
      },
      _onSelectChange: function () {
        var e = this._getVariantFromOptions();
        this.$container.trigger({ type: "variantChange", variant: e }),
          e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), (this.currentVariant = e), this.enableHistoryState && this._updateHistoryState(e));
      },
      _updateImages: function (e) {
        var t = e.featured_image || {},
            i = this.currentVariant.featured_image || {};
        e.featured_image && t.src !== i.src && this.$container.trigger({ type: "variantImageChange", variant: e });
      },
      _updatePrice: function (e) {
        (e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price) || this.$container.trigger({ type: "variantPriceChange", variant: e });
      },
      _updateSKU: function (e) {
        e.sku !== this.currentVariant.sku && this.$container.trigger({ type: "variantSKUChange", variant: e });
      },
      _updateHistoryState: function (e) {
        var t;
        history.replaceState && e && ((t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id), window.history.replaceState({ path: t }, "", t));
      },
      _updateMasterSelect: function (e) {
        $(this.originalSelectorId, this.$container).val(e.id);
      },
    })),
    e
  );
})()),
  (this.Shopify = this.Shopify || {}),
  (this.Shopify.theme = this.Shopify.theme || {}),
  (this.Shopify.theme.PredictiveSearch = (function () {
  "use strict";
  function d() {
    var e = Error.call(this);
    return (e.name = "Server error"), (e.message = "Something went wrong on the server"), (e.status = 500), e;
  }
  function u(e) {
    var t = Error.call(this);
    return (t.name = "Not found"), (t.message = "Not found"), (t.status = e), t;
  }
  function h() {
    var e = Error.call(this);
    return (e.name = "Server error"), (e.message = "Something went wrong on the server"), (e.status = 500), e;
  }
  function p(e) {
    var t = Error.call(this);
    return (t.name = "Content-Type error"), (t.message = "Content-Type was not provided or is of wrong type"), (t.status = e), t;
  }
  function m(e) {
    var t = Error.call(this);
    return (t.name = "JSON parse error"), (t.message = "JSON syntax error"), (t.status = e), t;
  }
  function f(e, t, i, s) {
    var a = Error.call(this);
    return (a.name = t), (a.message = i), (a.status = e), (a.retryAfter = s), a;
  }
  function v(e, t, i) {
    var s = Error.call(this);
    return (s.name = t), (s.message = i), (s.status = e), s;
  }
  function g(e, t, i) {
    var s = Error.call(this);
    return (s.name = t), (s.message = i), (s.status = e), s;
  }
  function t(e) {
    (this._store = {}), (this._keys = []), e && e.bucketSize ? (this.bucketSize = e.bucketSize) : (this.bucketSize = 20);
  }
  function i() {
    this.events = {};
  }
  function s(e) {
    (this.eventName = e), (this.callbacks = []);
  }
  function n(s, a) {
    var r = "";
    return (
      (a = a || null),
      Object.keys(s).forEach(function (e) {
        var t,
            i = a ? a + "[" + e + "]" : e + "=";
        switch (((t = s[e]), Object.prototype.toString.call(t).slice(8, -1).toLowerCase())) {
          case "object":
            r += n(s[e], a ? i : e);
            break;
          case "array":
            r += i + "=" + s[e].join(",") + "&";
            break;
          default:
            a && (i += "="), (r += i + encodeURIComponent(s[e]) + "&");
        }
      }),
      r
    );
  }
  (t.prototype.set = function (e, t) {
    var i;
    return this.count() >= this.bucketSize && ((i = this._keys.splice(0, 1)), this.delete(i)), this._keys.push(e), (this._store[e] = t), this._store;
  }),
    (t.prototype.get = function (e) {
    return this._store[e];
  }),
    (t.prototype.has = function (e) {
    return Boolean(this._store[e]);
  }),
    (t.prototype.count = function () {
    return Object.keys(this._store).length;
  }),
    (t.prototype.delete = function (e) {
    var t = Boolean(this._store[e]);
    return delete this._store[e], t && !this._store[e];
  }),
    (i.prototype.on = function (e, t) {
    var i = this.events[e];
    i || ((i = new s(e)), (this.events[e] = i)), i.registerCallback(t);
  }),
    (i.prototype.off = function (e, t) {
    var i = this.events[e];
    i && -1 < i.callbacks.indexOf(t) && (i.unregisterCallback(t), 0 === i.callbacks.length && delete this.events[e]);
  }),
    (i.prototype.dispatch = function (e, t) {
    var i = this.events[e];
    i && i.fire(t);
  }),
    (s.prototype.registerCallback = function (e) {
    this.callbacks.push(e);
  }),
    (s.prototype.unregisterCallback = function (e) {
    var t = this.callbacks.indexOf(e);
    -1 < t && this.callbacks.splice(t, 1);
  }),
    (s.prototype.fire = function (t) {
    this.callbacks.slice(0).forEach(function (e) {
      e(t);
    });
  });
  var a,
      r,
      o,
      c =
      ((a = function (e, n, o, c) {
        var l = new XMLHttpRequest();
        (l.onreadystatechange = function () {
          if (l.readyState === XMLHttpRequest.DONE) {
            var e = l.getResponseHeader("Content-Type");
            if (500 <= l.status) c(new h());
            else if (404 !== l.status)
              if ("string" == typeof e && null !== e.toLowerCase().match("application/json"))
                if (417 !== l.status)
                  if (422 !== l.status)
                    if (429 !== l.status)
                      if (200 !== l.status)
                        try {
                          var t = JSON.parse(l.responseText);
                          c(new d(l.status, t.message, t.description));
                        } catch (e) {
                          c(new m(l.status));
                        }
            else
              try {
                var i = JSON.parse(l.responseText);
                (i.query = n), o(i);
              } catch (e) {
                c(new m(l.status));
              }
            else
              try {
                var s = JSON.parse(l.responseText);
                c(new f(l.status, s.message, s.description, l.getResponseHeader("Retry-After")));
              } catch (e) {
                c(new m(l.status));
              }
            else
              try {
                var a = JSON.parse(l.responseText);
                c(new g(l.status, a.message, a.description));
              } catch (e) {
                c(new m(l.status));
              }
            else
              try {
                var r = JSON.parse(l.responseText);
                c(new v(l.status, r.message, r.description));
              } catch (e) {
                c(new m(l.status));
              }
            else c(new p(l.status));
            else c(new u(l.status));
          }
        }),
          l.open("get", "/search/suggest.json?q=" + encodeURIComponent(n) + "&" + e),
          l.setRequestHeader("Content-Type", "application/json"),
          l.send();
      }),
       (r = 10),
       (o = null),
       function () {
        var e = this,
            t = arguments;
        clearTimeout(o),
          (o = setTimeout(function () {
          (o = null), a.apply(e, t);
        }, r || 0));
      });
  function e(e) {
    if (!e) throw new TypeError("No config object was specified");
    (this._retryAfter = null), (this._currentQuery = null), (this.dispatcher = new i()), (this.cache = new t({ bucketSize: 40 })), (this.configParams = n(e));
  }
  function l(e) {
    return "string" != typeof e ? null : e.trim().replace(" ", "-").toLowerCase();
  }
  return (
    (e.TYPES = { PRODUCT: "product", PAGE: "page", ARTICLE: "article" }),
    (e.FIELDS = { AUTHOR: "author", BODY: "body", PRODUCT_TYPE: "product_type", TAG: "tag", TITLE: "title", VARIANTS_BARCODE: "variants.barcode", VARIANTS_SKU: "variants.sku", VARIANTS_TITLE: "variants.title", VENDOR: "vendor" }),
    (e.UNAVAILABLE_PRODUCTS = { SHOW: "show", HIDE: "hide", LAST: "last" }),
    (e.prototype.query = function (e) {
      try {
        !(function (e) {
          var t;
          if (null == e) throw (((t = new TypeError("'query' is missing")).type = "argument"), t);
          if ("string" != typeof e) throw (((t = new TypeError("'query' is not a string")).type = "argument"), t);
        })(e);
      } catch (e) {
        return void this.dispatcher.dispatch("error", e);
      }
      if ("" === e) return this;
      this._currentQuery = l(e);
      var t = this.cache.get(this._currentQuery);
      return (
        t
        ? this.dispatcher.dispatch("success", t)
        : c(
          this.configParams,
          e,
          function (e) {
            this.cache.set(l(e.query), e), l(e.query) === this._currentQuery && ((this._retryAfter = null), this.dispatcher.dispatch("success", e));
          }.bind(this),
          function (e) {
            e.retryAfter && (this._retryAfter = e.retryAfter), this.dispatcher.dispatch("error", e);
          }.bind(this)
        ),
        this
      );
    }),
    (e.prototype.on = function (e, t) {
      return this.dispatcher.on(e, t), this;
    }),
    (e.prototype.off = function (e, t) {
      return this.dispatcher.off(e, t), this;
    }),
    e
  );
})()),
  (this.Shopify = this.Shopify || {}),
  (this.Shopify.theme = this.Shopify.theme || {}),
  (this.Shopify.theme.PredictiveSearchComponent = (function (n) {
  "use strict";
  var o = {
    resources: {
      type: [(n = n && n.hasOwnProperty("default") ? n.default : n).TYPES.PRODUCT],
      options: { unavailable_products: n.UNAVAILABLE_PRODUCTS.LAST, fields: [n.FIELDS.TITLE, n.FIELDS.VENDOR, n.FIELDS.PRODUCT_TYPE, n.FIELDS.VARIANTS_TITLE] },
    },
  };
  function e(e) {
    if (
      !(
        e &&
        e.selectors &&
        e.selectors.input &&
        c(e.selectors.input) &&
        e.selectors.result &&
        c(e.selectors.result) &&
        e.resultTemplateFct &&
        l(e.resultTemplateFct) &&
        e.numberOfResultsTemplateFct &&
        l(e.numberOfResultsTemplateFct) &&
        e.loadingResultsMessageTemplateFct &&
        l(e.loadingResultsMessageTemplateFct)
      )
    ) {
      var t = new TypeError("PredictiveSearchComponent config is not valid");
      throw ((t.type = "argument"), t);
    }
    var i, s, a, r;
    (this.nodes = ((i = e.selectors), { input: document.querySelector(i.input), reset: document.querySelector(i.reset), result: document.querySelector(i.result) })),
      (s = this.nodes) && s.input && s.result && "INPUT" === s.input.tagName
    ? ((this._searchKeyword = ""),
       (this.resultTemplateFct = e.resultTemplateFct),
       (this.numberOfResultsTemplateFct = e.numberOfResultsTemplateFct),
       (this.loadingResultsMessageTemplateFct = e.loadingResultsMessageTemplateFct),
       (this.numberOfResults = e.numberOfResults || 4),
       (this.classes = {
      visibleVariant: e.visibleVariant ? e.visibleVariant : "predictive-search-wrapper--visible",
      itemSelected: e.itemSelectedClass ? e.itemSelectedClass : "predictive-search-item--selected",
      clearButtonVisible: e.clearButtonVisibleClass ? e.clearButtonVisibleClass : "predictive-search__clear-button--visible",
    }),
       (this.selectors = { searchResult: e.searchResult ? e.searchResult : "[data-search-result]" }),
       (this.callbacks = {
      onBodyMousedown: (a = e).onBodyMousedown,
      onBeforeOpen: a.onBeforeOpen,
      onOpen: a.onOpen,
      onBeforeClose: a.onBeforeClose,
      onClose: a.onClose,
      onInputFocus: a.onInputFocus,
      onInputKeyup: a.onInputKeyup,
      onInputBlur: a.onInputBlur,
      onInputReset: a.onInputReset,
      onBeforeDestroy: a.onBeforeDestroy,
      onDestroy: a.onDestroy,
    }),
       (r = this.nodes.input).setAttribute("autocorrect", "off"),
       r.setAttribute("autocomplete", "off"),
       r.setAttribute("autocapitalize", "off"),
       r.setAttribute("spellcheck", "false"),
       this._addInputEventListeners(),
       this._addBodyEventListener(),
       this._addAccessibilityAnnouncer(),
       this._toggleClearButtonVisibility(),
       (this.predictiveSearch = new n(e.PredictiveSearchAPIConfig ? e.PredictiveSearchAPIConfig : o)),
       this.predictiveSearch.on("success", this._handlePredictiveSearchSuccess.bind(this)),
       this.predictiveSearch.on("error", this._handlePredictiveSearchError.bind(this)))
    : console.warn("Could not find valid nodes");
  }
  function t(e) {
    return Object.prototype.toString.call(e);
  }
  function c(e) {
    return "[object String]" === t(e);
  }
  function i(e) {
    return "[object Boolean]" === t(e);
  }
  function l(e) {
    return "[object Function]" === t(e);
  }
  return (
    (e.prototype.isResultVisible = !1),
    (e.prototype.results = {}),
    (e.prototype._latencyTimer = null),
    (e.prototype._resultNodeClicked = !1),
    (e.prototype._addInputEventListeners = function () {
      var e = this.nodes.input,
          t = this.nodes.reset;
      e &&
        ((this._handleInputFocus = this._handleInputFocus.bind(this)),
         (this._handleInputBlur = this._handleInputBlur.bind(this)),
         (this._handleInputKeyup = this._handleInputKeyup.bind(this)),
         (this._handleInputKeydown = this._handleInputKeydown.bind(this)),
         e.addEventListener("focus", this._handleInputFocus),
         e.addEventListener("blur", this._handleInputBlur),
         e.addEventListener("keyup", this._handleInputKeyup),
         e.addEventListener("keydown", this._handleInputKeydown),
         t && ((this._handleInputReset = this._handleInputReset.bind(this)), t.addEventListener("click", this._handleInputReset)));
    }),
    (e.prototype._removeInputEventListeners = function () {
      var e = this.nodes.input;
      e.removeEventListener("focus", this._handleInputFocus),
        e.removeEventListener("blur", this._handleInputBlur),
        e.removeEventListener("keyup", this._handleInputKeyup),
        e.removeEventListener("keydown", this._handleInputKeydown);
    }),
    (e.prototype._addBodyEventListener = function () {
      (this._handleBodyMousedown = this._handleBodyMousedown.bind(this)), document.querySelector("body").addEventListener("mousedown", this._handleBodyMousedown);
    }),
    (e.prototype._removeBodyEventListener = function () {
      document.querySelector("body").removeEventListener("mousedown", this._handleBodyMousedown);
    }),
    (e.prototype._removeClearButtonEventListener = function () {
      var e = this.nodes.reset;
      e && e.removeEventListener("click", this._handleInputReset);
    }),
    (e.prototype._handleBodyMousedown = function (e) {
      var t;
      this.isResultVisible &&
        null !== this.nodes &&
        (e.target.isEqualNode(this.nodes.input) || this.nodes.input.contains(e.target) || e.target.isEqualNode(this.nodes.result) || this.nodes.result.contains(e.target)
         ? (this._resultNodeClicked = !0)
         : (!l(this.callbacks.onBodyMousedown) || (i((t = this.callbacks.onBodyMousedown(this.nodes))) && t)) && this.close());
    }),
    (e.prototype._handleInputFocus = function (e) {
      if (l(this.callbacks.onInputFocus)) {
        var t = this.callbacks.onInputFocus(this.nodes);
        if (i(t) && !t) return !1;
      }
      return 0 < e.target.value.length && this._search(), !0;
    }),
    (e.prototype._handleInputBlur = function () {
      return (
        setTimeout(
          function () {
            if (l(this.callbacks.onInputBlur)) {
              var e = this.callbacks.onInputBlur(this.nodes);
              if (i(e) && !e) return !1;
            }
            return !document.activeElement.isEqualNode(this.nodes.reset) && (this._resultNodeClicked ? (this._resultNodeClicked = !1) : void this.close());
          }.bind(this)
        ),
        !0
      );
    }),
    (e.prototype._addAccessibilityAnnouncer = function () {
      (this._accessibilityAnnouncerDiv = window.document.createElement("div")),
        this._accessibilityAnnouncerDiv.setAttribute("style", "position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;"),
        this._accessibilityAnnouncerDiv.setAttribute("data-search-announcer", ""),
        this._accessibilityAnnouncerDiv.setAttribute("aria-live", "polite"),
        this._accessibilityAnnouncerDiv.setAttribute("aria-atomic", "true"),
        this.nodes.result.parentElement.appendChild(this._accessibilityAnnouncerDiv);
    }),
    (e.prototype._removeAccessibilityAnnouncer = function () {
      this.nodes.result.parentElement.removeChild(this._accessibilityAnnouncerDiv);
    }),
    (e.prototype._updateAccessibilityAttributesAfterSelectingElement = function (e, t) {
      this.nodes.input.setAttribute("aria-activedescendant", t.id), e && e.removeAttribute("aria-selected"), t.setAttribute("aria-selected", !0);
    }),
    (e.prototype._clearAriaActiveDescendant = function () {
      this.nodes.input.setAttribute("aria-activedescendant", "");
    }),
    (e.prototype._announceNumberOfResultsFound = function (e) {
      var t = this._accessibilityAnnouncerDiv.innerHTML,
          i = this.numberOfResultsTemplateFct(e);
      t === i && (i += "&nbsp;"), (this._accessibilityAnnouncerDiv.innerHTML = i);
    }),
    (e.prototype._announceLoadingState = function () {
      this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
    }),
    (e.prototype._handleInputKeyup = function (e) {
      if (l(this.callbacks.onInputKeyup)) {
        var t = this.callbacks.onInputKeyup(this.nodes);
        if (i(t) && !t) return !1;
      }
      if ((this._toggleClearButtonVisibility(), this.isResultVisible && null !== this.nodes)) {
        if (38 === e.keyCode) return this._navigateOption(e, "UP"), !0;
        if (40 === e.keyCode) return this._navigateOption(e, "DOWN"), !0;
        if (13 === e.keyCode) return this._selectOption(), !0;
        27 === e.keyCode && this.close();
      }
      return e.target.value.length <= 0 ? (this.close(), this._setKeyword("")) : 0 < e.target.value.length && this._search(), !0;
    }),
    (e.prototype._handleInputKeydown = function (e) {
      13 === e.keyCode && null !== this._getSelectedOption() && e.preventDefault(), (38 !== e.keyCode && 40 !== e.keyCode) || e.preventDefault();
    }),
    (e.prototype._handleInputReset = function (e) {
      if ((e.preventDefault(), l(this.callbacks.onInputReset))) {
        var t = this.callbacks.onInputReset(this.nodes);
        if (i(t) && !t) return !1;
      }
      return (this.nodes.input.value = ""), this.nodes.input.focus(), this._toggleClearButtonVisibility(), this.close(), !0;
    }),
    (e.prototype._navigateOption = function (e, t) {
      var i,
          s,
          a,
          r = this._getSelectedOption();
      r
      ? "DOWN" === t
      ? (i = r.nextElementSibling) && (r.classList.remove(this.classes.itemSelected), i.classList.add(this.classes.itemSelected), this._updateAccessibilityAttributesAfterSelectingElement(r, i))
      : (s = r.previousElementSibling) && (r.classList.remove(this.classes.itemSelected), s.classList.add(this.classes.itemSelected), this._updateAccessibilityAttributesAfterSelectingElement(r, s))
      : ((a = this.nodes.result.querySelector(this.selectors.searchResult)).classList.add(this.classes.itemSelected), this._updateAccessibilityAttributesAfterSelectingElement(null, a));
    }),
    (e.prototype._getSelectedOption = function () {
      return this.nodes.result.querySelector("." + this.classes.itemSelected);
    }),
    (e.prototype._selectOption = function () {
      var e = this._getSelectedOption();
      e && e.querySelector("a, button").click();
    }),
    (e.prototype._search = function () {
      var e = this.nodes.input.value;
      this._searchKeyword !== e &&
        (clearTimeout(this._latencyTimer),
         (this._latencyTimer = setTimeout(
        function () {
          (this.results.isLoading = !0), this._announceLoadingState(), this.nodes.result.classList.add(this.classes.visibleVariant), (this.nodes.result.innerHTML = this.resultTemplateFct(this.results));
        }.bind(this),
        500
      )),
         this.predictiveSearch.query(e),
         this._setKeyword(e));
    }),
    (e.prototype._handlePredictiveSearchSuccess = function (e) {
      clearTimeout(this._latencyTimer),
        (this.results = e.resources.results),
        (this.results.isLoading = !1),
        (this.results.products = this.results.products.slice(0, this.numberOfResults)),
        (this.results.canLoadMore = this.numberOfResults <= this.results.products.length),
        (this.results.searchQuery = this.nodes.input.value),
        0 < this.results.products.length || this.results.searchQuery
      ? ((this.nodes.result.innerHTML = this.resultTemplateFct(this.results)), this._announceNumberOfResultsFound(this.results), this.open())
      : ((this.nodes.result.innerHTML = ""), this._closeOnNoResults());
    }),
    (e.prototype._handlePredictiveSearchError = function () {
      clearTimeout(this._latencyTimer), (this.nodes.result.innerHTML = ""), this._closeOnNoResults();
    }),
    (e.prototype._closeOnNoResults = function () {
      this.nodes && this.nodes.result.classList.remove(this.classes.visibleVariant), (this.isResultVisible = !1);
    }),
    (e.prototype._setKeyword = function (e) {
      this._searchKeyword = e;
    }),
    (e.prototype._toggleClearButtonVisibility = function () {
      this.nodes.reset && (0 < this.nodes.input.value.length ? this.nodes.reset.classList.add(this.classes.clearButtonVisible) : this.nodes.reset.classList.remove(this.classes.clearButtonVisible));
    }),
    (e.prototype.open = function () {
      if (!this.isResultVisible) {
        if (l(this.callbacks.onBeforeOpen)) {
          var e = this.callbacks.onBeforeOpen(this.nodes);
          if (i(e) && !e) return !1;
        }
        return this.nodes.result.classList.add(this.classes.visibleVariant), this.nodes.input.setAttribute("aria-expanded", !0), (this.isResultVisible = !0), (l(this.callbacks.onOpen) && this.callbacks.onOpen(this.nodes)) || !0;
      }
    }),
    (e.prototype.close = function () {
      if (!this.isResultVisible) return !0;
      if (l(this.callbacks.onBeforeClose)) {
        var e = this.callbacks.onBeforeClose(this.nodes);
        if (i(e) && !e) return !1;
      }
      return (
        this.nodes && this.nodes.result.classList.remove(this.classes.visibleVariant),
        this.nodes.input.setAttribute("aria-expanded", !1),
        this._clearAriaActiveDescendant(),
        this._setKeyword(""),
        l(this.callbacks.onClose) && this.callbacks.onClose(this.nodes),
        (this.isResultVisible = !1),
        (this.results = {}),
        !0
      );
    }),
    (e.prototype.destroy = function () {
      if ((this.close(), l(this.callbacks.onBeforeDestroy))) {
        var e = this.callbacks.onBeforeDestroy(this.nodes);
        if (i(e) && !e) return !1;
      }
      var t;
      return (
        this.nodes.result.classList.remove(this.classes.visibleVariant),
        (t = this.nodes.input).removeAttribute("autocorrect", "off"),
        t.removeAttribute("autocomplete", "off"),
        t.removeAttribute("autocapitalize", "off"),
        t.removeAttribute("spellcheck", "false"),
        this._removeInputEventListeners(),
        this._removeBodyEventListener(),
        this._removeAccessibilityAnnouncer(),
        this._removeClearButtonEventListener(),
        l(this.callbacks.onDestroy) && this.callbacks.onDestroy(this.nodes),
        !0
      );
    }),
    (e.prototype.clearAndClose = function () {
      (this.nodes.input.value = ""), this.close();
    }),
    e
  );
})(Shopify.theme.PredictiveSearch)),
  (theme.Drawers = (function () {
  function e(e, t, i) {
    var s = "js-drawer-open",
        a = { selectors: { openVariant: "." + s + "-" + t, close: ".js-drawer-close" }, classes: { open: s, openVariant: s + "-" + t }, withPredictiveSearch: !1 };
    if (((this.nodes = { $parent: $("html").add("body"), $page: $("#PageContainer") }), (this.config = $.extend(a, i)), (this.position = t), (this.$drawer = $("#" + e)), !this.$drawer.length)) return !1;
    (this.drawerIsOpen = !1), this.init();
  }
  return (
    (e.prototype.init = function () {
      $(this.config.selectors.openVariant).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.selectors.close, $.proxy(this.close, this));
    }),
    (e.prototype.open = function (e) {
      var t = !1;
      if ((e ? e.preventDefault() : (t = !0), e && e.stopPropagation && (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))), this.drawerIsOpen && !t)) return this.close();
      this.config.withPredictiveSearch || this.$drawer.prepareTransition(),
        this.nodes.$parent.addClass(this.config.classes.open + " " + this.config.classes.openVariant),
        (this.drawerIsOpen = !0),
        this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()),
        this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true");
      var i = { $container: this.$drawer, namespace: "drawer_focus" };
      return this.config.$elementToFocusOnOpen && (i.$elementToFocus = this.config.$elementToFocusOnOpen), slate.a11y.trapFocus(i), this.bindEvents(), this;
    }),
    (e.prototype.close = function () {
      this.drawerIsOpen &&
        ($(document.activeElement).trigger("blur"),
         this.config.withPredictiveSearch || this.$drawer.prepareTransition(),
         this.nodes.$parent.removeClass(this.config.classes.open + " " + this.config.classes.openVariant),
         this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"),
         (this.drawerIsOpen = !1),
         slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
         this.unbindEvents(),
         this.config.onDrawerClose && "function" == typeof this.config.onDrawerClose && this.config.onDrawerClose());
    }),
    (e.prototype.bindEvents = function () {
      this.nodes.$parent.on(
        "keyup.drawer",
        $.proxy(function (e) {
          return 27 !== e.keyCode || (this.close(), !1);
        }, this)
      ),
        this.nodes.$page.on("touchmove.drawer", function () {
        return !1;
      }),
        this.nodes.$page.on(
        "click.drawer",
        $.proxy(function () {
          return this.close(), !1;
        }, this)
      );
    }),
    (e.prototype.unbindEvents = function () {
      this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
    }),
    e
  );
})()),
  (theme.Helpers = (function () {
  var e = !1;
  return {
    setTouch: function () {
      e = !0;
    },
    isTouch: function () {
      return e;
    },
  };
})()),
  (theme.LibraryLoader = (function () {
  var u = "link",
      h = "script",
      p = { requested: "requested", loaded: "loaded" },
      e = "https://cdn.shopify.com/shopifycloud/",
      m = {
        youtubeSdk: { tagId: "youtube-sdk", src: "https://www.youtube.com/iframe_api", type: h },
        plyrShopifyStyles: { tagId: "plyr-shopify-styles", src: e + "shopify-plyr/v1.0/shopify-plyr.css", type: u },
        modelViewerUiStyles: { tagId: "shopify-model-viewer-ui-styles", src: e + "model-viewer-ui/assets/v1.0/model-viewer-ui.css", type: u },
      };
  return {
    load: function (e, t) {
      var i,
          s,
          a,
          r,
          n,
          o,
          c,
          l = m[e];
      if (l && l.status !== p.requested)
        if (((t = t || function () {}), l.status !== p.loaded)) {
          switch (((l.status = p.requested), l.type)) {
            case h:
              (n = l),
                (o = t),
                ((c = document.createElement("script")).src = n.src),
                c.addEventListener("load", function () {
                (n.status = p.loaded), o();
              }),
                (i = c);
              break;
            case u:
              (s = l),
                (a = t),
                ((r = document.createElement("link")).href = s.src),
                (r.rel = "stylesheet"),
                (r.type = "text/css"),
                r.addEventListener("load", function () {
                (s.status = p.loaded), a();
              }),
                (i = r);
          }
          (i.id = l.tagId), (l.element = i);
          var d = document.getElementsByTagName(l.type)[0];
          d.parentNode.insertBefore(i, d);
        } else t();
    },
  };
})()),
  (window.theme = window.theme || {}),
  (theme.Header = (function () {
  var s = {
    body: "body",
    navigation: "#AccessibleNav",
    siteNavHasDropdown: "[data-has-dropdowns]",
    siteNavChildLinks: ".site-nav__child-link",
    siteNavActiveDropdown: ".site-nav--active-dropdown",
    siteNavHasCenteredDropdown: ".site-nav--has-centered-dropdown",
    siteNavCenteredDropdown: ".site-nav__dropdown--centered",
    siteNavLinkMain: ".site-nav__link--main",
    siteNavChildLink: ".site-nav__link--last",
    siteNavDropdown: ".site-nav__dropdown",
    siteHeader: ".site-header",
  },
      i = { activeClass: "site-nav--active-dropdown", childLinkClass: "site-nav__child-link", rightDropdownClass: "site-nav__dropdown--right", leftDropdownClass: "site-nav__dropdown--left" },
      a = {};
  function r(e) {
    e.find(s.siteNavLinkMain).attr("aria-expanded", "false"), e.removeClass(i.activeClass), (a.$activeDropdown = $(s.siteNavActiveDropdown)), $(s.body).off("click.siteNav"), $(window).off("keyup.siteNav");
  }
  function e(e) {
    e.each(function () {
      var e = $(this).find(s.siteNavDropdown);
      e.length &&
        (Math.ceil($(this).offset().left) > Math.floor(a.$siteHeader.outerWidth()) / 2 ? e.removeClass(i.leftDropdownClass).addClass(i.rightDropdownClass) : e.removeClass(i.rightDropdownClass).addClass(i.leftDropdownClass));
    });
  }
  function t() {
    $(s.siteNavHasCenteredDropdown).each(function () {
      var e = $(this),
          t = e.find(s.siteNavCenteredDropdown),
          i = e.position().top + 41;
      t.css("top", i);
    });
  }
  return {
    init: function () {
      (a = {
        $nav: $(s.navigation),
        $topLevel: $(s.siteNavLinkMain),
        $parents: $(s.navigation).find(s.siteNavHasDropdown),
        $subMenuLinks: $(s.siteNavChildLinks),
        $activeDropdown: $(s.siteNavActiveDropdown),
        $siteHeader: $(s.siteHeader),
      }),
        e($(s.siteNavHasDropdown)),
        t(),
        a.$parents.on("click.siteNav", function () {
        var e = $(this);
        (e.hasClass(i.activeClass)
         ? r
         : function (t) {
          t.addClass(i.activeClass), a.$activeDropdown.length && r(a.$activeDropdown);
          (a.$activeDropdown = t).find(s.siteNavLinkMain).attr("aria-expanded", "true"),
            setTimeout(function () {
            $(window).on("keyup.siteNav", function (e) {
              27 === e.keyCode && r(t);
            }),
              $(s.body).on("click.siteNav", function () {
              r(t);
            });
          }, 250);
        })(e);
      }),
        $(s.siteNavChildLink).on("focusout.siteNav", function () {
        setTimeout(function () {
          !$(document.activeElement).hasClass(i.childLinkClass) && a.$activeDropdown.length && r(a.$activeDropdown);
        });
      }),
        a.$topLevel.on("focus.siteNav", function () {
        a.$activeDropdown.length && r(a.$activeDropdown);
      }),
        a.$subMenuLinks.on("click.siteNav", function (e) {
        e.stopImmediatePropagation();
      }),
        $(window).resize(
        $.debounce(50, function () {
          e($(s.siteNavHasDropdown)), t();
        })
      );
    },
    unload: function () {
      $(window).off(".siteNav"), a.$parents.off(".siteNav"), a.$subMenuLinks.off(".siteNav"), a.$topLevel.off(".siteNav"), $(s.siteNavChildLink).off(".siteNav"), $(s.body).off(".siteNav");
    },
  };
})()),
  (window.theme = window.theme || {}),
  (theme.MobileNav = (function () {
  var o,
      c,
      s,
      l = {
        mobileNavOpenIcon: "mobile-nav--open",
        mobileNavCloseIcon: "mobile-nav--close",
        navLinkWrapper: "mobile-nav__item",
        navLink: "mobile-nav__link",
        subNavLink: "mobile-nav__sublist-link",
        return: "mobile-nav__return-btn",
        subNavActive: "is-active",
        subNavClosing: "is-closing",
        navOpen: "js-menu--is-open",
        subNavShowing: "sub-nav--is-open",
        thirdNavShowing: "third-nav--is-open",
        subNavToggleBtn: "js-toggle-submenu",
      },
      d = {},
      u = 1;
  function e() {
    var e;
    d.$mobileNavToggle.hasClass(l.mobileNavCloseIcon)
    ? t()
    : ((e = d.$siteHeader.outerHeight()),
       d.$mobileNavContainer.prepareTransition().addClass(l.navOpen),
       d.$mobileNavContainer.css({ transform: "translateY(" + e + "px)" }),
       d.$pageContainer.css({ transform: "translate3d(0, " + d.$mobileNavContainer[0].scrollHeight + "px, 0)" }),
       slate.a11y.trapFocus({ $container: d.$sectionHeader, $elementToFocus: d.$mobileNavToggle, namespace: "navFocus" }),
       d.$mobileNavToggle.addClass(l.mobileNavCloseIcon).removeClass(l.mobileNavOpenIcon).attr("aria-expanded", !0),
       $(window).on("keyup.mobileNav", function (e) {
      27 === e.which && t();
    }));
  }
  function t() {
    d.$mobileNavContainer.prepareTransition().removeClass(l.navOpen),
      d.$mobileNavContainer.css({ transform: "translateY(-100%)" }),
      d.$pageContainer.removeAttr("style"),
      slate.a11y.trapFocus({ $container: $("html"), $elementToFocus: $("body") }),
      d.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle", function () {
      slate.a11y.removeTrapFocus({ $container: d.$mobileNav, namespace: "navFocus" });
    }),
      d.$mobileNavToggle.addClass(l.mobileNavOpenIcon).removeClass(l.mobileNavCloseIcon).attr("aria-expanded", !1).focus(),
      $(window).off("keyup.mobileNav"),
      scrollTo(0, 0);
  }
  function i(e) {
    var t, i;
    o ||
      ((i = (t = $(e.currentTarget)).hasClass(l.return)),
       (o = !0),
       i ? ($("." + l.subNavToggleBtn + '[data-level="' + (u - 1) + '"]').removeClass(l.subNavActive), s && s.length && s.removeClass(l.subNavActive)) : t.addClass(l.subNavActive),
       (function (e) {
      var t = e ? $('.mobile-nav__dropdown[data-parent="' + e + '"]') : d.$mobileNav;
      (u = t.data("level") ? t.data("level") : 1), c && c.length && c.prepareTransition().addClass(l.subNavClosing);
      var i = (c = t).outerHeight(),
          s = 2 < u ? l.thirdNavShowing : l.subNavShowing;
      d.$mobileNavContainer.css("height", i).removeClass(l.thirdNavShowing).addClass(s), e || d.$mobileNavContainer.removeClass(l.thirdNavShowing).removeClass(l.subNavShowing);
      var a = 1 === u ? d.$sectionHeader : t,
          r = t.find("[data-menu-title=" + u + "]"),
          n = r || t;
      d.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle", function () {
        slate.a11y.trapFocus({ $container: a, $elementToFocus: n, namespace: "subNavFocus" }), d.$mobileNavContainer.off(".subnavToggle"), (o = !1);
      }),
        d.$pageContainer.css({ transform: "translateY(" + i + "px)" }),
        c.removeClass(l.subNavClosing);
    })((s = t).data("target")));
  }
  return {
    init: function () {
      (d = {
        $pageContainer: $("#PageContainer"),
        $siteHeader: $(".site-header"),
        $mobileNavToggle: $(".js-mobile-nav-toggle"),
        $mobileNavContainer: $(".mobile-nav-wrapper"),
        $mobileNav: $("#MobileNav"),
        $sectionHeader: $("#shopify-section-header"),
        $subNavToggleBtn: $("." + l.subNavToggleBtn),
      }).$mobileNavToggle.on("click", e),
        d.$subNavToggleBtn.on("click.subNav", i),
        enquire.register("screen and (max-width: 749px)", {
        unmatch: function () {
          d.$mobileNavContainer.hasClass(l.navOpen) && t();
        },
      });
    },
    closeMobileNav: t,
  };
})(jQuery)),
  (function () {
  var e = $(".return-link");
  function i(e) {
    var t = document.createElement("a");
    return (t.ref = e), t.hostname;
  }
  document.referrer &&
    e.length &&
    window.history.length &&
    e.one("click", function (e) {
    e.preventDefault();
    var t = i(document.referrer);
    return i(window.location.href) === t && history.back(), !1;
  });
})(),
  (theme.Slideshow = (function () {
  this.$slideshow = null;
  var n = { slideshow: "slideshow", slickActiveMobile: "slick-active-mobile", controlsHover: "slideshow__controls--hover", isPaused: "is-paused" },
      r = {
        section: ".shopify-section",
        wrapper: "#SlideshowWrapper-",
        slides: ".slideshow__slide",
        textWrapperMobile: ".slideshow__text-wrap--mobile",
        textContentMobile: ".slideshow__text-content--mobile",
        controls: ".slideshow__controls",
        pauseButton: ".slideshow__pause",
        dots: ".slick-dots",
        arrows: ".slideshow__arrows",
        arrowsMobile: ".slideshow__arrows--mobile",
        arrowLeft: ".slideshow__arrow-left",
        arrowRight: ".slideshow__arrow-right",
      };
  function e(e, i) {
    var t = (this.$slideshow = $(e));
    (this.adaptHeight = this.$slideshow.data("adapt-height")),
      (this.$wrapper = this.$slideshow.closest(r.wrapper + i)),
      (this.$section = this.$wrapper.closest(r.section)),
      (this.$controls = this.$wrapper.find(r.controls)),
      (this.$arrows = this.$section.find(r.arrows)),
      (this.$arrowsMobile = this.$section.find(r.arrowsMobile)),
      (this.$pause = this.$controls.find(r.pauseButton)),
      (this.$textWrapperMobile = this.$section.find(r.textWrapperMobile)),
      (this.autorotate = this.$slideshow.data("autorotate"));
    var s = this.$slideshow.data("speed"),
        a = this.$slideshow.data("slide-nav-a11y");
    (this.settings = {
      accessibility: !0,
      arrows: !1,
      dots: !0,
      fade: !0,
      draggable: !0,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: s,
      appendDots: this.$arrows,
      customPaging: function (e, t) {
        return '<a href="' + r.wrapper + i + '" aria-label="' + a.replace("[slide_number]", t + 1) + '" data-slide-number="' + t + '"></a>';
      },
    }),
      this.$slideshow.on(
      "beforeChange",
      function (e, t, i, s) {
        var a = this.$dots.find("a"),
            r = this.$mobileDots.find("li");
        a.removeAttr("aria-current").eq(s).attr("aria-current", "true"), r.removeClass(n.slickActiveMobile).eq(s).addClass(n.slickActiveMobile), this.showMobileText(s);
      }.bind(this)
    ),
      this.$slideshow.on(
      "init",
      function (e, t) {
        var i = t.$slider,
            s = t.$list;
        (this.$dots = this.$section.find(r.dots)),
          (this.$mobileDots = this.$dots.eq(1)),
          s.removeAttr("aria-live"),
          this.$wrapper.on("keyup", o.bind(this)),
          this.$controls.on("keyup", o.bind(this)),
          this.$textWrapperMobile.on("keyup", o.bind(this)),
          this.$wrapper
        .on(
          "focusin",
          function (e) {
            this.$wrapper.has(e.target).length && (s.attr("aria-live", "polite"), this.autorotate && i.slick("slickPause"));
          }.bind(this)
        )
        .on(
          "focusout",
          function (e) {
            this.$wrapper.has(e.target).length && (s.removeAttr("aria-live"), this.autorotate && (this.$pause.is(".is-paused") || i.slick("slickPlay")));
          }.bind(this)
        ),
          this.$dots &&
          this.$dots
        .find("a")
        .each(function () {
          $(this).on("click keyup", function (e) {
            var t;
            ("keyup" === e.type && e.which !== slate.utils.keyboardKeys.ENTER) ||
              (e.preventDefault(), (t = $(e.target).data("slide-number")), i.attr("tabindex", -1).slick("slickGoTo", t), "keyup" === e.type && i.focus());
          });
        })
        .eq(0)
        .attr("aria-current", "true");
        this.$controls
        .on(
          "focusin",
          function () {
            this.$controls.addClass(n.controlsHover);
          }.bind(this)
        )
        .on(
          "focusout",
          function () {
            this.$controls.removeClass(n.controlsHover);
          }.bind(this)
        );
      }.bind(this)
    ),
      this.$slideshow.on(
      "init",
      function () {
        this.$mobileDots.find("li:first-of-type").addClass(n.slickActiveMobile), this.showMobileText(0);
      }.bind(this)
    ),
      this.autorotate &&
      $(document).scroll(
      $.debounce(
        250,
        function () {
          this.$arrowsMobile.offset().top + this.$arrowsMobile.outerHeight() < window.pageYOffset ? t.slick("slickPause") : this.$pause.hasClass(n.isPaused) || t.slick("slickPlay");
        }.bind(this)
      )
    ),
      this.adaptHeight && (this.setSlideshowHeight(), $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)))),
      this.$slideshow.slick(this.settings),
      function () {
      this.$slideshow.find(r.slides).removeAttr("role").removeAttr("aria-labelledby"),
        this.$dots
      .removeAttr("role")
      .find("li")
      .removeAttr("role")
      .removeAttr("aria-selected")
      .each(function () {
        var e = $(this),
            t = e.attr("aria-controls");
        e.removeAttr("aria-controls").find("a").attr("aria-controls", t);
      });
    }.bind(this)(),
      this.$arrows.find(r.arrowLeft).on("click", function () {
      t.slick("slickPrev");
    }),
      this.$arrows.find(r.arrowRight).on("click", function () {
      t.slick("slickNext");
    }),
      this.$pause.on("click", this.togglePause.bind(this));
  }
  function o() {
    event.keyCode === slate.utils.keyboardKeys.LEFTARROW && this.$slideshow.slick("slickPrev"), event.keyCode === slate.utils.keyboardKeys.RIGHTARROW && this.$slideshow.slick("slickNext");
  }
  return (
    (e.prototype.togglePause = function () {
      var e = "#Slideshow-" + this.$pause.data("id");
      this.$pause.hasClass(n.isPaused)
      ? (this.$pause.removeClass(n.isPaused).attr("aria-pressed", "false"), this.autorotate && $(e).slick("slickPlay"))
      : (this.$pause.addClass(n.isPaused).attr("aria-pressed", "true"), this.autorotate && $(e).slick("slickPause"));
    }),
    (e.prototype.setSlideshowHeight = function () {
      var e = this.$slideshow.data("min-aspect-ratio");
      this.$slideshow.height($(document).width() / e);
    }),
    (e.prototype.showMobileText = function (e) {
      var t = this.$textWrapperMobile.find(r.textContentMobile),
          i = r.textContentMobile + "-" + e,
          s = this.$textWrapperMobile.find(i);
      s.length || 1 !== this.$slideshow.find(r.slides).length ? this.$textWrapperMobile.show() : this.$textWrapperMobile.hide(), t.hide(), s.show();
    }),
    e
  );
})()),
  (theme.Video = (function () {
  var r = !1,
      t = !1,
      n = !1,
      o = !1,
      c = {},
      l = [],
      d = {
        ratio: 16 / 9,
        scrollAnimationDuration: 400,
        playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
        events: {
          onReady: function (e) {
            e.target.setPlaybackQuality("hd1080");
            var t = y(e),
                i = e.target.getVideoData().title;
            a(),
              $("#" + t.id).attr("tabindex", "-1"),
              w(),
              (function (e, t) {
              var i = e.find(h.playVideoBtn),
                  s = e.find(h.closeVideoBtn),
                  a = e.find(h.pauseVideoBtn),
                  r = s.find(h.fallbackText),
                  n = a.find(h.pauseVideoStop).find(h.fallbackText),
                  o = a.find(h.pauseVideoResume).find(h.fallbackText);
              i.each(function () {
                var e = $(this).find(h.fallbackText);
                e.text(e.text().replace("[video_title]", t));
              }),
                r.text(r.text().replace("[video_title]", t)),
                n.text(n.text().replace("[video_title]", t)),
                o.text(o.text().replace("[video_title]", t));
            })(t.$videoWrapper, i),
              "background" === t.type && (e.target.mute(), s(t.id));
            t.$videoWrapper.addClass(u.loaded);
          },
          onStateChange: function (e) {
            var t = y(e);
            "background" !== t.status || S() || r || (e.data !== YT.PlayerState.PLAYING && e.data !== YT.PlayerState.BUFFERING) || (i(!0), (r = !0), t.$videoWrapper.removeClass(u.loading));
            switch (e.data) {
              case YT.PlayerState.ENDED:
                !(function (e) {
                  switch (e.type) {
                    case "background":
                      l[e.id].seekTo(0);
                      break;
                    case "image_with_play":
                      g(e.id), b(e.id, !1);
                  }
                })(t);
                break;
              case YT.PlayerState.PAUSED:
                setTimeout(function () {
                  e.target.getPlayerState() === YT.PlayerState.PAUSED && v(t);
                }, 200);
            }
          },
        },
      },
      u = {
        playing: "video-is-playing",
        paused: "video-is-paused",
        loading: "video-is-loading",
        loaded: "video-is-loaded",
        backgroundVideoWrapper: "video-background-wrapper",
        videoWithImage: "video--image_with_play",
        backgroundVideo: "video--background",
        userPaused: "is-paused",
        supportsAutoplay: "autoplay",
        supportsNoAutoplay: "no-autoplay",
        wrapperMinHeight: "video-section-wrapper--min-height",
      },
      h = {
        section: ".video-section",
        videoWrapper: ".video-section-wrapper",
        playVideoBtn: ".video-control__play",
        closeVideoBtn: ".video-control__close-wrapper",
        pauseVideoBtn: ".video__pause",
        pauseVideoStop: ".video__pause-stop",
        pauseVideoResume: ".video__pause-resume",
        fallbackText: ".icon__fallback-text",
      };
  function p(e) {
    (t || n) && e && "function" == typeof l[e].playVideo && s(e);
  }
  function m(e) {
    l[e] && "function" == typeof l[e].pauseVideo && l[e].pauseVideo();
  }
  function s(e, t) {
    var i = c[e],
        s = l[e],
        a = i.$videoWrapper;
    if (n) f(i);
    else {
      if (t || r) return a.removeClass(u.loading), f(i), void s.playVideo();
      s.playVideo();
    }
  }
  function i(e) {
    var t = e ? u.supportsAutoplay : u.supportsNoAutoplay;
    $(document.documentElement).removeClass(u.supportsAutoplay).removeClass(u.supportsNoAutoplay).addClass(t), e || (n = !0), (r = !0);
  }
  function a() {
    t || (S() && (n = !0), n && i(!1), (t = !0));
  }
  function f(e) {
    var t = e.$videoWrapper,
        i = t.find(h.pauseVideoBtn);
    t.removeClass(u.loading),
      i.hasClass(u.userPaused) && i.removeClass(u.userPaused),
      "background" !== e.status &&
      ($("#" + e.id).attr("tabindex", "0"),
       "image_with_play" === e.type && t.removeClass(u.paused).addClass(u.playing),
       setTimeout(function () {
      t.find(h.closeVideoBtn).focus();
    }, d.scrollAnimationDuration));
  }
  function v(e) {
    var t = e.$videoWrapper;
    "image_with_play" === e.type && ("closed" === e.status ? t.removeClass(u.paused) : t.addClass(u.paused)), t.removeClass(u.playing);
  }
  function g(e) {
    var t,
        i = c[e],
        s = i.$videoWrapper,
        a = [u.paused, u.playing].join(" ");
    switch ((S() && s.removeAttr("style"), $("#" + i.id).attr("tabindex", "-1"), (i.status = "closed"), i.type)) {
      case "image_with_play":
        l[e].stopVideo(), v(i);
        break;
      case "background":
        l[e].mute(),
          (t = e),
          $("#" + t)
        .removeClass(u.videoWithImage)
        .addClass(u.backgroundVideo),
          c[t].$videoWrapper.addClass(u.backgroundVideoWrapper),
          (c[t].status = "background"),
          C($("#" + t));
    }
    s.removeClass(a);
  }
  function y(e) {
    var t = e.target.getIframe().id;
    return c[t];
  }
  function b(e, t) {
    var i = c[e],
        s = i.$videoWrapper.offset().top,
        a = i.$videoWrapper.find(h.playVideoBtn),
        r = 0,
        n = 0;
    S() && i.$videoWrapper.parent().toggleClass("page-width", !t),
      t
    ? ((n = S() ? $(window).width() / d.ratio : i.$videoWrapper.width() / d.ratio),
       (r = ($(window).height() - n) / 2),
       i.$videoWrapper.removeClass(u.wrapperMinHeight).animate({ height: n }, 600),
       (S() && Shopify.designMode) || $("html, body").animate({ scrollTop: s - r }, d.scrollAnimationDuration))
    : ((n = S() ? i.$videoWrapper.data("mobile-height") : i.$videoWrapper.data("desktop-height")),
       i.$videoWrapper.height(i.$videoWrapper.width() / d.ratio).animate({ height: n }, 600),
       setTimeout(function () {
      i.$videoWrapper.addClass(u.wrapperMinHeight);
    }, 600),
       a.focus());
  }
  function _(e) {
    var t,
        i = c[e];
    switch ((i.$videoWrapper.addClass(u.loading), i.$videoWrapper.attr("style", "height: " + i.$videoWrapper.height() + "px"), (i.status = "open"), i.type)) {
      case "image_with_play":
        s(e, !0);
        break;
      case "background":
        (t = e),
          $("#" + t)
        .removeClass(u.backgroundVideo)
        .addClass(u.videoWithImage),
          setTimeout(function () {
          $("#" + t).removeAttr("style");
        }, 600),
          c[t].$videoWrapper.removeClass(u.backgroundVideoWrapper).addClass(u.playing),
          (c[t].status = "open"),
          l[e].unMute(),
          s(e, !0);
    }
    b(e, !0),
      $(document).on("keydown.videoPlayer", function (e) {
      var t = $(document.activeElement).data("controls");
      e.keyCode === slate.utils.keyboardKeys.ESCAPE && t && (g(t), b(t, !1));
    });
  }
  function w() {
    $("." + u.backgroundVideo).each(function (e, t) {
      C($(t));
    });
  }
  function C(e) {
    var t, i, s, a;
    o &&
      (S()
       ? e.removeAttr("style")
       : ((i = (t = e.closest(h.videoWrapper)).width()),
          (s = e.width()),
          (a = t.data("desktop-height")),
          i / d.ratio < a
          ? ((s = Math.ceil(a * d.ratio)),
             e
             .width(s)
             .height(a)
             .css({ left: (i - s) / 2, top: 0 }))
          : ((a = Math.ceil(i / d.ratio)),
             e
             .width(i)
             .height(a)
             .css({ left: 0, top: (a - a) / 2 })),
          e.prepareTransition(),
          t.addClass(u.loaded)));
  }
  function S() {
    return $(window).width() < 750 || window.mobileCheck();
  }
  function k() {
    $(document).on("click.videoPlayer", h.playVideoBtn, function (e) {
      _($(e.currentTarget).data("controls"));
    }),
      $(document).on("click.videoPlayer", h.closeVideoBtn, function (e) {
      var t = $(e.currentTarget).data("controls");
      $(e.currentTarget).blur(), g(t), b(t, !1);
    }),
      $(document).on("click.videoPlayer", h.pauseVideoBtn, function (e) {
      var t,
          i,
          s,
          a = $(e.currentTarget).data("controls");
      (i = c[(t = a)].$videoWrapper.find(h.pauseVideoBtn)), (s = i.hasClass(u.userPaused)) ? (i.removeClass(u.userPaused), p(t)) : (i.addClass(u.userPaused), m(t)), i.attr("aria-pressed", !s);
    }),
      $(window).on(
      "resize.videoPlayer",
      $.debounce(200, function () {
        if (o) {
          var e,
              t = window.innerHeight === screen.height;
          if ((w(), S())) {
            for (e in c) c.hasOwnProperty(e) && (c[e].$videoWrapper.hasClass(u.playing) && (t || (m(e), v(c[e]))), c[e].$videoWrapper.height($(document).width() / d.ratio));
            i(!1);
          } else for (e in (i(!0), c)) c[e].$videoWrapper.find("." + u.videoWithImage).length || (l[e].playVideo(), f(c[e]));
        }
      })
    ),
      $(window).on(
      "scroll.videoPlayer",
      $.debounce(50, function () {
        if (o)
          for (var e in c) {
            var t;
            !c.hasOwnProperty(e) ||
              ((t = c[e].$videoWrapper).hasClass(u.playing) &&
               (t.offset().top + 0.75 * t.height() < $(window).scrollTop() || t.offset().top + 0.25 * t.height() > $(window).scrollTop() + $(window).height()) &&
               (g(e), b(e, !1)));
          }
      })
    );
  }
  function T(e) {
    var t = $.extend({}, d, c[e]);
    (t.playerVars.controls = t.controls), (l[e] = new YT.Player(e, t));
  }
  return {
    init: function (e) {
      var t, i;
      e.length &&
        ((c[e.attr("id")] = {
        id: e.attr("id"),
        videoId: e.data("id"),
        type: e.data("type"),
        status: "image_with_play" === e.data("type") ? "closed" : "background",
        $video: e,
        $videoWrapper: e.closest(h.videoWrapper),
        $section: e.closest(h.section),
        controls: "background" === e.data("type") ? 0 : 1,
      }),
         o || (((t = document.createElement("script")).src = "https://www.youtube.com/iframe_api"), (i = document.getElementsByTagName("script")[0]).parentNode.insertBefore(t, i)),
         a());
    },
    editorLoadVideo: function (e) {
      o && (T(e), k());
    },
    loadVideos: function () {
      for (var e in c) c.hasOwnProperty(e) && T(e);
      k(), (o = !0);
    },
    playVideo: p,
    pauseVideo: m,
    removeEvents: function () {
      $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
    },
  };
})()),
  (theme.ProductVideo = (function () {
  var a = {},
      r = { html5: "html5", youtube: "youtube" },
      n = { productMediaWrapper: "[data-product-single-media-wrapper]" },
      o = { enableVideoLooping: "enable-video-looping", videoId: "video-id" };
  function c(e) {
    e
    ? (function () {
      for (var e in a)
        if (a.hasOwnProperty(e)) {
          var t = a[e];
          if (t.nativeVideo) continue;
          t.host === r.html5 && (t.element.setAttribute("controls", "controls"), (t.nativeVideo = !0));
        }
    })()
    : t(r.html5);
  }
  function l() {
    window.YT.Player && t(r.youtube);
  }
  function t(e) {
    for (var t in a) {
      var i;
      !a.hasOwnProperty(t) || ((i = a[t]).host === e && i.ready());
    }
  }
  return {
    init: function (e, t) {
      if (e.length) {
        var i = e.find("iframe, video")[0],
            s = e.data("mediaId");
        if (i)
          switch (
            ((a[s] = {
              mediaId: s,
              sectionId: t,
              host: (function (e) {
                if ("VIDEO" === e.tagName) return r.html5;
                if ("IFRAME" === e.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e.src)) return r.youtube;
                return null;
              })(i),
              container: e,
              element: i,
              ready: function () {
                !(function (e) {
                  if (e.player) return;
                  var t = e.container.closest(n.productMediaWrapper),
                      i = t.data(o.enableVideoLooping);
                  switch (e.host) {
                    case r.html5:
                      e.player = new Shopify.Plyr(e.element, { loop: { active: i } });
                      break;
                    case r.youtube:
                      var s = t.data(o.videoId);
                      e.player = new YT.Player(e.element, {
                        videoId: s,
                        events: {
                          onStateChange: function (e) {
                            0 === e.data && i && e.target.seekTo(0);
                          },
                        },
                      });
                  }
                  t.on("mediaHidden xrLaunch", function () {
                    e.player && (e.host === r.html5 && e.player.pause(), e.host === r.youtube && e.player.pauseVideo && e.player.pauseVideo());
                  }),
                    t.on("mediaVisible", function () {
                    theme.Helpers.isTouch() || (e.player && (e.host === r.html5 && e.player.play(), e.host === r.youtube && e.player.playVideo && e.player.playVideo()));
                  });
                })(this);
              },
            }),
             a[s].host)
          ) {
            case r.html5:
              window.Shopify.loadFeatures([{ name: "video-ui", version: "1.0", onLoad: c }]), theme.LibraryLoader.load("plyrShopifyStyles");
              break;
            case r.youtube:
              theme.LibraryLoader.load("youtubeSdk", l);
          }
      }
    },
    hosts: r,
    loadVideos: t,
    removeSectionVideos: function (e) {
      for (var t in a) {
        var i;
        !a.hasOwnProperty(t) || ((i = a[t]).sectionId === e && (i.player && i.player.destroy(), delete a[t]));
      }
    },
  };
})()),
  (theme.ProductModel = (function () {
  var a = {},
      o = {},
      c = {},
      l = "[data-product-single-media-group]",
      d = "[data-shopify-xr]";
  function r(e) {
    if (!e)
      if (window.ShopifyXR) {
        for (var t in a)
          if (a.hasOwnProperty(t)) {
            var i = a[t];
            if (i.loaded) continue;
            var s = $("#ModelJson-" + t);
            window.ShopifyXR.addModels(JSON.parse(s.html())), (i.loaded = !0);
          }
        window.ShopifyXR.setupXRElements();
      } else
        document.addEventListener("shopify_xr_initialized", function () {
          r();
        });
  }
  function t(e) {
    if (!e)
      for (var t in o) {
        var i;
        o.hasOwnProperty(t) &&
          ((i = o[t]).modelViewerUi || (i.modelViewerUi = new Shopify.ModelViewerUI(i.$element)),
           (function (e) {
          var t = c[e.sectionId];
          e.$container.on("mediaVisible", function () {
            t.$element.attr("data-shopify-model3d-id", e.modelId), theme.Helpers.isTouch() || e.modelViewerUi.play();
          }),
            e.$container
          .on("mediaHidden", function () {
            t.$element.attr("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause();
          })
          .on("xrLaunch", function () {
            e.modelViewerUi.pause();
          });
        })(i));
      }
  }
  return {
    init: function (e, n) {
      (a[n] = { loaded: !1 }),
        e.each(function (e) {
        var t,
            i = $(this),
            s = i.data("media-id"),
            a = $(i.find("model-viewer")[0]),
            r = a.data("model-id");
        0 === e && ((t = i.closest(l).find(d)), (c[n] = { $element: t, defaultId: r })), (o[s] = { modelId: r, sectionId: n, $container: i, $element: a });
      }),
        window.Shopify.loadFeatures([
        { name: "shopify-xr", version: "1.0", onLoad: r },
        { name: "model-viewer-ui", version: "1.0", onLoad: t },
      ]),
        theme.LibraryLoader.load("modelViewerUiStyles");
        },
        removeSectionModels: function (e) {
        for (var t in o) {
        o.hasOwnProperty(t) && o[t].sectionId === e && (o[t].modelViewerUi.destroy(), delete o[t]);
                                    }
                                    delete a[e];
                                    },
                                    };
                                    })()),
        (window.theme = window.theme || {}),
          (theme.FormStatus = (function () {
          var e = "[data-form-status]";
          return {
            init: function () {
              (this.$statusMessage = $(e)),
                this.$statusMessage &&
                (this.$statusMessage.attr("tabindex", -1).focus(),
                 this.$statusMessage.on(
                "blur",
                function () {
                  this.$statusMessage.removeAttr("tabindex");
                }.bind(this)
              ));
            },
          };
        })()),
          (theme.Hero = (function () {
          var n = "index-section--flush",
              o = ".hero-fixed-width__content",
              c = ".hero-fixed-width__image";
          return function (e, t) {
            (this.$hero = $(e)), (this.layout = this.$hero.data("layout"));
            var i = $("#shopify-section-" + t),
                s = i.find(o),
                a = i.find(c);
            function r() {
              var e = s.height() + 50;
              a.height() < e && a.css("min-height", e);
            }
            "fixed_width" === this.layout &&
              (i.removeClass(n),
               r(),
               $(window).resize(
              $.debounce(50, function () {
                r();
              })
            ));
          };
        })()),
          (window.theme = window.theme || {}),
          (theme.SearchResultsTemplate = (function () {
          function a(e, t, i) {
            return [
              '<div class="predictive-search">',
              ((r = t),
               0 !== e.length
               ? [
                '<div class="predictive-search-title">',
                '<h3 id="predictive-search" class="predictive-search-title__content">' + theme.strings.products + "</h3>",
                '<span class="predictive-search-title__loading-spinner">' + (r ? '<span class= "icon-predictive-search-spinner" ></span >' : "") + "</span>",
                "</div>",
              ].join("")
                : ""),
                ((a = i),
                (n = (s = e).length),
                [
                '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
                s
                .map(function (e, t) {
                return (
                (i = {
                url: (0 < (r = e).variants.length ? r.variants[0] : r).url,
              image: (function (e) {
              var t, i;
              return (
              0 < e.variants.length && null !== e.variants[0].image ? (i = e.variants[0].featured_image) : e.image ? (i = e.featured_image) : (t = null),
              null !== t && (t = { url: theme.Images.getSizedImageUrl(i.url, "100x"), alt: i.alt }),
              t
            );
          })(r),
            title: r.title,
              vendor: r.vendor || "",
                price: theme.Currency.formatMoney(r.price_min, theme.moneyFormat),
                  compareAtPrice: theme.Currency.formatMoney(r.compare_at_price_min, theme.moneyFormat),
                    available: r.available,
                      isOnSale: (function (e) {
                        return null !== e.compare_at_price_min && parseInt(e.compare_at_price_min, 10) > parseInt(e.price_min, 10);
                      })(r),
                        isPriceVaries: (function (e) {
                          return e.price_max !== e.price_min;
                        })(r),
                          isCompareVaries: (function (e) {
                            return e.compare_at_price_max !== e.compare_at_price_min;
                          })(r),
        }),
          (a = n),
            [
            '<li id="search-result-' + (s = t) + '" class="predictive-search-item" role="option" data-search-result>',
            '<a class="predictive-search-item__link" href="' + i.url + '" tabindex="-1">',
            '<div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper>',
            (function (e) {
              return null !== e.image
              ? [
                '<div class="placeholder-background placeholder-background--animation" data-image-placeholder aria-hidden="true"></div>',
                '<img class="predictive-search-item__image lazyload" src="' + e.image.url + '" data-src="' + e.image.url + '" data-image alt="' + e.image.alt + '" />',
              ].join("")
                : "";
                })(i),
                "</div>",
                '<div class="predictive-search__column predictive-search__column--content ' + (o() ? "" : "predictive-search__column--center") + '">',
                '<span class="predictive-search-item__title">',
                '<span class="predictive-search-item__title-text">' + i.title + "</span>",
                "</span>" +
                (o()
                ? (function (e) {
                return [
                '<dl class="predictive-search-item__details price' +
                (e.isOnSale ? " price--on-sale" : "") +
                (e.available ? "" : " price--sold-out") +
                (!e.isPriceVaries && e.isCompareVaries ? " price--compare-price-hidden" : "") +
                '">',
                '<div class="predictive-search-item__detail">',
                (function (e) {
                return theme.settings.predictiveSearchShowVendor && "" !== e.vendor
                ? ["<dt>", '<span class="visually-hidden">' + theme.strings.vendor + "</span>", "</dt>", '<dd class="predictive-search-item__vendor">' + e.vendor + "</dd>"].join("")
              : "";
            })(e),
            "</div>",
            '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
            (function (e) {
              if (!theme.settings.predictiveSearchShowPrice) return "";
              var t =
                  '<div class="price__regular">' +
                  (function (e) {
                    return [
                      "<dt>",
                      '<span class="visually-hidden">' + theme.strings.regularPrice + "</span>",
                      "</dt>",
                      "<dd>",
                      '<span class="predictive-search-item__price">' + (e.isPriceVaries ? theme.strings.fromLowestPrice.replace("[price]", e.price) : e.price) + "</span>",
                      "</dd>",
                    ].join("");
                      })(e) +
                      "</div>",
                      i =
                      '<div class="price__sale">' +
                      (function (e) {
                      return [
                      "<dt>",
                      '<span class="visually-hidden">' + theme.strings.salePrice + "</span>",
                      "</dt>",
                      "<dd>",
                      '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
                      (e.isPriceVaries ? theme.strings.fromLowestPrice.replace("[price]", e.price) : e.price) +
                      "</span>",
                      "</dd>",
                      '<div class="price__compare">' +
                      (function (e) {
                      return [
                      "<dt>",
                      '<span class="visually-hidden">' + theme.strings.regularPrice + "</span> ",
                      "</dt>",
                      "<dd>",
                      '<span class="predictive-search-item__price predictive-search-item__price--compare">' + e.compareAtPrice + "</span>",
                      "</dd>",
                    ].join("");
                  })(e) +
                  "</div>",
                  ].join("");
            })(e) +
            "</div>";
            return '<span class="visually-hidden">, </span><div class="price__pricing-group">' + (e.isOnSale ? i : t) + "</div>";
            })(e),
            "</div>",
            "</dl>",
          ].join("");
        })(i)
           : ""),
          '<span class="visually-hidden">, </span>',
          '<span class="visually-hidden">' +
          (function (e, t) {
          return theme.strings.number_of_results.replace("[result_number]", e).replace("[results_count]", t);
        })(s + 1, a) +
          "</span>",
          "</div>",
          "</a>",
          "</li>",
          ].join("")
          );
      var i, s, a, r;
    })
    .join(""),
    '<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
    (function (e) {
    return [
    '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
    theme.strings.searchFor +
    '<span class="predictive-search-view-all__query"> &ldquo;' +
    (function (e) {
    return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  })(e) +
    "&rdquo;</span>",
    "</button>",
    ].join("");
})(a) +
   "</li>",
   "</ul>",
   ].join("")),
  "</div>",
    ].join("");
var s, a, n, r;
}
function o() {
  return [theme.settings.predictiveSearchShowPrice, theme.settings.predictiveSearchShowVendor].reduce(function (e, t) {
    return e + (t ? 1 : 0);
  }, 0);
}
return function (e) {
  var t = e.products || [],
      i = e.isLoading,
      s = e.searchQuery || "";
  return i && 0 === t.length
  ? [
    '<div class="predictive-search">',
    '<div class="predictive-search-loading">',
    '<span class="visually-hidden">' + theme.strings.loading + "</span>",
    '<span class="predictive-search-loading__icon">',
    '<span class="icon-predictive-search-spinner"></span>',
    "</span>",
    "</div>",
    "</div>",
  ].join("")
    : a(t, i, s);
    };
    })()),
    (window.theme = window.theme || {}),
    (function () {
    function e(e) {
    return 1 === e.products.length ? theme.strings.one_result_found : theme.strings.number_of_results_found.replace("[results_count]", e.products.length);
    }
    function t() {
    return theme.strings.loading;
    }
    function i() {
    return JSON.parse($("#shopify-features").text()).predictiveSearch && window.theme.settings.predictiveSearchEnabled;
    }
    function a(e, t) {
    t.addEventListener(
    "click",
    function (e, t) {
    if (0 !== e.value.trim().length) return;
    void 0 !== t && t.preventDefault();
    e.focus();
    }.bind(this, e)
    );
    }
    var r, n, o, s, c, l, d, u, h, p, m, f, v, g, y, b;
    function _() {
    theme.SearchDrawer.close(),
    theme.SearchHeader.unload(),
    theme.SearchPage.unload(),
    b.mobile.matches
    ? (theme.SearchHeader.init({ numberOfResults: 4, isTabletAndUp: !1 }), w() && theme.SearchPage.init({ isTabletAndUp: !1 }))
    : (theme.SearchHeader.init({ numberOfResults: 4, isTabletAndUp: !0 }), w() && theme.SearchPage.init({ isTabletAndUp: !0 }));
    }
    function w() {
    return $("body").hasClass(g.searchTemplate);
    }
    (window.theme.SearchPage =
    ((n = "[data-search-page-predictive-search-clear]"),
    (o = "[data-search-page-predictive-search-input]"),
    (s = "[data-search-page-predictive-search-submit]"),
    (c = '[data-predictive-search-mount="default"]'),
    (l = document.querySelector(o)),
    (d = document.querySelector(s)),
    {
    init: function (s) {
    (r = new window.Shopify.theme.PredictiveSearchComponent({
    selectors: { input: o, reset: n, result: c },
    resultTemplateFct: window.theme.SearchResultsTemplate,
    numberOfResultsTemplateFct: e,
    loadingResultsMessageTemplateFct: t,
    onOpen: function (e) {
    var t, i;
    s.isTabletAndUp || ((t = $(o)[0].getBoundingClientRect()), (i = $("body").height() - t.bottom - 50), $(e.result).css({ maxHeight: i }));
},
  onBeforeDestroy: function (e) {
    $(e.result).css({ maxHeight: "" });
  },
})),
  a(l, d);
},
  unload: function () {
    r && (r.destroy(), (r = null));
  },
})),
  (window.theme.SearchHeader =
   ((h = "[data-predictive-search-drawer-input]"),
    (p = '[data-predictive-search-mount="drawer"]'),
    (m = "[data-search-form-submit]"),
    (f = document.querySelector(h)),
    (v = document.querySelector(m)),
    {
    init: function (s) {
      (u = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: { input: h, result: p },
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: e,
        numberOfResults: s.numberOfResults,
        loadingResultsMessageTemplateFct: t,
        onInputBlur: function () {
          return !1;
        },
        onOpen: function (e) {
          var t = $(f)[0].getBoundingClientRect(),
              i = window.innerHeight - t.bottom - (s.isTabletAndUp ? 20 : 0);
          $(e.result).css({ top: s.isTabletAndUp ? "" : t.bottom, maxHeight: i });
        },
        onClose: function (e) {
          $(e.result).css({ maxHeight: "" });
        },
        onBeforeDestroy: function (e) {
          $(e.result).css({ top: "" });
        },
      })),
        a(f, v);
    },
    unload: function () {
      u && (u.destroy(), (u = null));
    },
    clearAndClose: function () {
      u && u.clearAndClose();
    },
  })),
    (window.theme.Search =
     ((g = { searchTemplate: "template-search" }),
      (y = ".site-header"),
      (b = { mobile: window.matchMedia("(max-width: 749px)"), tabletAndUp: window.matchMedia("(min-width: 750px)") }),
      {
    init: function () {
      $(y).length &&
        i() &&
        (Object.keys(b).forEach(function (e) {
        b[e].addListener(_);
      }),
         _());
    },
    unload: function () {
      theme.SearchHeader.unload(), theme.SearchPage.unload();
    },
  }));
})(),
  (window.theme = window.theme || {}),
  (theme.SearchDrawer = (function () {
  var e,
      t = {
        headerSection: "[data-header-section]",
        drawer: "[data-predictive-search-drawer]",
        drawerOpenButton: "[data-predictive-search-open-drawer]",
        headerSearchInput: "[data-predictive-search-drawer-input]",
        predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]',
      };
  return {
    init: function () {
      $(t.drawerOpenButton).attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false").attr("aria-haspopup", "dialog"),
        (e = new theme.Drawers("SearchDrawer", "top", {
        onDrawerOpen: function () {
          $(t.drawer).css({ height: $(t.headerSection).outerHeight() }),
            theme.MobileNav.closeMobileNav(),
            window.bodyScrollLock.disableBodyScroll(document.querySelector(t.predictiveSearchWrapper), {
            allowTouchMove: function (e) {
              return 1 === $(e).parents(t.predictiveSearchWrapper).length;
            },
          });
        },
        onDrawerClose: function () {
          theme.SearchHeader.clearAndClose(), $(t.drawerOpenButton).focus(), window.bodyScrollLock.clearAllBodyScrollLocks();
        },
        withPredictiveSearch: !0,
        $elementToFocusOnOpen: $(t.headerSearchInput),
      }));
    },
    close: function () {
      e.close();
    },
  };
})()),
  (theme.Disclosure = (function () {
  var e = "[data-disclosure-list]",
      t = "[data-disclosure-toggle]",
      i = "[data-disclosure-input]",
      s = "[data-disclosure-option]",
      a = "disclosure-list--visible";
  function r(e) {
    (this.$container = e), (this.cache = {}), this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut();
  }
  return (
    (r.prototype = _.assignIn({}, r.prototype, {
      _cacheSelectors: function () {
        this.cache = { $disclosureList: this.$container.find(e), $disclosureToggle: this.$container.find(t), $disclosureInput: this.$container.find(i), $disclosureOptions: this.$container.find(s) };
      },
      _connectToggle: function () {
        this.cache.$disclosureToggle.on(
          "click",
          function (e) {
            var t = "true" === $(e.currentTarget).attr("aria-expanded");
            $(e.currentTarget).attr("aria-expanded", !t), this.cache.$disclosureList.toggleClass(a);
          }.bind(this)
        );
      },
      _connectOptions: function () {
        this.cache.$disclosureOptions.on(
          "click",
          function (e) {
            this._submitForm($(e.currentTarget).data("value"));
          }.bind(this)
        );
      },
      _onFocusOut: function () {
        this.cache.$disclosureToggle.on(
          "focusout",
          function (e) {
            0 === this.$container.has(e.relatedTarget).length && this._hideList();
          }.bind(this)
        ),
          this.cache.$disclosureList.on(
          "focusout",
          function (e) {
            var t = 0 < $(e.currentTarget).has(e.relatedTarget).length;
            this.cache.$disclosureList.hasClass(a) && !t && this._hideList();
          }.bind(this)
        ),
          this.$container.on(
          "keyup",
          function (e) {
            e.which === slate.utils.keyboardKeys.ESCAPE && (this._hideList(), this.cache.$disclosureToggle.focus());
          }.bind(this)
        ),
          $("body").on(
          "click",
          function (e) {
            var t = 0 < this.$container.has(e.target).length;
            this.cache.$disclosureList.hasClass(a) && !t && this._hideList();
          }.bind(this)
        );
      },
      _submitForm: function (e) {
        this.cache.$disclosureInput.val(e), this.$container.parents("form").submit();
      },
      _hideList: function () {
        this.cache.$disclosureList.removeClass(a), this.cache.$disclosureToggle.attr("aria-expanded", !1);
      },
      unload: function () {
        this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off();
      },
    })),
    r
  );
})()),
  (function () {
  var e = $("#BlogTagFilter");
  e.length &&
    (slate.utils.resizeSelects(e),
     e.on("change", function () {
    location.href = $(this).val();
  }));
})(),
  (window.theme = theme || {}),
  (theme.customerTemplates = (function () {
  var e = "#RecoverHeading",
      t = "#RecoverEmail",
      i = "#LoginHeading";
  function s() {
    (this.$RecoverHeading = $(e)),
      (this.$RecoverEmail = $(t)),
      (this.$LoginHeading = $(i)),
      $("#RecoverPassword").on(
      "click",
      function (e) {
        e.preventDefault(), a(), this.$RecoverHeading.attr("tabindex", "-1").focus();
      }.bind(this)
    ),
      $("#HideRecoverPasswordLink").on(
      "click",
      function (e) {
        e.preventDefault(), $("#RecoverPasswordForm").addClass("hide"), $("#CustomerLoginForm").removeClass("hide"), this.$LoginHeading.attr("tabindex", "-1").focus();
      }.bind(this)
    ),
      this.$RecoverHeading.on("blur", function () {
      $(this).removeAttr("tabindex");
    }),
      this.$LoginHeading.on("blur", function () {
      $(this).removeAttr("tabindex");
    });
  }
  function a() {
    $("#RecoverPasswordForm").removeClass("hide"), $("#CustomerLoginForm").addClass("hide"), "true" === this.$RecoverEmail.attr("aria-invalid") && this.$RecoverEmail.focus();
  }
  return {
    init: function () {
      var t, i;
      s(),
        (function () {
        "#recover" === window.location.hash && a.bind(this)();
      })(),
        $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide").focus(),
        (t = $("#AddressNewForm")),
        (i = $("#AddressNewButton")),
        t.length &&
        (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
         $(".address-country-option").each(function () {
        var e = $(this).data("form-id"),
            t = "AddressCountry_" + e,
            i = "AddressProvince_" + e,
            s = "AddressProvinceContainer_" + e;
        new Shopify.CountryProvinceSelector(t, i, { hideElement: s });
      }),
         $(".address-new-toggle").on("click", function () {
        var e = "true" === i.attr("aria-expanded");
        t.toggleClass("hide"), i.attr("aria-expanded", !e).focus();
      }),
         $(".address-edit-toggle").on("click", function () {
        var e = $(this).data("form-id"),
            t = $("#EditFormButton_" + e),
            i = $("#EditAddress_" + e),
            s = "true" === t.attr("aria-expanded");
        i.toggleClass("hide"), t.attr("aria-expanded", !s).focus();
      }),
         $(".address-delete").on("click", function () {
        var e = $(this),
            t = e.data("target"),
            i = e.data("confirm-message");
        confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink(t, { parameters: { _method: "delete" } });
      }));
    },
  };
})()),
  (window.theme = window.theme || {}),
  (theme.Cart = (function () {
  var t = "[data-cart-count]",
      i = "[data-cart-count-bubble]",
      e = "[data-cart-discount]",
      s = "[data-cart-discount-title]",
      a = "[data-cart-discount-amount]",
      r = "[data-cart-discount-wrapper]",
      n = "[data-cart-error-message]",
      o = "[data-cart-error-message-wrapper]",
      c = "[data-cart-item]",
      l = "[data-cart-item-details]",
      d = "[data-cart-item-discount]",
      u = "[data-cart-item-discounted-price-group]",
      h = "[data-cart-item-discount-title]",
      p = "[data-cart-item-discount-amount]",
      m = "[data-cart-item-discount-list]",
      f = "[data-cart-item-final-price]",
      v = "[data-cart-item-image]",
      g = "[data-cart-item-line-price]",
      y = "[data-cart-item-original-price]",
      b = "[data-cart-item-price]",
      w = "[data-cart-item-price-list]",
      C = "[data-cart-item-property]",
      S = "[data-cart-item-property-name]",
      k = "[data-cart-item-property-value]",
      T = "[data-cart-item-regular-price-group]",
      P = "[data-cart-item-regular-price]",
      I = "[data-cart-item-title]",
      L = "[data-cart-item-option]",
      x = "[data-cart-line-items]",
      E = "[data-cart-notes]",
      A = "[data-cart-quantity-error-message]",
      M = "[data-cart-quantity-error-message-wrapper]",
      D = "[data-cart-remove]",
      O = "[data-cart-status]",
      N = "[data-cart-subtotal]",
      V = "[data-cart-table-cell]",
      R = "[data-cart-wrapper]",
      F = "[data-empty-page-content]",
      B = "[data-quantity-input]",
      W = "[data-quantity-input-mobile]",
      H = "[data-quantity-input-desktop]",
      q = "[data-quantity-label-mobile]",
      U = "[data-quantity-label-desktop]",
      j = "[data-quantity-input]",
      Q = ".cart__image",
      z = "[data-unit-price]",
      K = "[data-unit-price-base-unit]",
      Y = "[data-unit-price-group]",
      J = "cart--no-cookies",
      G = "cart__removed-product",
      X = "hide",
      Z = "input--error",
      ee = "data-cart-item-index",
      te = "data-cart-item-key",
      ie = "data-cart-item-quantity",
      se = "data-cart-item-title",
      ae = "data-cart-item-url",
      re = "data-quantity-item";
  (theme.breakpoints = theme.breakpoints || {}), (!isNaN(theme.breakpoints.medium) && void 0 !== theme.breakpoints.medium) || (theme.breakpoints.medium = 750);
  var ne = "(min-width: " + theme.breakpoints.medium + "px)";
  function oe(e) {
    (this.$container = $(e)),
      (this.$thumbnails = $(Q, this.$container)),
      (this.ajaxEnabled = this.$container.data("ajax-enabled")),
      this.cookiesEnabled() || this.$container.addClass(J),
      this.$thumbnails.css("cursor", "pointer"),
      this.$container.on("click", Q, this._handleThumbnailClick),
      this.$container.on("change", j, $.debounce(500, this._handleInputQty.bind(this))),
      (this.mql = window.matchMedia(ne)),
      this.mql.addListener(this.setQuantityFormControllers.bind(this)),
      this.setQuantityFormControllers(),
      this.ajaxEnabled && (this.$container.on("change", E, this._onNoteChange.bind(this)), this.$container.on("click", D, this._onRemoveItem.bind(this)), this._setupCartTemplates());
  }
  return (
    (oe.prototype = _.assignIn({}, oe.prototype, {
      _setupCartTemplates: function () {
        (this.$itemTemplate = $(c, this.$container).first().clone()),
          (this.$itemDiscountTemplate = $(d, this.$itemTemplate).clone()),
          (this.$itemOptionTemplate = $(L, this.$itemTemplate).clone()),
          (this.$itemPropertyTemplate = $(C, this.$itemTemplate).clone()),
          (this.$itemPriceListTemplate = $(w, this.$itemTemplate).clone()),
          (this.$itemLinePriceTemplate = $(g, this.$itemTemplate).clone()),
          (this.$cartDiscountTemplate = $(e, this.$container).clone());
      },
      _handleInputQty: function (e) {
        var t = $(e.target),
            i = t.data("quantity-item"),
            s = t.closest(c),
            a = $("[data-quantity-item=" + i + "]"),
            r = parseInt(t.val()),
            n = !(r < 0 || isNaN(r));
        a.val(r), this._hideCartError(), this._hideQuantityErrorMessage(), n ? n && this.ajaxEnabled && this._updateItemQuantity(i, s, a, r) : this._showQuantityErrorMessages(s);
      },
      _updateItemQuantity: function (e, s, t, a) {
        var r = s.attr(te),
            i = s.attr(ee),
            n = { url: "/cart/change.js", data: { quantity: a, line: i }, dataType: "json" };
        $.post(n)
        .done(
          function (e) {
            var t, i;
            0 === e.item_count
            ? this._emptyCart()
            : (this._createCart(e), 0 === a ? this._showRemoveMessage(s.clone()) : ((t = $('[data-cart-item-key="' + r + '"]')), (i = this.getItem(r, e)), $(B, t).focus(), this._updateLiveRegion(i))),
              this._setCartCountBubble(e.item_count);
          }.bind(this)
        )
        .fail(
          function () {
            this._showCartError(t);
          }.bind(this)
        );
      },
      getItem: function (t, e) {
        return e.items.find(function (e) {
          return e.key === t;
        });
      },
      _liveRegionText: function (e) {
        var t = (t = theme.strings.update + ": [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]").replace("[QuantityLabel]", theme.strings.quantity).replace("[Quantity]", e.quantity),
            i = "",
            s = theme.Currency.formatMoney(e.original_line_price, theme.moneyFormat),
            a = "",
            r = "",
            n = "";
        return (
          e.original_line_price > e.final_line_price &&
          ((i = theme.strings.regularTotal), (a = theme.strings.discountedTotal), (r = theme.Currency.formatMoney(e.final_line_price, theme.moneyFormat)), (n = theme.strings.priceColumn)),
          (t = t.replace("[Regular]", i).replace("[$$]", s).replace("[DiscountedPrice]", a).replace("[$]", r).replace("[PriceInformation]", n).trim())
        );
      },
      _updateLiveRegion: function (e) {
        var t = $(O);
        t.html(this._liveRegionText(e)).attr("aria-hidden", !1),
          setTimeout(function () {
          t.attr("aria-hidden", !0);
        }, 1e3);
      },
      _createCart: function (e) {
        var t = this._createCartDiscountList(e);
        $(x, this.$container).html(this._createLineItemList(e)),
          this.setQuantityFormControllers(),
          $(E, this.$container).val(e.note),
          0 === t.length ? $(r, this.$container).html("").addClass(X) : $(r, this.$container).html(t).removeClass(X),
          $(N, this.$container).html(theme.Currency.formatMoney(e.total_price, theme.moneyFormatWithCurrency));
      },
      _createCartDiscountList: function (e) {
        return $.map(
          e.cart_level_discount_applications,
          function (e) {
            var t = this.$cartDiscountTemplate.clone();
            return t.find(s).text(e.title), t.find(a).html(theme.Currency.formatMoney(e.total_allocated_amount, theme.moneyFormat)), t[0];
          }.bind(this)
        );
      },
      _createLineItemList: function (e) {
        return $.map(
          e.items,
          function (e, t) {
            var i = this.$itemTemplate.clone(),
                s = this.$itemPriceListTemplate.clone();
            this._setLineItemAttributes(i, e, t), this._setLineItemImage(i, e.featured_image), $(I, i).text(e.product_title).attr("href", e.url);
            var a = this._createProductDetailsList(e.product_has_only_default_variant, e.options_with_values, e.properties);
            this._setProductDetailsList(i, a),
              this._setItemRemove(i, e.title),
              s.html(this._createItemPrice(e.original_price, e.final_price, this.$itemPriceListTemplate)),
              e.unit_price_measurement && s.append(this._createUnitPrice(e.unit_price, e.unit_price_measurement, this.$itemPriceListTemplate)),
              this._setItemPrice(i, s);
            var r = this._createItemDiscountList(e);
            this._setItemDiscountList(i, r), this._setQuantityInputs(i, e, t);
            var n = this._createItemPrice(e.original_line_price, e.final_line_price, this.$itemLinePriceTemplate);
            return this._setItemLinePrice(i, n), i[0];
          }.bind(this)
        );
      },
      _setLineItemAttributes: function (e, t, i) {
        e.attr(te, t.key)
        .attr(ae, t.url)
        .attr(se, t.title)
        .attr(ee, i + 1)
        .attr(ie, t.quantity);
      },
      _setLineItemImage: function (e, t) {
        var i = $(v, e),
            s = null !== t.url ? theme.Images.getSizedImageUrl(t.url, "x190") : null;
        s ? i.attr("alt", t.alt).attr("src", s).removeClass(X) : i.remove();
      },
      _setProductDetailsList: function (e, t) {
        var i = $(l, e);
        0 === t.length ? i.addClass(X).text("") : i.removeClass(X).html(t);
      },
      _setItemPrice: function (e, t) {
        $(b, e).html(t);
      },
      _setItemDiscountList: function (e, t) {
        var i = $(m, e);
        0 === t.length ? i.html("").addClass(X) : i.html(t).removeClass(X);
      },
      _setItemRemove: function (e, t) {
        $(D, e).attr("aria-label", theme.strings.removeLabel.replace("[product]", t));
      },
      _setQuantityInputs: function (e, t, i) {
        $(W, e)
        .attr("id", "updates_" + t.key)
        .attr(re, i + 1)
        .val(t.quantity),
          $(H, e)
        .attr("id", "updates_large_" + t.key)
        .attr(re, i + 1)
        .val(t.quantity),
          $(q, e).attr("for", "updates_" + t.key),
          $(U, e).attr("for", "updates_large_" + t.key);
      },
      setQuantityFormControllers: function () {
        this.mql.matches ? ($(H).attr("name", "updates[]"), $(W).removeAttr("name")) : ($(W).attr("name", "updates[]"), $(H).removeAttr("name"));
      },
      _setItemLinePrice: function (e, t) {
        $(g, e).html(t);
      },
      _createProductDetailsList: function (e, t, i) {
        var s = [];
        return e || (s = s.concat(this._getOptionList(t))), null !== i && 0 !== Object.keys(i).length && (s = s.concat(this._getPropertyList(i))), s;
      },
      _getOptionList: function (e) {
        return $.map(
          e,
          function (e) {
            var t = this.$itemOptionTemplate.clone();
            return t.text(e.name + ": " + e.value).removeClass(X), t[0];
          }.bind(this)
        );
      },
      _getPropertyList: function (e) {
        var t = null !== e ? Object.entries(e) : [];
        return $.map(
          t,
          function (e) {
            var t = this.$itemPropertyTemplate.clone();
            if ("_" !== e[0].charAt(0) && 0 !== e[1].length)
              return t.find(S).text(e[0]), -1 === e[0].indexOf("/uploads/") ? t.find(k).text(": " + e[1]) : t.find(k).html(': <a href="' + e[1] + '"> ' + e[1].split("/").pop() + "</a>"), t.removeClass(X), t[0];
          }.bind(this)
        );
      },
      _createItemPrice: function (e, t, i) {
        if (e !== t) {
          var s = $(u, i).clone();
          return $(y, s).html(theme.Currency.formatMoney(e, theme.moneyFormat)), $(f, s).html(theme.Currency.formatMoney(t, theme.moneyFormat)), s.removeClass(X), s[0];
        }
        var a = $(T, i).clone();
        return $(P, a).html(theme.Currency.formatMoney(e, theme.moneyFormat)), a.removeClass(X), a[0];
      },
      _createUnitPrice: function (e, t, i) {
        var s = $(Y, i).clone(),
            a = (1 !== t.reference_value ? t.reference_value : "") + t.reference_unit;
        return $(K, s).text(a), $(z, s).html(theme.Currency.formatMoney(e, theme.moneyFormat)), s.removeClass(X), s[0];
      },
      _createItemDiscountList: function (e) {
        return $.map(
          e.line_level_discount_allocations,
          function (e) {
            var t = this.$itemDiscountTemplate.clone();
            return t.find(h).text(e.discount_application.title), t.find(p).html(theme.Currency.formatMoney(e.amount, theme.moneyFormat)), t[0];
          }.bind(this)
        );
      },
      _showQuantityErrorMessages: function (e) {
        $(A, e).text(theme.strings.quantityMinimumMessage), $(M, e).removeClass(X), $(j, e).addClass(Z).focus();
      },
      _hideQuantityErrorMessage: function () {
        var e = $(M).addClass(X);
        $(A, e).text(""), $(j, this.$container).removeClass(Z);
      },
      _handleThumbnailClick: function (e) {
        var t = $(e.target).closest(c).data("cart-item-url");
        window.location.href = t;
      },
      _onNoteChange: function (e) {
        var t = e.currentTarget.value;
        this._hideCartError(), this._hideQuantityErrorMessage();
        var i = { url: "/cart/update.js", data: { note: t }, dataType: "json" };
        $.post(i).fail(
          function () {
            this._showCartError(e.currentTarget);
          }.bind(this)
        );
      },
      _showCartError: function (e) {
        $(n).text(theme.strings.cartError), $(o).removeClass(X), e.focus();
      },
      _hideCartError: function () {
        $(o).addClass(X), $(n).text("");
      },
      _onRemoveItem: function (e) {
        e.preventDefault();
        var t = $(e.target).closest(c),
            i = t.attr(ee);
        this._hideCartError();
        var s = { url: "/cart/change.js", data: { quantity: 0, line: i }, dataType: "json" };
        $.post(s)
        .done(
          function (e) {
            0 === e.item_count ? this._emptyCart() : (this._createCart(e), this._showRemoveMessage(t.clone())), this._setCartCountBubble(e.item_count);
          }.bind(this)
        )
        .fail(
          function () {
            this._showCartError(null);
          }.bind(this)
        );
      },
      _showRemoveMessage: function (e) {
        var t,
            i = e.data("cart-item-index"),
            s = this._getRemoveMessage(e);
        i - 1 == 0 ? ((t = $('[data-cart-item-index="1"]', this.$container)), $(s).insertBefore(t)) : ((t = $('[data-cart-item-index="' + (i - 1) + '"]', this.$container)), s.insertAfter(t)), s.focus();
      },
      _getRemoveMessage: function (e) {
        var t = this._formatRemoveMessage(e),
            i = $(V, e).clone();
        return i.removeClass().addClass(G).attr("colspan", "4").html(t), e.attr("role", "alert").html(i).attr("tabindex", "-1"), e;
      },
      _formatRemoveMessage: function (e) {
        var t = e.data("cart-item-quantity"),
            i = e.attr(ae),
            s = e.attr(se);
        return theme.strings.removedItemMessage.replace("[quantity]", t).replace("[link]", '<a href="' + i + '" class="text-link text-link--accent">' + s + "</a>");
      },
      _setCartCountBubble: function (e) {
        (this.$cartCountBubble = this.$cartCountBubble || $(i)),
          (this.$cartCount = this.$cartCount || $(t)),
          0 < e ? (this.$cartCountBubble.removeClass(X), this.$cartCount.html(e)) : (this.$cartCountBubble.addClass(X), this.$cartCount.html(""));
      },
      _emptyCart: function () {
        (this.$emptyPageContent = this.$emptyPageContent || $(F, this.$container)), (this.$cartWrapper = this.$cartWrapper || $(R, this.$container)), this.$emptyPageContent.removeClass(X), this.$cartWrapper.addClass(X);
      },
      cookiesEnabled: function () {
        var e = navigator.cookieEnabled;
        return e || ((document.cookie = "testcookie"), (e = -1 !== document.cookie.indexOf("testcookie"))), e;
      },
    })),
    oe
  );
})()),
  (window.theme = window.theme || {}),
  (theme.Filters = (function () {
  var t = "screen and (min-width: 750px)",
      i = "#FilterTags",
      s = "#SortBy",
      e = "data-default-sortby";
  function a(e) {
    var t = (this.$container = $(e));
    (this.$filterSelect = $(i, t)),
      (this.$sortSelect = $(s, t)),
      (this.$selects = $(i, t).add($(s, t))),
      (this.defaultSort = this._getDefaultSortValue()),
      this.$selects.removeClass("hidden"),
      this.$filterSelect.on("change", this._onFilterChange.bind(this)),
      this.$sortSelect.on("change", this._onSortChange.bind(this)),
      this._initBreakpoints(),
      this._initParams();
  }
  return (
    (a.prototype = _.assignIn({}, a.prototype, {
      _initBreakpoints: function () {
        var e = this;
        enquire.register(t, {
          match: function () {
            slate.utils.resizeSelects(e.$selects);
          },
        });
      },
      _initParams: function () {
        if (((self.queryParams = {}), location.search.length))
          for (var e, t = location.search.substr(1).split("&"), i = 0; i < t.length; i++) 1 < (e = t[i].split("=")).length && (self.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1]));
      },
      _onSortChange: function () {
        (self.queryParams.sort_by = this._getSortValue()), self.queryParams.page && delete self.queryParams.page, (window.location.search = decodeURIComponent($.param(self.queryParams)));
      },
      _onFilterChange: function () {
        document.location.href = this._getFilterValue();
      },
      _getFilterValue: function () {
        return this.$filterSelect.val();
      },
      _getSortValue: function () {
        return this.$sortSelect.val() || this.defaultSort;
      },
      _getDefaultSortValue: function () {
        return this.$sortSelect.attr(e);
      },
      onUnload: function () {
        this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange);
      },
    })),
    a
  );
})()),
  (window.theme = window.theme || {}),
  (theme.HeaderSection = (function () {
  function e() {
    theme.Header.init(), theme.MobileNav.init(), theme.SearchDrawer.init(), theme.Search.init();
  }
  return (
    (e.prototype = _.assignIn({}, e.prototype, {
      onUnload: function () {
        theme.Header.unload(), theme.Search.unload();
      },
    })),
    e
  );
})()),
  (theme.Maps = (function () {
  var r = 14,
      t = null,
      i = [],
      n = { addressNoResults: theme.strings.addressNoResults, addressQueryLimit: theme.strings.addressQueryLimit, addressError: theme.strings.addressError, authError: theme.strings.authError },
      e = '[data-section-type="map"]',
      s = "[data-map]",
      a = "[data-map-overlay]",
      o = "map-section--load-error",
      c = "map-section__error errors text-center";
  function l(e) {
    (this.$container = $(e)),
      (this.$map = this.$container.find(s)),
      (this.key = this.$map.data("api-key")),
      void 0 !== this.key &&
        ("loaded" === t
         ? this.createMap()
         : (i.push(this),
            "loading" !== t &&
            ((t = "loading"),
             void 0 === window.google &&
             $.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
        (t = "loaded"),
          $.each(i, function (e, t) {
          t.createMap();
        });
      }))));
  }
  return (
    (window.gm_authFailure = function () {
      Shopify.designMode && ($(e).addClass(o), $(s).remove(), $(a).after('<div class="' + c + '">' + theme.strings.authError + "</div>"));
    }),
    (l.prototype = _.assignIn({}, l.prototype, {
      createMap: function () {
        var e,
            i,
            t,
            s,
            a = this.$map;
        return (
          (e = a),
          (i = $.Deferred()),
          (t = new google.maps.Geocoder()),
          (s = e.data("address-setting")),
          t.geocode({ address: s }, function (e, t) {
            t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e);
          }),
          i
          .then(
            function (e) {
              var t = { zoom: r, center: e[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                  i = (this.map = new google.maps.Map(a[0], t)),
                  s = (this.center = i.getCenter());
              new google.maps.Marker({ map: i, position: i.getCenter() });
              google.maps.event.addDomListener(
                window,
                "resize",
                $.debounce(250, function () {
                  google.maps.event.trigger(i, "resize"), i.setCenter(s), a.removeAttr("style");
                })
              );
            }.bind(this)
          )
          .fail(function () {
            var e;
            switch (status) {
              case "ZERO_RESULTS":
                e = n.addressNoResults;
                break;
              case "OVER_QUERY_LIMIT":
                e = n.addressQueryLimit;
                break;
              case "REQUEST_DENIED":
                e = n.authError;
                break;
              default:
                e = n.addressError;
            }
            Shopify.designMode &&
              a
            .parent()
            .addClass(o)
            .html('<div class="' + c + '">' + e + "</div>");
          })
        );
      },
      onUnload: function () {
        0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize");
      },
    })),
    l
  );
})()),
  (theme.Product = (function () {
  function e(e) {
    var t = (this.$container = $(e)),
        i = t.attr("data-section-id");
    (this.ajaxEnabled = t.data("ajax-enabled")),
      (this.settings = {
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      mediaQuerySmall: "screen and (max-width: 749px)",
      bpSmall: !1,
      enableHistoryState: t.data("enable-history-state") || !1,
      namespace: ".slideshow-" + i,
      sectionId: i,
      sliderActive: !1,
      zoomEnabled: !1,
    }),
      (this.selectors = {
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      cartCount: "[data-cart-count]",
      cartCountBubble: "[data-cart-count-bubble]",
      cartPopup: "[data-cart-popup]",
      cartPopupCartQuantity: "[data-cart-popup-cart-quantity]",
      cartPopupClose: "[data-cart-popup-close]",
      cartPopupDismiss: "[data-cart-popup-dismiss]",
      cartPopupImage: "[data-cart-popup-image]",
      cartPopupImageWrapper: "[data-cart-popup-image-wrapper]",
      cartPopupImagePlaceholder: "[data-cart-popup-image-placeholder]",
      cartPopupPlaceholderSize: "[data-placeholder-size]",
      cartPopupProductDetails: "[data-cart-popup-product-details]",
      cartPopupQuantity: "[data-cart-popup-quantity]",
      cartPopupQuantityLabel: "[data-cart-popup-quantity-label]",
      cartPopupTitle: "[data-cart-popup-title]",
      cartPopupWrapper: "[data-cart-popup-wrapper]",
      loader: "[data-loader]",
      loaderStatus: "[data-loader-status]",
      quantity: "[data-quantity-input]",
      SKU: ".variant-sku",
      productStatus: "[data-product-status]",
      originalSelectorId: "#ProductSelect-" + i,
      productForm: "[data-product-form]:not([exclude])",
      errorMessage: "[data-error-message]",
      errorMessageWrapper: "[data-error-message-wrapper]",
      imageZoomWrapper: "[data-image-zoom-wrapper]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productThumbImages: ".product-single__thumbnail--" + i,
      productThumbs: ".product-single__thumbnails-" + i,
      productThumbListItem: ".product-single__thumbnails-item",
      productThumbsWrapper: ".thumbnails-wrapper",
      saleLabel: ".product-price__sale-label-" + i,
      singleOptionSelector: ".single-option-selector-" + i,
      shopifyPaymentButton: ".shopify-payment-button",
      productMediaTypeVideo: "[data-product-media-type-video]",
      productMediaTypeModel: "[data-product-media-type-model]",
      priceContainer: "[data-price]",
      regularPrice: "[data-regular-price]",
      salePrice: "[data-sale-price]",
      unitPrice: "[data-unit-price]",
      unitPriceBaseUnit: "[data-unit-price-base-unit]",
      productPolicies: "[data-product-policies]",
    }),
      (this.classes = {
      cartPopupWrapperHidden: "cart-popup-wrapper--hidden",
      hidden: "hide",
      visibilityHidden: "visibility-hidden",
      inputError: "input--error",
      jsZoomEnabled: "js-zoom-enabled",
      productOnSale: "price--on-sale",
      productUnitAvailable: "price--unit-available",
      productUnavailable: "price--unavailable",
      productSoldOut: "price--sold-out",
      cartImage: "cart-popup-item__image",
      productFormErrorMessageWrapperHidden: "product-form__error-message-wrapper--hidden",
      activeClass: "active-thumb",
      variantSoldOut: "product-form--variant-sold-out",
    }),
      (this.$quantityInput = $(this.selectors.quantity, t)),
      (this.$errorMessageWrapper = $(this.selectors.errorMessageWrapper, t)),
      (this.$addToCart = $(this.selectors.addToCart, t)),
      (this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart)),
      (this.$shopifyPaymentButton = $(this.selectors.shopifyPaymentButton, t)),
      (this.$productPolicies = $(this.selectors.productPolicies, t)),
      (this.$loader = $(this.selectors.loader, this.$addToCart)),
      (this.$loaderStatus = $(this.selectors.loaderStatus, t)),
      $("#ProductJson-" + i).html() &&
      ((this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML)),
       (this.settings.zoomEnabled = $(this.selectors.imageZoomWrapper).hasClass(this.classes.jsZoomEnabled)),
       this._initBreakpoints(),
       this._stringOverrides(),
       this._initVariants(),
       this._initMediaSwitch(),
       this._initAddToCart(),
       this._setActiveThumbnail(),
       this._initProductVideo(),
       this._initModelViewerLibraries(),
       this._initShopifyXrLaunch());
  }
  return (
    (e.prototype = _.assignIn({}, e.prototype, {
      _stringOverrides: function () {
        (theme.productStrings = theme.productStrings || {}), $.extend(theme.strings, theme.productStrings);
      },
      _initBreakpoints: function () {
        var e = this;
        enquire.register(this.settings.mediaQuerySmall, {
          match: function () {
            4 < $(e.selectors.productThumbImages).length && e._initThumbnailSlider(),
              e.settings.zoomEnabled &&
              $(e.selectors.imageZoomWrapper).each(function () {
              $(this).trigger("zoom.destroy");
            }),
              (e.settings.bpSmall = !0);
          },
          unmatch: function () {
            e.settings.sliderActive && e._destroyThumbnailSlider(), (e.settings.bpSmall = !1);
          },
        }),
          enquire.register(this.settings.mediaQueryMediumUp, {
          match: function () {
            e.settings.zoomEnabled &&
              $(e.selectors.imageZoomWrapper).each(function () {
              var e, t;
              (e = this), (t = $(e).data("zoom")), $(e).zoom({ url: t });
            });
          },
        });
      },
      _initVariants: function () {
        var e = {
          $container: this.$container,
          enableHistoryState: this.$container.data("enable-history-state") || !1,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          product: this.productSingleObject,
        };
        (this.variants = new slate.Variants(e)),
          this.$container.on("variantChange" + this.settings.namespace, this._updateAvailability.bind(this)),
          this.$container.on("variantImageChange" + this.settings.namespace, this._updateMedia.bind(this)),
          this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)),
          this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this));
      },
      _initMediaSwitch: function () {
        var i;
        $(this.selectors.productThumbImages).length &&
          ((i = this),
           $(this.selectors.productThumbImages)
           .on("click", function (e) {
          e.preventDefault();
          var t = $(this).data("thumbnail-id");
          i._switchMedia(t), i._setActiveThumbnail(t);
        })
           .on("keyup", i._handleMediaFocus.bind(i)));
      },
      _initAddToCart: function () {
        $('.variant--block .product-form').each( function(){
          $(this, this.$container).on('submit', function(e){
              var t, i;
              this.$addToCart.is("[aria-disabled]")
              ? e.preventDefault()
              : this.ajaxEnabled &&
                (e.preventDefault(),
                 (this.$previouslyFocusedElement = $(":focus")),
                 (t = this.$quantityInput.val() <= 0)
                 ? this._showErrorMessage(theme.strings.quantityMinimumMessage)
                 : t || !this.ajaxEnabled || (this._handleButtonLoadingState(!0), (i = $(this.selectors.productForm, this.$container)), this._addItemToCart(i)));
            });
      }.bind(this)
                                               );
        $(this.selectors.productForm, this.$container).on(
          "submit",
          function (e) {
            var t, i;
            this.$addToCart.is("[aria-disabled]")
            ? e.preventDefault()
            : this.ajaxEnabled &&
              (e.preventDefault(),
               (this.$previouslyFocusedElement = $(":focus")),
               (t = this.$quantityInput.val() <= 0)
               ? this._showErrorMessage(theme.strings.quantityMinimumMessage)
               : t || !this.ajaxEnabled || (this._handleButtonLoadingState(!0), (i = $(this.selectors.productForm, this.$container)), this._addItemToCart(i)));
          }.bind(this)
        );
      },
      _initProductVideo: function () {
        var t = this.settings.sectionId;
        $(this.selectors.productMediaTypeVideo, this.$container).each(function () {
          var e = $(this);
          theme.ProductVideo.init(e, t);
        });
      },
      _initModelViewerLibraries: function () {
        var e = $(this.selectors.productMediaTypeModel, this.$container);
        e.length < 1 || theme.ProductModel.init(e, this.settings.sectionId);
      },
      _initShopifyXrLaunch: function () {
        var e = this;
        $(document).on("shopify_xr_launch", function () {
          $(e.selectors.productMediaWrapper + ":not(." + e.classes.hidden + ")", e.$container).trigger("xrLaunch");
        });
      },
      _addItemToCart: function (e) {
        var t = { url: "/cart/add.js", data: $(e).serialize(), dataType: "json" };
        $.post(t)
        .done(
          function (e) {
            this._hideErrorMessage(), this._setupCartPopup(e);
          }.bind(this)
        )
        .fail(
          function (e) {
            this.$previouslyFocusedElement.focus();
            var t = e.responseJSON ? e.responseJSON.description : theme.strings.cartError;
            this._showErrorMessage(t), this._handleButtonLoadingState(!1);
          }.bind(this)
        );
      },
      _handleButtonLoadingState: function (e) {
        e
        ? (this.$addToCart.attr("aria-disabled", !0),
           this.$addToCartText.addClass(this.classes.hidden),
           this.$loader.removeClass(this.classes.hidden),
           this.$shopifyPaymentButton.attr("disabled", !0),
           this.$loaderStatus.attr("aria-hidden", !1))
        : (this.$addToCart.removeAttr("aria-disabled"),
           this.$addToCartText.removeClass(this.classes.hidden),
           this.$loader.addClass(this.classes.hidden),
           this.$shopifyPaymentButton.removeAttr("disabled"),
           this.$loaderStatus.attr("aria-hidden", !0));
      },
      _showErrorMessage: function (e) {
        $(this.selectors.errorMessage, this.$container).html(e),
          0 !== this.$quantityInput.length && this.$quantityInput.addClass(this.classes.inputError),
          this.$errorMessageWrapper.removeClass(this.classes.productFormErrorMessageWrapperHidden).attr("aria-hidden", !0).removeAttr("aria-hidden");
      },
      _hideErrorMessage: function () {
        this.$errorMessageWrapper.addClass(this.classes.productFormErrorMessageWrapperHidden), 0 !== this.$quantityInput.length && this.$quantityInput.removeClass(this.classes.inputError);
      },
      _setupCartPopup: function (e) {
        (this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup)),
          (this.$cartPopupWrapper = this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper)),
          (this.$cartPopupTitle = this.$cartPopupTitle || $(this.selectors.cartPopupTitle)),
          (this.$cartPopupQuantity = this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity)),
          (this.$cartPopupQuantityLabel = this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel)),
          (this.$cartPopupClose = this.$cartPopupClose || $(this.selectors.cartPopupClose)),
          (this.$cartPopupDismiss = this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss)),
          (this.$cartPopupImagePlaceholder = this.$cartPopupImagePlaceholder || $(this.selectors.cartPopupImagePlaceholder)),
          this._setupCartPopupEventListeners(),
          this._updateCartPopupContent(e);
      },
      _updateCartPopupContent: function (e) {
        var t = this.$quantityInput.length ? this.$quantityInput.val() : 1;
        this.$cartPopupTitle.text(e.product_title),
          this.$cartPopupQuantity.text(t),
          this.$cartPopupQuantityLabel.text(theme.strings.quantityLabel.replace("[count]", t)),
          this._setCartPopupPlaceholder(e.featured_image.url, e.featured_image.aspect_ratio),
          this._setCartPopupImage(e.featured_image.url, e.featured_image.alt),
          this._setCartPopupProductDetails(e.product_has_only_default_variant, e.options_with_values, e.properties),
          $.getJSON("/cart.js").then(
          function (e) {
            this._setCartQuantity(e.item_count), this._setCartCountBubble(e.item_count), this._showCartPopup();
          }.bind(this)
        );
      },
      _setupCartPopupEventListeners: function () {
        this.$cartPopupWrapper.on(
          "keyup",
          function (e) {
            e.keyCode === slate.utils.keyboardKeys.ESCAPE && this._hideCartPopup(e);
          }.bind(this)
        ),
          this.$cartPopupClose.on("click", this._hideCartPopup.bind(this)),
          this.$cartPopupDismiss.on("click", this._hideCartPopup.bind(this)),
          $("body").on("click", this._onBodyClick.bind(this));
      },
      _setCartPopupPlaceholder: function (e, t) {
        var i, s, a;
        (this.$cartPopupImageWrapper = this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper)),
          null !== e
        ? ((i = $(this.selectors.cartPopupPlaceholderSize)), (s = 95 * t), (a = 100 / t), this.$cartPopupImagePlaceholder.css("max-width", s), i.css("padding-top", a + "%"))
        : this.$cartPopupImageWrapper.addClass(this.classes.hidden);
      },
      _setCartPopupImage: function (e, t) {
        var i, s;
        null !== e &&
          (this.$cartPopupImageWrapper.removeClass(this.classes.hidden),
           (i = theme.Images.getSizedImageUrl(e, "200x")),
           ((s = document.createElement("img")).src = i),
           (s.alt = t),
           s.classList.add(this.classes.cartImage),
           (s.dataset.cartPopupImage = ""),
           (s.onload = function () {
          this.$cartPopupImagePlaceholder.addClass(this.classes.hidden), this.$cartPopupImageWrapper.append(s);
        }.bind(this)));
      },
      _setCartPopupProductDetails: function (e, t, i) {
        this.$cartPopupProductDetails = this.$cartPopupProductDetails || $(this.selectors.cartPopupProductDetails);
        var s = "";
        e || (s += this._getVariantOptionList(t)),
          null !== i && 0 !== Object.keys(i).length && (s += this._getPropertyList(i)),
          0 === s.length ? (this.$cartPopupProductDetails.html(""), this.$cartPopupProductDetails.attr("hidden", "")) : (this.$cartPopupProductDetails.html(s), this.$cartPopupProductDetails.removeAttr("hidden"));
      },
      _getVariantOptionList: function (e) {
        var t = "";
        return (
          e.forEach(function (e) {
            t = t + '<li class="product-details__item product-details__item--variant-option">' + e.name + ": " + e.value + "</li>";
          }),
          t
        );
      },
      _getPropertyList: function (e) {
        var t = "";
        return (
          Object.entries(e).forEach(function (e) {
            "_" !== e[0].charAt(0) && 0 !== e[1].length && (t = t + '<li class="product-details__item product-details__item--property"><span class="product-details__property-label">' + e[0] + ": </span>" + e[1]);
          }),
          t
        );
      },
      _setCartQuantity: function (e) {
        var t;
        (this.$cartPopupCartQuantity = this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity)),
          1 === e ? (t = theme.strings.oneCartCount) : 1 < e && (t = theme.strings.otherCartCount.replace("[count]", e)),
          this.$cartPopupCartQuantity.text(e).attr("aria-label", t);
      },
      _setCartCountBubble: function (e) {
        (this.$cartCountBubble = this.$cartCountBubble || $(this.selectors.cartCountBubble)),
          (this.$cartCount = this.$cartCount || $(this.selectors.cartCount)),
          this.$cartCountBubble.removeClass(this.classes.hidden),
          this.$cartCount.text(e);
      },
      _showCartPopup: function () {
        this.$cartPopupWrapper.prepareTransition().removeClass(this.classes.cartPopupWrapperHidden),
          this._handleButtonLoadingState(!1),
          slate.a11y.trapFocus({ $container: this.$cartPopupWrapper, $elementToFocus: this.$cartPopup, namespace: "cartPopupFocus" });
      },
      _hideCartPopup: function (e) {
        var t = 0 === e.detail;
        this.$cartPopupWrapper.prepareTransition().addClass(this.classes.cartPopupWrapperHidden),
          $(this.selectors.cartPopupImage).remove(),
          this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden),
          slate.a11y.removeTrapFocus({ $container: this.$cartPopupWrapper, namespace: "cartPopupFocus" }),
          t && this.$previouslyFocusedElement[0].focus(),
          this.$cartPopupWrapper.off("keyup"),
          this.$cartPopupClose.off("click"),
          this.$cartPopupDismiss.off("click"),
          $("body").off("click");
      },
      _onBodyClick: function (e) {
        var t = $(e.target);
        t[0] === this.$cartPopupWrapper[0] || t.parents(this.selectors.cartPopup).length || this._hideCartPopup(e);
      },
      _setActiveThumbnail: function (e) {
        void 0 === e && (e = $(this.selectors.productMediaWrapper + ":not(.hide)", this.$container).data("media-id"));
        var t,
            i = $(this.selectors.productThumbListItem + ":not(.slick-cloned)", this.$container),
            s = i.find(this.selectors.productThumbImages + "[data-thumbnail-id='" + e + "']");
        $(this.selectors.productThumbImages).removeClass(this.classes.activeClass).removeAttr("aria-current"),
          s.addClass(this.classes.activeClass),
          s.attr("aria-current", !0),
          i.hasClass("slick-slide") && ((t = s.parent().data("slick-index")), $(this.selectors.productThumbs).slick("slickGoTo", t, !0));
      },
      _switchMedia: function (e) {
        var t = $(this.selectors.productMediaWrapper + ":not(." + this.classes.hidden + ")", this.$container),
            i = $(this.selectors.productMediaWrapper + "[data-media-id='" + e + "']", this.$container),
            s = $(this.selectors.productMediaWrapper + ":not([data-media-id='" + e + "'])", this.$container);
        t.trigger("mediaHidden"), i.removeClass(this.classes.hidden).trigger("mediaVisible"), s.addClass(this.classes.hidden);
      },
      _handleMediaFocus: function (e) {
        var t;
        e.keyCode === slate.utils.keyboardKeys.ENTER && ((t = $(e.currentTarget).data("thumbnail-id")), $(this.selectors.productMediaWrapper + "[data-media-id='" + t + "']", this.$container).focus());
      },
      _initThumbnailSlider: function () {
        var e = { slidesToShow: 3, slidesToScroll: 2, infinite: !1, prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId, nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId };
        $(this.selectors.productThumbs).slick(e),
          $(this.selectors.productThumbsWrapper, this.$container).find(".slick-list").removeAttr("aria-live"),
          $(this.selectors.productThumbsWrapper, this.$container).find(".slick-disabled").removeAttr("aria-disabled"),
          (this.settings.sliderActive = !0);
      },
      _destroyThumbnailSlider: function () {
        $(this.selectors.productThumbs).slick("unslick"), (this.settings.sliderActive = !1), $(this.selectors.productThumbsWrapper, this.$container).find('[tabindex="-1"]').removeAttr("tabindex");
      },
      _liveRegionText: function (e) {
        var t = "[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]";
        if (!e) return (t = theme.strings.unavailable);
        var i = e.available ? "" : theme.strings.soldOut + ",",
            t = t.replace("[Availability]", i),
            s = "",
            a = theme.Currency.formatMoney(e.price, theme.moneyFormat),
            r = "",
            n = "",
            o = "",
            c = "";
        return (
          e.compare_at_price > e.price &&
          ((s = theme.strings.regularPrice), (a = theme.Currency.formatMoney(e.compare_at_price, theme.moneyFormat) + ","), (r = theme.strings.sale), (n = theme.Currency.formatMoney(e.price, theme.moneyFormat))),
          e.unit_price && ((o = theme.strings.unitPrice), (c = theme.Currency.formatMoney(e.unit_price, theme.moneyFormat) + " " + theme.strings.unitPriceSeparator + " " + this._getBaseUnit(e))),
          (t = t.replace("[Regular]", s).replace("[$$]", a).replace("[Sale]", r).replace("[$]", n).replace("[UnitPrice]", o).replace("[$$$]", c).trim())
        );
      },
      _updateLiveRegion: function (e) {
        var t = e.variant,
            i = this.container.querySelector(this.selectors.productStatus);
        (i.innerHTML = this._liveRegionText(t)),
          i.setAttribute("aria-hidden", !1),
          setTimeout(function () {
          i.setAttribute("aria-hidden", !0);
        }, 1e3);
      },
      _updateAddToCart: function (e) {
        var t = e.variant;
        t
        ? t.available
        ? (this.$addToCart.removeAttr("aria-disabled").attr("aria-label", theme.strings.addToCart),
           $(this.selectors.addToCartText, this.$container).text(theme.strings.addToCart),
           $(this.selectors.productForm, this.container).removeClass(this.classes.variantSoldOut))
        : (this.$addToCart.attr("aria-disabled", !0).attr("aria-label", theme.strings.soldOut),
           $(this.selectors.addToCartText, this.$container).text(theme.strings.soldOut),
           $(this.selectors.productForm, this.container).addClass(this.classes.variantSoldOut))
        : (this.$addToCart.attr("aria-disabled", !0).attr("aria-label", theme.strings.unavailable),
           $(this.selectors.addToCartText, this.$container).text(theme.strings.unavailable),
           $(this.selectors.productForm, this.container).addClass(this.classes.variantSoldOut));
      },
      _updateAvailability: function (e) {
        this._hideErrorMessage(), this._updateAddToCart(e), this._updateLiveRegion(e), this._updatePrice(e);
      },
      _updateMedia: function (e) {
        var t = e.variant.featured_media.id,
            i = this.settings.sectionId + "-" + t;
        this._switchMedia(i), this._setActiveThumbnail(i);
      },
      _updatePrice: function (e) {
        var t = e.variant,
            i = $(this.selectors.priceContainer, this.$container),
            s = $(this.selectors.regularPrice, i),
            a = $(this.selectors.salePrice, i),
            r = $(this.selectors.unitPrice, i),
            n = $(this.selectors.unitPriceBaseUnit, i);
        if (
          (i.removeClass(this.classes.productUnavailable).removeClass(this.classes.productOnSale).removeClass(this.classes.productUnitAvailable).removeClass(this.classes.productSoldOut).removeAttr("aria-hidden"),
           this.$productPolicies.removeClass(this.classes.visibilityHidden),
           !t)
        )
          return i.addClass(this.classes.productUnavailable).attr("aria-hidden", !0), void this.$productPolicies.addClass(this.classes.visibilityHidden);
        t.available || i.addClass(this.classes.productSoldOut),
          t.compare_at_price > t.price
        ? (s.html(theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat)), a.html(theme.Currency.formatMoney(t.price, theme.moneyFormat)), i.addClass(this.classes.productOnSale))
        : s.html(theme.Currency.formatMoney(t.price, theme.moneyFormat)),
          t.unit_price && (r.html(theme.Currency.formatMoney(t.unit_price, theme.moneyFormat)), n.html(this._getBaseUnit(t)), i.addClass(this.classes.productUnitAvailable));
      },
      _getBaseUnit: function (e) {
        return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
      },
      _updateSKU: function (e) {
        var t = e.variant;
        $(this.selectors.SKU).html(t.sku);
      },
      onUnload: function () {
        this.$container.off(this.settings.namespace), theme.ProductVideo.removeSectionVideos(this.settings.sectionId), theme.ProductModel.removeSectionModels(this.settings.sectionId);
      },
    })),
    e
  );
})()),
  (theme.ProductRecommendations = function (e) {
  this.$container = $(e);
  var t = this.$container.data("baseUrl") + "?section_id=product-recommendations&product_id=" + this.$container.data("productId") + "&limit=4";
  $.get(t).then(
    function (e) {
      var t = $(e).html();
      "" !== t.trim() && this.$container.html(t);
    }.bind(this)
  );
}),
  (theme.Quotes = (function () {
  var o = { mediaQuerySmall: "screen and (max-width: 749px)", mediaQueryMediumUp: "screen and (min-width: 750px)", slideCount: 0 },
      c = { accessibility: !0, arrows: !1, dots: !0, autoplay: !1, touchThreshold: 20, slidesToShow: 3, slidesToScroll: 3 };
  function e(e) {
    var t = (this.$container = $(e)).attr("data-section-id"),
        i = ((this.wrapper = ".quotes-wrapper"), (this.slider = "#Quotes-" + t)),
        s = $(i, ".quotes-wrapper"),
        a = !1,
        r = $.extend({}, c, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: !0 });
    function n(e, t) {
      a && (e.slick("unslick"), (a = !1)), e.slick(t), (a = !0);
    }
    (o.slideCount = s.data("count")),
      o.slideCount < c.slidesToShow && ((c.slidesToShow = o.slideCount), (c.slidesToScroll = o.slideCount)),
      s.on("init", this.a11y.bind(this)),
      enquire.register(o.mediaQuerySmall, {
      match: function () {
        n(s, r);
      },
    }),
      enquire.register(o.mediaQueryMediumUp, {
      match: function () {
        n(s, c);
      },
    });
  }
  return (
    (e.prototype = _.assignIn({}, e.prototype, {
      onUnload: function () {
        enquire.unregister(o.mediaQuerySmall), enquire.unregister(o.mediaQueryMediumUp), $(this.slider, this.wrapper).slick("unslick");
      },
      onBlockSelect: function (e) {
        var t = $(".quotes-slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
        $(this.slider, this.wrapper).slick("slickGoTo", t);
      },
      a11y: function (e, t) {
        var i = t.$list,
            s = $(this.wrapper, this.$container);
        i.removeAttr("aria-live"),
          s.on("focusin", function (e) {
          s.has(e.target).length && i.attr("aria-live", "polite");
        }),
          s.on("focusout", function (e) {
          s.has(e.target).length && i.removeAttr("aria-live");
        });
      },
    })),
    e
  );
})()),
  (theme.slideshows = {}),
  (theme.SlideshowSection = function (e) {
  var t = (this.$container = $(e)).attr("data-section-id"),
      i = (this.slideshow = "#Slideshow-" + t);
  theme.slideshows[i] = new theme.Slideshow(i, t);
}),
  (theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function () {
    delete theme.slideshows[this.slideshow];
  },
  onBlockSelect: function (e) {
    var t = $(this.slideshow);
    t.data("adapt-height") && theme.slideshows[this.slideshow].setSlideshowHeight();
    var i = $(".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
    t.slick("slickGoTo", i).slick("slickPause");
  },
  onBlockDeselect: function () {
    $(this.slideshow).slick("slickPlay");
  },
})),
  (theme.slideshows = {}),
  (theme.VideoSection = function (e) {
  var t = (this.$container = $(e));
  $(".video", t).each(function () {
    var e = $(this);
    theme.Video.init(e), theme.Video.editorLoadVideo(e.attr("id"));
  });
}),
  (theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onUnload: function () {
    theme.Video.removeEvents();
  },
})),
  (theme.heros = {}),
  (theme.HeroSection = function (e) {
  var t = (this.$container = $(e)).attr("data-section-id"),
      i = "#Hero-" + t;
  theme.heros[i] = new theme.Hero(i, t);
}),
  (window.theme = window.theme || {});
var selectors = { disclosureLocale: "[data-disclosure-locale]", disclosureCurrency: "[data-disclosure-currency]" };
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos(), theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}
(theme.FooterSection = (function () {
  function e(e) {
    (this.$container = $(e)),
      (this.cache = {}),
      this.cacheSelectors(),
      this.cache.$localeDisclosure.length && (this.localeDisclosure = new theme.Disclosure(this.cache.$localeDisclosure)),
      this.cache.$currencyDisclosure.length && (this.currencyDisclosure = new theme.Disclosure(this.cache.$currencyDisclosure));
  }
  return (
    (e.prototype = _.assignIn({}, e.prototype, {
      cacheSelectors: function () {
        this.cache = { $localeDisclosure: this.$container.find(selectors.disclosureLocale), $currencyDisclosure: this.$container.find(selectors.disclosureCurrency) };
      },
      onUnload: function () {
        this.cache.$localeDisclosure.length && this.localeDisclosure.unload(), this.cache.$currencyDisclosure.length && this.currencyDisclosure.unload();
      },
    })),
    e
  );
})()),
  $(document).ready(function () {
  var e = new theme.Sections();
  e.register("cart-template", theme.Cart),
    e.register("product", theme.Product),
    e.register("collection-template", theme.Filters),
    e.register("product-template", theme.Product),
    e.register("header-section", theme.HeaderSection),
    e.register("map", theme.Maps),
    e.register("slideshow-section", theme.SlideshowSection),
    e.register("video-section", theme.VideoSection),
    e.register("quotes", theme.Quotes),
    e.register("hero-section", theme.HeroSection),
    e.register("product-recommendations", theme.ProductRecommendations),
    e.register("footer-section", theme.FooterSection);
}),
  (theme.init = function () {
  theme.customerTemplates.init();
  slate.rte.wrapTable({ $tables: $(".rte table,.custom__item-inner--html table"), tableWrapperClass: "scrollable-wrapper" });
  slate.rte.wrapIframe({
    $iframes: $('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"],.custom__item-inner--html iframe[src*="youtube.com/embed"],.custom__item-inner--html iframe[src*="player.vimeo"]'),
    iframeWrapperClass: "video-wrapper",
  }),
    slate.a11y.pageLinkFocus($(window.location.hash)),
    $(".in-page-link").on("click", function (e) {
    slate.a11y.pageLinkFocus($(e.currentTarget.hash));
  }),
    $('a[href="#"]').on("click", function (e) {
    e.preventDefault();
  }),
    slate.a11y.accessibleLinks({
    messages: { newWindow: theme.strings.newWindow, external: theme.strings.external, newWindowExternal: theme.strings.newWindowExternal },
    $links: $("a[href]:not([aria-describedby], .product-single__thumbnail)"),
  }),
    theme.FormStatus.init();
  var r = "[data-image]",
      n = "[data-image-placeholder]",
      o = "[data-image-with-placeholder-wrapper]",
      c = ".lazyloaded",
      l = "hide";
  $(document).on("lazyloaded", function (e) {
    var t,
        i,
        s,
        a = $(e.target);
    !a.data("bgset") || ((t = a.find(c)).length && ((i = a.data("alt")), (s = t.data("src") ? t.data("src") : a.data("bg")), t.attr("alt", i || ""), t.attr("src", s || ""))), a.is(r) && a.closest(o).find(n).addClass(l);
  }),
    $(r + ".lazyloaded")
  .closest(o)
  .find(n)
  .addClass(l),
    $(document).one("touchstart", function () {
    theme.Helpers.setTouch();
  });
}),
  $(theme.init);
